import { useState, useRef, useEffect, useCallback } from 'react'
import Immutable, { isImmutable, Map, List, fromJS } from 'immutable'
import _ from 'lodash'
// import { getChannelState, getChannelDispatch } from 'x/modules/channels/BaseChannelConnect'

//
//
import dayjs, { Dayjs } from 'dayjs'
import moment, { Moment } from 'moment'
// import { Moment } from 'moment'
// @ts-ignore
// import SETTINGS from '../config/settings'
// MUST (and just) require as it's a .tz() plugin for moment
import { detailedDiff } from 'deep-object-diff'
import * as MarketplaceChannelActions from 'x/modules/marketplaceChannel/marketplaceChannelState'
import momentTz from 'moment-timezone'

// import 'moment-timezone/builds/moment-timezone-with-data-2012-2022';

// import AUTOCONS from '../../../src/config/autoupdateConstants'
import { Clipboard, Platform } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import {
  IMkpProductDetail,
  IProductDetailItem,
  HelperPermissionType,
  IPaymentAccount,
  IXSellyErrorResponse,
  IOrdersFilter,
  IFetchOrdersRequestBody,
  IXScreenProps,
} from 'x/types'
import SETTINGS from 'x/config/settings'
import { FLAVOUR_CONFIG } from 'x/config/app/generated-runtime-app-config'
import { setConfiguration } from 'x/utils/configuration'
import { IXShippingConfig } from 'x/config/app'
import api from './api'
import { COLORS } from '../config/styles'
import { MODE, PROD_TEST, CONSOLE_LOG, APP_CONFIG } from '../config/mode'
import p from '../config/platform-specific'
import {
  IDiffTimeTilNowProps,
  IXSellyError,
  IVolumeDiscountMap,
  IBackgroundJobListResponse,
  BackgroundJobTypeType,
  ISelectedStoreMap,
  IWarehousesDetailMap,
  IOrderMap,
  ISummaryItem,
  IOrderSummary,
  IMap,
  ISelectedAddresses,
  PrintOptionKey,
  PresentModeKey,
  IMKPChannelDetail,
  IProductItemData,
  UserGroupMap,
  IProductItemVariantData,
  ImmutableObject,
  IAddress,
  IBgSyncStatusManager,
  IApiOptions,
  IAnyObject,
  IShippingType,
  IOrder,
  IOrderListItem,
  IXDateRangeSelectorOptionKey,
  IDateRange,
  IOrderErpChannels,
  IQuickAddress,
  SubscriptionPackageListItems,
  IGenericAddress,
  ISubscriptionPackageList,
  IProductListFilterState,
  IProductListFilterTemplate,
  IProductListFilterOptions,
  IProfile,
  ICategory,
  IProductListFilterPreference,
  IOrderListFilterPreference,
  IStockFilterQtyUpdatedAtOptionKey,
} from '../index'
import * as NavActions from './navigation'
import * as acl from './acl'
import {
  getStoreSelected,
  getMyStores,
  getSellerStores,
  getSelectedStore,
  getLoadingInProgress,
  getSubscription,
  getSelectedProduct,
  getSelectedStoreProductGroups,
  getSelectedStoreWarehouses,
  getXShippingConfigFromRedux,
  getMyProfile,
  getSelectedStoreOrdersDates as getSelectedStoreOrdersDatesSelector,
  getSelectedStoreOrdersDatesOptionKey as getSelectedStoreOrdersDatesOptionKeySelector,
} from '../redux/selectors'
import settings from '../config/settings'
import * as fmt from './formatter'
import CONS from '../config/constants'

// import { NavigationRoute, NavigationState, NavigationDispatch } from 'react-navigation'

type NavigationRoute = any
type NavigationState = any
type NavigationDispatch = any

const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const REGEX_PASSWORD = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z~*-@!.#$%^&*()-_+={}|\\/,'"]{8,}$/
const REGEX_NUMBER_ONLY = /^[0-9]*$/

// const REGEX_USERNAME = /^[a-z0-9._]*$/
const REGEX_USERNAME = /^(?![_.])(?!.*[_.]{2})[a-z0-9._]+$/

// let isNative = false
// try {
//   require.resolve('react-native')
//   isNative = true
// } catch (e) {
//   isNative = false
// }

// let moment
// if (isNative) {
//   try {
//     moment = require('moment')
//     if ('default' in moment) {
//       moment = moment.default
//     }
//     require('moment/locale/th')
//     require('moment-timezone')
//   } catch (e) {
//     // Nothing
//     // console.log('ERROR require moment for native')
//   }
// } else {
//   moment = momentForWeb
// }
// // console.log('isNative => ', isNative)
// // MUST import moment-timezone right after moment
// moment.locale('en')
// console.log('Load moment locale to English !!! => ', moment(1316116057189).fromNow())
// moment.locale('th')
// console.log('Load moment locale to Thai !!! => ', moment(1316116057189).fromNow())

const NAVIGATOR_STATE = 'navigatorState'
const ROUTES = 'routes'
const INDEX = 'index'
// const isIOS = Platform.OS === 'ios'

// ======== Order ==========
export const getOrderListTabScreenName = (mainTabName, subTabName) => mainTabName + CONS.ORDER_TAB_KEY_SEP + subTabName

/**
 * Returns an array of string where the first index is mainTabName
 * and the 2nd index is subTabName
 * @param {*} orderListTabScreenName For example, myTasks_confirmOrder
 */
export const getOrderListMainTabFromScreenNames = (orderListTabScreenName) => {
  const names = orderListTabScreenName.split(CONS.ORDER_TAB_KEY_SEP)
  if (names && names.length === 2) {
    return names
  }
  return [orderListTabScreenName, 'ERROR: NOT A ORDER LIST TAB NAME']
}

// ========== Store =========
export const canSelectedStoreAutoCalcShippingRateBy = (measure) => {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const {
    AUTO_CALC_SHIPPING_COST,
    SHIPPING_CALC_MODE,
    SHIPPING_CALC_MODE_QTY,
    SHIPPING_CALC_MODE_WEIGHT,
    SHIPPING_CALC_MODE_QTY_AND_WEIGHT,
    CALC_SHIPPING_MEASURE_QTY,
    CALC_SHIPPING_MEASURE_WEIGHT,
  } = CONS.STORE_SETTINGS
  if (
    !selectedStore ||
    !selectedStore.has(AUTO_CALC_SHIPPING_COST) ||
    !selectedStore.get(AUTO_CALC_SHIPPING_COST) ||
    !selectedStore.has(SHIPPING_CALC_MODE)
  ) {
    return false
  }
  const calcMode = selectedStore.get(SHIPPING_CALC_MODE)
  if (measure === CALC_SHIPPING_MEASURE_QTY && (calcMode === SHIPPING_CALC_MODE_QTY || calcMode === SHIPPING_CALC_MODE_QTY_AND_WEIGHT)) {
    return true
  }
  if (
    measure === CALC_SHIPPING_MEASURE_WEIGHT &&
    (calcMode === SHIPPING_CALC_MODE_WEIGHT || calcMode === SHIPPING_CALC_MODE_QTY_AND_WEIGHT)
  ) {
    return true
  }
  return false
}

export function isAlreadySelectedStore(): boolean {
  const selectedStore = getSelectedStore(p.op.getAppState())
  if (!selectedStore || !Map.isMap(selectedStore) || !selectedStore.get('id')) {
    return false
  }
  return true
}

// TODO: Keng remove this method when backend support subsciption model
// export function isSubscribedStore(storeId) {
//     if (!storeId) {
//         return false
//     }
//     const storeIdInt = parseInt(storeId)
//     let result = storeIdInt <= 7 || storeIdInt === 88
//     if (!result) {
//         let { CALC_SHIPPING_MEASURE_QTY, CALC_SHIPPING_MEASURE_WEIGHT } = CONS.STORE_SETTINGS
//         result = canSelectedStoreAutoCalcShippingRateBy(CALC_SHIPPING_MEASURE_QTY) || canSelectedStoreAutoCalcShippingRateBy(CALC_SHIPPING_MEASURE_WEIGHT)
//     }
//     return result
// }

// ============ General =============
/**
 * console.log message if __DEV__ is true. Support at most 4 params
 * @param {*} msg1
 * @param {*} msg2
 * @param {*} msg3
 * @param {*} msg4
 */
export const log = (msgOrThatObj: any, ...messages: any[]): void => {
  if (!CONSOLE_LOG) {
    return
  }
  try {
    if (_.isString(msgOrThatObj)) {
      // console.log(...[msgOrThatObj,...messages])
    } else if (typeof Object.getPrototypeOf(msgOrThatObj) === 'object') {
      const myClass = Object.getPrototypeOf(msgOrThatObj)
      const parentClass = Object.getPrototypeOf(Object.getPrototypeOf(msgOrThatObj))
      const hasParent = typeof parentClass === 'object'
      const parentName = hasParent ? parentClass.constructor.name : ''
      const myName = myClass.constructor.name
      const txtClassNames = hasParent ? `${parentName}::${myName}::` : `${myName}::`
      // console.log(...[txtClassNames,...messages])
    } else {
      // console.log(...messages)
    }
  } catch (e) {
    // console.log(e)
    // throw new Error('util log error.')
  }
}

// export const log = (msg1, msg2?, msg3?, msg4?) => {
//   // if (!__DEV__) {
//   // if (!__DEV__) {
//   //   return
//   // }
//   if (!CONSOLE_LOG) {
//     return
//   }
//   if (msg4) {
//     console.log(msg1, msg2, msg3, msg4)
//   } else if (msg3) {
//     console.log(msg1, msg2, msg3)
//   } else if (msg2) {
//     console.log(msg1, msg2)
//   } else {
//     console.log(msg1)
//   }
// }

export const logRender = (obj: any) => {
  if (!CONSOLE_LOG) {
    return
  }
  console.log(`${obj.constructor.name}.render()`)
}

export const logPrettyObj = (name = 'Name not provided', obj) => {
  // if (!__DEV__) {
  //   return
  // }
  if (!CONSOLE_LOG) {
    return
  }
  if (obj) {
    if (isImmutable(obj)) {
      // console.log(`${name}(ImmuObj): `, obj.toJS())
    } else {
      // console.log(`${name}(PlainJS): `, obj)
    }
  } else {
    // console.log(`${name}: + ${obj}`)
  }
}

export const assert = (condition, message) => {
  // if (!__DEV__) {
  //   return
  // }
  if (!CONSOLE_LOG) {
    return
  }
  if (!condition) {
    message = message || 'Assertion failed!!'
    if (typeof Error !== 'undefined') {
      // throw new Error(message)
      log(message)
    }
  }
}

export const getAllTimes = (serverTime) =>
  // TODO: Fix the hardcode
  ({
    server_time: serverTime,
    local_last_updated_time: new Date(),
    diff_server_minus_local: -5000,
  })

// export function getErrorObjectFromErrorResponse(error) {
//   if (error && error.message) {
//     const errObj = JSON.parse(error.message)
//     if (errObj.error) {
//       return errObj.error
//     }
//   }
//   return null
// }

// TODO: Call to local function platform
export function showSuccessToast(txtSummary) {
  // console.log(txtSummary)
  p.op.showToast(txtSummary, 'success')
}

export function showWarningToast(txtSummary) {
  // console.log(txtSummary)
  p.op.showToast(txtSummary, 'warning')
}

export function aLogEvent(txtSummary) {
  // console.log(txtSummary)
}

export function validateInputCurrency(text) {
  let newText = text ? text.toString() : ''
  newText = newText.replace(/฿/g, '')
  newText = newText.replace(/,/g, '')
  // newText = parseFloat(newText).toString()
  if (newText.match(/^(\d*)$/)) {
    // ถ้าเป็น pure number  ให้ return ตัวเดิม
    if (newText.length > 1) {
      return parseFloat(newText).toString()
    }
    return newText
  }
  if (newText.match(/^(\d*\.|\d*\.?\d|\.\d)$/)) {
    // ถ้าเติม . ด้านหลัง ให้ return ตัวเดิม
    return newText
  }
  if (newText.match(/^(\d*\.?\d{3,}|\.\d{3,})$/)) {
    // ถ้าจุดทศนิยมเกิน 2 ให้ปัดเหลือสอง
    // let val = (Math.floor(100 * parseFloat(newText)) / 100).toFixed(2)
    const val = Math.floor(parseFloat(newText) * 100) / 100
    return val.toString()
  }
  if (newText.match(/^(\d*\.?\d{2}|\.\d{2})$/)) {
    // ถ้าตรง format ให้ parseFloat
    return parseFloat(newText).toString()
  }
  if (newText.match(/^(\d*\.?\d{0,1}|\.\d{0,1})$/)) {
    // ถ้าตรง format ให้ parseFloat
    return newText.toString()
  }
  return ''
}

export function validateInputInteger(text) {
  log('validateInteger :', text)
  let newText = text ? text.toString() : ''
  newText = newText.replace(/\./g, '')
  // newText = parseFloat(newText).toString()
  if (newText.match(/^(\d+)$/)) {
    // ถ้าเป็น pure number  ให้ return ตัวเดิม
    return parseInt(newText).toString()
  }
  return '0'
}

export function limitIntString(newValue: string | number, limit = 999): string {
  let value = newValue
  if (value > limit) {
    value = limit
  } else if (!value || value === '') {
    value = 0
  }
  return validateInputInteger(value)
}

export function formatCurrency(amount: number): string {
  if (!amount || isNaN(amount)) {
    return '฿0'
  }
  let isNegativeNum = false
  if (amount < 0) {
    isNegativeNum = true
    amount *= -1 // convert to positive first
  }
  const amountStr = String(amount)
  let amountText = `฿${fmt.currencyFormatter.format(amount)}`
  const isEndedWithDot = amountStr.indexOf('.')
  // console.log('idx ' + isEndedWithDot + ' len: ' + amountStr.length)
  if (isEndedWithDot === amountStr.length - 1) {
    amountText += '.'
  }

  // interupt check ถ้ามีเคส .x ใดๆ ให้คงค่าหลังจุดไว้
  if (amountStr.match(/^(\d*\.\d|\.\d)$/)) {
    const amountArr: string[] = amountStr.split('.')
    amountText = `฿${fmt.currencyFormatter.format(parseFloat(amountArr[0]))}.${amountArr[1]}`
  }

  if (isNegativeNum) {
    amountText = `(${amountText})`
  }
  // console.log(amountText)
  return amountText
}

function _convertNumToTwoChars(num) {
  if (num > 9) {
    return num
  }
  return `0${num}`
}
export function getDiffTimeTilNow(theTime: string): IDiffTimeTilNowProps {
  // return {
  //   isOverDue: true,
  //   isAlmostDue: false,
  //   text: 'what'
  // }
  // var date1 = moment.tz('2017-06-21 12:00', 'Asia/Bangkok').toDate()
  const startTime = momentTz.tz(settings.app.timezone)
  // var endTime = moment.tz('2017-06-22 19:05', 'Asia/Bangkok')
  const endTime = momentTz(theTime)
  const d = {} as IDiffTimeTilNowProps
  if (!endTime.isValid()) {
    d.isOverDue = true
    d.isAlmostDue = false
    d.text = p.op.t('Order.invalidEndTime')
    // this.forceUpdate()
    return d
  }

  let diff = endTime.diff(startTime, 'second', false)
  if (diff < 0) {
    d.text = p.op.t('Order.overdue')
    d.isOverDue = true
    d.isAlmostDue = false
  } else {
    if (diff < CONS.TIMER_ALMOST_DUE_SECONDS) {
      d.isAlmostDue = true
      d.isOverDue = false
    }

    const diffHrs = Math.floor(diff / 3600)
    diff -= diffHrs * 3600 // substract the hours

    const diffMins = Math.floor(diff / 60)
    // diff -= diffMins * 60 // substract the minutes

    // diffText = this._format(diffHrs) + 'h' + this._format(diffMins) + 'm' + this._format(diff) + 's'
    d.text = `${_convertNumToTwoChars(diffHrs)}h${_convertNumToTwoChars(diffMins)}m`
  }

  return d
}

export const capitalizeFirstLetter = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1)

/**
 * Returns the user-translated error title and message based on provided error code.
 * Returns the default msgObj if the code does not exists in the translation file.
 *
 * @returns {*}
 * @param response
 * @param currentLocale
 */

// {
//   "error": {
//   "status_code": 400,
//     "error_code": "07_052",
//     "attach": {
//     "pp_name": "ขวดนม",
//       "store_name": "ร้านสอง",
//     },
//   }
// }
export function getErrMessageObj(
  // response: { error: IXSellyError },
  response: IXSellyErrorResponse,
  path?: string,
  currentLocale = 'th'
): { title: string; msg: string } | null {
  if (!response.error || _.isEmpty(response.error) || !_.isString(response.error.error_code)) {
    // ถ้าไม่มี error_code จะ ignore
    return null
  }

  // เรียก translation มาเป็น Object เพื่อมาใช้ compute ถ้าไม่มี ก็ ignore
  const transObj = p.op.getTranslatorObj(currentLocale)
  if (_.isEmpty(transObj) && transObj.e_specifics && transObj.e_generals && transObj.e_modules) {
    return null
  }

  // log ('path: ' + path)
  // FIXME: เดี๋ยวมา validate code นี้อีกทีว่ายังจำเป็นมั้ย
  const xErr: IXSellyError = response.error
  if (
    path === api.GET_REFRESH &&
    xErr &&
    xErr.status_code === 500 &&
    xErr.message &&
    xErr.message.startsWith('file_put_contents(/var/www/storage')
  ) {
    // ignore this error
    return null
  }

  // log('transObj => ', transObj)

  // สร้าง  Default Message ขึ้นมา เผื่อให้ User ช่วย Capture Response มาให้เราดู
  const resultErrorObj = {
    // title: p.op.t('e_title_generals', currentLocale),
    title: p.op.t('e_title_generals'),
    // Default error is parse Error to String Object for Unknown Error
    msg: JSON.stringify(response),
    // msg: p.op.t('e_msg_general', currentLocale),
  }

  try {
    // log('response => ', response)
    // log('error_code => ', error_code)
    // log('status_code => ', status_code)
    // log('error_code => ', eModuleKey)
    // log('status_code => ', eMessageKey)
    const fullErrrCodeKey = `_${xErr.error_code}`
    const splitErrCode = xErr.error_code.split('_')
    // log('splitErrCode => ', splitErrCode)

    // ถ้า Error Code ไม่แบ่งเป็นสองส่วนตาม Internal Format ให้ return Default Message ออกไป
    if (splitErrCode.length !== 2) {
      return resultErrorObj
    }

    const eModuleKey = `_${splitErrCode[0]}`
    const eMessageKey = `_${splitErrCode[1]}`
    log('eModuleKey => ', eModuleKey)
    log('eMessageKey => ', eMessageKey)
    // log('I18n current locale => ', I18n.locale)
    const { e_specifics, e_attach_specifics, e_generals, e_modules, e_title_customs } = transObj

    // find specific error
    if (!_.isEmpty(e_specifics) && _.has(e_specifics, eMessageKey)) {
      resultErrorObj.msg = e_specifics[eMessageKey]

      // find general error
    } else if (!_.isEmpty(e_generals) && _.has(e_generals, eMessageKey)) {
      resultErrorObj.msg = e_generals[eMessageKey]

      // find error's module
      if (_.has(e_modules, eModuleKey)) {
        // log('e_generals[eModuleKey] get => ', e_modules[eModuleKey])
        // resultErrorObj.msg = resultErrorObj.msg.replace(new RegExp('%{module}', 'gi'), e_generals[eModuleKey])
        resultErrorObj.msg = resultErrorObj.msg.replace(/%{module}/g, e_modules[eModuleKey])
      } else {
        resultErrorObj.title = transObj.e_title_critical ? transObj.e_title_critical : resultErrorObj.title
        // log('e_generals[eModuleKey] get => ', e_modules[eModuleKey])
        resultErrorObj.msg = resultErrorObj.msg.replace(/%{module}/g, e_modules[eModuleKey])
        resultErrorObj.msg = resultErrorObj.msg.replace(/%{module}/g, 'ระบบ')
      }
    }

    // ถ้ามี specific title
    log('fullErrrCodeKey => ', fullErrrCodeKey)
    if (!_.isEmpty(e_title_customs) && _.has(e_title_customs, fullErrrCodeKey)) {
      resultErrorObj.title = e_title_customs[fullErrrCodeKey]
      log('resultErrorObj.title  => ', resultErrorObj.title)
    }

    // override with attach special case if special and have attach
    if (
      !_.isEmpty(e_specifics) &&
      _.has(e_attach_specifics, eMessageKey) &&
      xErr.attach &&
      _.isObject(xErr.attach) &&
      !_.isEmpty(xErr.attach)
    ) {
      resultErrorObj.msg = e_attach_specifics[eMessageKey]
    }

    // ถ้ามี attach สำหรับแสดงข้อมูลเพิ่มเติม
    if (xErr.attach && _.isObject(xErr.attach) && !_.isEmpty(xErr.attach)) {
      const attachKeys = Object.keys(xErr.attach)

      for (const attachKey of attachKeys) {
        // for (let i = 0; i < attachKeys.length; i++) {
        //   // เช็คว่า attachKey เอาไปยัดใน message ได้รึเปล่า ถ้าได้ก็ยัด ถ้าไม่ได้ก็เมิน (replace by dynamic regex)
        //   const attachKey = attachKeys[i]
        const replaceByValue = xErr.attach[attachKey] ? xErr.attach[attachKey] : ''
        const attachRegEx = new RegExp(`%{${attachKey}}`, 'g')
        resultErrorObj.msg = resultErrorObj.msg.replace(attachRegEx, replaceByValue) // replace for display
      }

      // replace any %{...any...} with ''
      resultErrorObj.msg = resultErrorObj.msg.replace(/%{(.*?)}/g, '')
    }

    // FIXME: Implement in better pattern
    // Special Specific attach case
    // 07_056
    //  "attach": {
    //    "store": {
    //      "id": 1,
    //      "name": "ร้านเบอร์ 1"
    //    },
    //    "products": [
    //      {
    //        "pp_id": 3154,
    //        "name": "ยาดมโป๊ยก่าย (A)"
    //      }
    //    ]
    //   }
    if (_.includes(['_056', '_057'], eMessageKey) && xErr.attach && !_.isEmpty(xErr.attach)) {
      const { attach } = xErr
      let txtErrMessage = ''
      txtErrMessage = e_attach_specifics[eMessageKey]
      log('txtErrMessage => ', txtErrMessage)

      if (attach.store && attach.store.name) {
        txtErrMessage = txtErrMessage.replace(/%{store_name}/g, attach.store.name)
      }

      if (attach.products && attach.products.length > 0) {
        txtErrMessage += ' ทำให้รายการต่อไปนี้ ไม่สามารถใช้เปิดออเดอร์ได้'
        for (let i = 0; i < attach.products.length; i++) {
          const txtProductName = attach.products[i] && attach.products[i].name ? attach.products[i].name : null
          if (txtProductName) {
            txtErrMessage += `\n${i + 1}. ${txtProductName}`
          }
        }
      }

      resultErrorObj.msg = txtErrMessage
    }
  } catch (e) {
    log('Cannot parse error response => ', e)
    p.op.aLogEvent(CONS.ALOG.API_CANNOT_PARSE_ERROR, response)
  }

  // return Msg with Unknown Error Response
  p.op.aLogEvent(CONS.ALOG.API_ERROR, response)
  return resultErrorObj
}

// {
//   "error": {
//   "message": "422 Unprocessable Entity",
//     "errors": {
//     "store_product.0.products.0.qty": [
//       "The store_product.0.products.0.qty must be at least 1."
//     ],
//     "status_code": 422
//   },
//   "code": 422
// }
// Handle 422 message
export function getUnprocessableEntityMesssages(httpError): { title: string; msg: string } {
  const resultErrorObj = {
    title: p.op.t('e_title_generals'),
    msg: p.op.t('e_msg_general'),
  }
  const { code, error, message } = httpError
  if (error && error.errors && _.isObject(error.errors) && !_.isEmpty(error.errors) && code === 422) {
    let txtErrorMessage = ''
    const keys = Object.keys(error.errors)
    keys.forEach((errKey) => {
      txtErrorMessage += `${error.errors[errKey]}\n`
    })
    resultErrorObj.msg = txtErrorMessage
  }
  if (resultErrorObj.msg.replace(/ /g, '').indexOf('Theusernamehasalreadybeentaken.') > -1) {
    resultErrorObj.msg = 'กรุณาตั้งชื่อใหม่ เนื่องจากชื่อที่ระบุมีผู้อื่นใช้ไปแล้ว'
  }

  return resultErrorObj
}

export function alertUnprocessableEntity(errorMessageObj: any = {}, path: string): void {
  log('path => ', path)
  log('errorMessageObj => ', errorMessageObj)

  const errObj = typeof errorMessageObj === 'string' ? JSON.parse(errorMessageObj) : errorMessageObj
  let alertMessage = ''
  log('errObj => ', errObj)
  if (errObj && errObj.error) {
    if (parseInt(errObj.error.status_code) === 422 && errObj.error.errors) {
      const errorKeys = Object.keys(errObj.error.errors) || []

      for (const errorKey of errorKeys) {
        // handle specific api path and field
        if (path === api.PATCH_USERNAME && errorKey === 'username') {
          p.op.alert('ชื่อบัญชีผู้ใช้ถูกใช้ไปแล้ว', 'กรุณาระบุชื่อบัญชีผู้ใช้ใหม่')
          return
        }

        alertMessage += `${errObj.error.errors[errorKey][0]}\n` || ''
      }
    }
  }

  if (alertMessage.length > 0) {
    p.op.alert('เกิดข้อผิดพลาด', alertMessage)
  }
}

export const isDiff = (props1: any, props2: any, propNames: string[]): boolean => {
  // console.log('isDiff', props1, props2)
  if (!props1 || !props2 || !propNames) {
    // console.log('isDiff should NEVER HAPPEN')
    return props1 !== props2
  }
  for (const name of propNames) {
    // console.log('isDiff', props1[name],props2[name])
    if (props1[name] !== props2[name]) {
      return true
    }
  }
  return false
}

export const isDiffAccuracy = (props1: { [key: string]: any }, props2: { [key: string]: any }, propNames: string[]): boolean => {
  // console.log('isDiff', props1, props2)
  if (!props1 || !props2 || !propNames) {
    // console.log('isDiff should NEVER HAPPEN')
    return props1 !== props2
  }
  // let name
  for (const name of propNames) {
    // for (let i = 0; i < propNames.length; i++) {
    //   name = propNames[i]
    // console.log('isDiff', props1[name],props2[name])
    const hasProp1 = _.has(props1, name)
    const hasProp2 = _.has(props2, name)
    if (!hasProp1 && hasProp2) {
      return true
    }
    if (hasProp1 && !hasProp2) {
      return true
    }
    if (hasProp1 && hasProp2 && props1[name] !== props2[name]) {
      return true
    }
  }
  return false
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 * ref => https://gist.github.com/Yimiprod/7ee176597fef230d1451
 */
export function isDiffObject(testObj: { [key: string]: any }, baseObj: { [key: string]: any }): { [key: string]: any } {
  const changes = (tObj: { [key: string]: any }, bObj: { [key: string]: any }) =>
    _.transform(tObj, (result, value, key) => {
      if (!_.isEqual(value, bObj[key])) {
        result[key] = _.isObject(value) && _.isObject(bObj[key]) ? changes(value, bObj[key]) : value
      }
    })
  return changes(testObj, baseObj)
}

export function isDevMode(): boolean {
  return MODE === 'dev'
}

export function isProdTest(): boolean {
  return PROD_TEST
}

export function isDevOrProdTestMode(): boolean {
  return MODE === 'dev' || PROD_TEST
}

export function isOrderInCancelledState(orderState: number): boolean {
  return orderState >= 181 && orderState <= 184
}

export function isOrderInShippableState(orderState: number, shippingState: number): boolean {
  return !isOrderInCancelledState(orderState) && shippingState === 121
}

// ===================== Shipping Label ============================
/**
 *
 * @param startDate A moment date object (parsed from string)
 * @param endDate A moment date object (parsed from string)
 * @returns {string}
 */
export function getShippingLabelPDFFileNameByDates(startDate: Moment | null, endDate: Moment): string {
  let dateFormat = 'YYYYMMDDHHmmss'
  // log('getShippingLabelPDFFileNameByDates dateFormat => ', dateFormat)
  // log('getShippingLabelPDFFileNameByDates startDate => ', startDate)
  // log('getShippingLabelPDFFileNameByDates endDate => ', endDate)
  let fileName
  if (moment.isMoment(startDate)) {
    fileName = `${startDate.format(dateFormat)}-${endDate.format(dateFormat)}`
  } else {
    dateFormat = 'YYYYMMDD'
    const d = new Date()
    // QuickFix:: Because we cannot use moment (No idea why?)
    // d is "Sun Oct 13 2013 20:32:01 GMT+0530 (India Standard Time)"
    let currentTime = d.toTimeString()
    // datestring is "20:32:01 GMT+0530 (India Standard Time)"
    // Split with ' ' and we get: ["20:32:01", "GMT+0530", "(India", "Standard", "Time)"]
    // Take the first value from array :)
    currentTime = currentTime.split(' ')[0].replace(/:/g, '')
    fileName = endDate.format(dateFormat) + currentTime
  }
  // log('getShippingLabelPDFFileNameByDates fileName => ', fileName)
  return `${fileName}.pdf`
}

export function getShippingLabelPDFFileNameByOrder(orderName: string): string {
  return `${orderName}.pdf`
}

/**
 *
 * @param {any} store_id (Required)
 * @param {any} orders Array of orderId i.e. ['8011', '8013']
 * @param {any} only_not_printed
 * @param {any} limit
 * @param {any} startTime A moment date object (parsed from string)
 * @param {any} endTime A moment date object (parsed from string)
 * @returns {any}
 */
export function getShippingLabelPDFUrl({
  store_id,
  orders,
  only_not_printed,
  limit,
  startDate,
  endDate,
  isGoApi,
  paperang,
  sticker,
  activeShippingTypeIds,
}: any): string {
  if (!store_id) {
    // store_id is required
    return null
  }
  // let store_id = this.props.navigation.state.params.store_id
  // let only_not_printed = this.state.selectedOptionPrintFilter === OPTIONS_PRINT_FILTER[0] ? 1 : 0
  // let limit = this.state.selectedOptionOrderCount
  const pOnlyNotPrinted = only_not_printed ? `&only_not_printed=${only_not_printed}` : ''
  const pLimit = limit ? `&limit=${limit}` : ''
  let pTimePeriod = ''
  if (startDate && endDate) {
    let stime = changeSecondTime(startDate, 0)
    stime = changeMillisecondsTime(stime, 0)
    let etime = changeSecondTime(endDate, 59)
    etime = changeMillisecondsTime(etime, 999)
    const s = stime.format(CONS.PDF_URL_REQ_DATE_FORMAT)
    const e = etime.format(CONS.PDF_URL_REQ_DATE_FORMAT)
    pTimePeriod = `&startTime=${s}&endTime=${e}`
  }
  let pOrders = ''
  if (orders && orders.length > 0) {
    orders.map((orderId) => {
      pOrders += `&orders[]=${orderId}`
    })
  }
  const rootAPI = settings.app.GO_API_ROOT
  let url = `${rootAPI}/order/print?store_id=${store_id}${pOrders}${pOnlyNotPrinted}${pLimit}${pTimePeriod}`

  if (paperang) {
    url += '&ppr=true'
  } else if (sticker) {
    url += '&sticker=true'
  }
  if (activeShippingTypeIds) {
    activeShippingTypeIds.map((shippingId: number) => {
      url += `&shipping_type_ids[]=${shippingId}`
    })
  }
  // console.log('print url: ' + url)
  return url
}

/**
 *
 * @param {any} store_id (Required)
 * @param {any} orders Array of orderId i.e. ['8011', '8013']
 * @returns {any}
 */
export function getErpDocumentPDFUrl({ store_id, orders, erp_doc_types_not_in, erp_ch_id }: any): string {
  if (!store_id) {
    // store_id is required
    return null
  }

  let erpDocTypesNotIn = ''
  if (erp_doc_types_not_in && erp_doc_types_not_in.length > 0) {
    erp_doc_types_not_in.map((erpDocTypeId) => {
      erpDocTypesNotIn += `&erp_doc_types_not_in[]=${erpDocTypeId}`
    })
  }

  let pOrders = ''
  if (orders && orders.length > 0) {
    orders.map((orderId) => {
      pOrders += `&orders[]=${orderId}`
    })
  }
  const rootAPI = settings.app.GO_API_ROOT
  const url = `${rootAPI}/order/print?store_id=${store_id}&erp_ch_id=${erp_ch_id}${erpDocTypesNotIn}${pOrders}`

  // console.log('print url: ' + url)
  return url
}

interface IGetShippingLabelBillUrlParams {
  store_id: number
  printing_type: number
  size: number
  order_ids: number[]
}

export function getShippingLabelBillUrl(params: IGetShippingLabelBillUrlParams): string | null {
  const { printing_type, size, store_id, order_ids } = params
  if (!store_id) {
    // store_id is required
    return null
  }
  const rootAPI = settings.app.GO_API_ROOT

  let url = `${rootAPI}/print?pt=${printing_type}&z=${size}&s=${store_id}`

  if (order_ids && order_ids.length > 0) {
    order_ids.map((orderId) => {
      url += `&ids[]=${orderId}`
    })
    if (p.op.isWeb()) {
      url += `&pdf=1`
    }
  } else {
    return null
  }

  return url
}

/**
 *
 * @param {number} store_id (Required)
 * @param {string} startDate (Required) A moment date object (parsed to DD/MM/YYYY string format)
 * @param {string} endDate (Optional) A moment date object  (parsed to DD/MM/YYYY string format)
 * @returns {string||null}
 */

export function getReportShippingExcelUrl(params: {
  store_id: number
  startDate: string
  showDateTime?: boolean
  endDate?: string
  showProduct?: boolean
  showWeight?: boolean
  asReseller?: boolean
  showShippingType?: boolean
  showTotalAmount?: boolean
  showTotalQty?: boolean
  showHelperName?: boolean
}): string | null {
  const {
    store_id,
    startDate,
    endDate,
    showProduct,
    showWeight,
    asReseller,
    showDateTime,
    showShippingType,
    showTotalAmount,
    showTotalQty,
    showHelperName,
  } = params
  if (!store_id || !startDate) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.API_ROOT}/report/shipping?store_id=${store_id}&startDate=${startDate}`
  // let url = `http://alp.xselly.com/api/report/shipping?store_id=${store_id}&startDate=${startDate}`
  if (endDate) {
    url = `${url}&endDate=${endDate}`
  }
  if (showShippingType) {
    url = `${url}&showShippingType=1`
  }
  if (showTotalAmount) {
    url = `${url}&showTotalAmount=1`
  }
  if (showTotalQty) {
    url = `${url}&showTotalQty=1`
  }
  if (showProduct) {
    url = `${url}&showProduct=true`
  }
  if (showWeight) {
    url = `${url}&showWeight=true`
  }
  if (showDateTime) {
    url = `${url}&showDateTime=true`
  }
  if (showHelperName) {
    url = `${url}&showHelperName=true`
  }
  if (asReseller) {
    url = `${url}&asReseller=1`
  }
  // log('print url: ' + url)
  // console.log('download shipping url => ', url)
  return url
}

export function getCompleteSalesReportViewExcelUrl(params: {
  store_id: number
  // created_at_from: string
  // created_at_to: string
  // completed_at_from: string
  // completed_at_to: string
  // payment_states: number
  // shipping_states: number
  // all_shipped_at_from: string
  // all_shipped_at_to: string
}): string | null {
  const {
    store_id,
    // created_at_from,
    // created_at_to,
    // completed_at_from,
    // completed_at_to,
    // payment_states,
    // shipping_states,
    // all_shipped_at_from,
    // all_shipped_at_to,
  } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  const url = `${settings.app.API_ROOT}/report/completesales?store_id=${store_id}`
  // if (created_at_from != null) {
  //   url = `${url}&created_at_from=${created_at_from}`
  // }
  // if (created_at_to != null) {
  //   url = `${url}&created_at_to=${created_at_to}`
  // }
  // if (completed_at_from != null) {
  //   url = `${url}&completed_at_from=${completed_at_from}`
  // }
  // if (completed_at_to != null) {
  //   url = `${url}&completed_at_to=${completed_at_to}`
  // }
  // if (!_.isNull(all_shipped_at_from)) {
  //   url = `${url}&all_shipped_at_from=${all_shipped_at_from}`
  // }
  // if (!_.isNull(all_shipped_at_to)) {
  //   url = `${url}&all_shipped_at_to=${all_shipped_at_to}`
  //   url = `${url}&shipping_states[]=129`
  // } else {
  //   if (payment_states === null || payment_states === 0) {
  //     url = `${url}&payment_states[]=119`
  //   } else if (payment_states === 1) {
  //     url = `${url}&payment_states[]=111&payment_states[]=112&payment_states[]=113&payment_states[]=114&payment_states[]=115`
  //   } else {
  //     url = `${url}&payment_states[]=119&payment_states[]=111&payment_states[]=112&payment_states[]=113&payment_states[]=114&payment_states[]=115`
  //   }
  //   if (shipping_states === null || shipping_states === 0) {
  //     url = `${url}&shipping_states[]=129`
  //   } else if (shipping_states === 1) {
  //     url = `${url}&shipping_states[]=121&shipping_states[]=122`
  //   } else {
  //     url = `${url}&shipping_states[]=129&shipping_states[]=121&shipping_states[]=122`
  //   }
  // }

  // log('print url: ' + url)
  // console.log('download shipping url => ', url)
  return url
}

export function getReportRequisitionExcelUrl(params: {
  store_id: number
  showTotalCost: boolean
  listReadyToShipOrders?: boolean
  listConfirmedToRefundOrders?: boolean
  showCost?: boolean
  isFlashExpress?: boolean
  isKerryExpress?: boolean
  isKerryExpress2?: boolean
  startDateTime: string
  endDateTime: string
  shippingTypeIds: string
}): string | null {
  const {
    store_id,
    listReadyToShipOrders,
    listConfirmedToRefundOrders,
    showCost,
    showTotalCost,
    isFlashExpress = false,
    isKerryExpress = false,
    isKerryExpress2 = false,
    startDateTime,
    endDateTime,
    shippingTypeIds = null,
  } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.API_ROOT}/report/requisition?store_id=${store_id}`
  // let url = `http://alp.xselly.com/api/report/shipping?store_id=${store_id}&startDate=${startDate}`
  // if (endDate) {
  //   url = `${url}&endDate=${endDate}`
  // }
  if (listReadyToShipOrders) {
    url = `${url}&listReadyToShipOrders=1`
  }
  if (listConfirmedToRefundOrders) {
    url = `${url}&listConfirmedToRefundOrders=1`
  }
  if (showCost) {
    url = `${url}&showCost=1`
  }
  if (showTotalCost) {
    url = `${url}&showCost=1`
  }
  if (isFlashExpress) {
    url = `${url}&isFlashExpress=1`
  }
  if (isKerryExpress) {
    url = `${url}&isKerryExpress=1`
  }
  if (isKerryExpress2) {
    url = `${url}&isKerryExpress2=1`
  }
  if (!_.isNil(startDateTime)) {
    url = `${url}&start_date_time=${startDateTime}`
  }
  if (!_.isNil(endDateTime)) {
    url = `${url}&end_date_time=${endDateTime}`
  }
  if (!_.isNil(shippingTypeIds)) {
    url = `${url}&${shippingTypeIds}`
  }
  log(`print url: ${url}`)
  // console.log('download shipping url => ', url)
  return url
}

export function getReportOwnerCountResellersExcelUrl(params: { org_id: number }): string | null {
  const { org_id } = params
  if (!org_id) {
    // org_id required
    return null
  }
  const url = `${settings.app.GO_API_ROOT}/org/report/all_resellers_count_of_each_dealers?org_id=${org_id}`
  log(`print url: ${url}`)
  // console.log('download url => ', url)
  return url
}

export function getReportResellerExcelUrl(params: {
  store_id: number
  resultReportType: string
  startDate: string
  endDate: string
  daysInPast: string
}): string | null {
  const { store_id, startDate, endDate, resultReportType, daysInPast } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.API_ROOT}/report/dailysalesbyreseller?store_id=${store_id}`
  // let url = `http://alp.xselly.com/api/report/shipping?store_id=${store_id}&startDate=${startDate}`
  if (resultReportType) {
    url = `${url}&exportExcel=${resultReportType}`
  }
  if (daysInPast) {
    url = `${url}&daysInPast=${daysInPast}`
  }
  if (startDate !== '') {
    url = `${url}&startDate=${startDate}`
  }
  if (endDate !== '') {
    url = `${url}&endDate=${endDate}`
  }
  log(`print url: ${url}`)
  // console.log('download shipping url => ', url)
  return url
}

export function getReportSalesByChannelExcelUrl(params: {
  store_id: number
  exportExcel?: 1 | 2
  startDate?: string
  endDate?: string
  daysInPast?: number
}): string | null {
  const { store_id, startDate, endDate, exportExcel, daysInPast } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.API_ROOT}/report/dailysalesbychannel?store_id=${store_id}`
  // let url = `http://alp.xselly.com/api/report/shipping?store_id=${store_id}&startDate=${startDate}`
  if (exportExcel) {
    url = `${url}&exportExcel=${exportExcel}`
  }
  if (daysInPast) {
    url = `${url}&daysInPast=${daysInPast}`
  }
  if (_.isString(startDate) && startDate.length !== 0) {
    url = `${url}&startDate=${startDate}`
  }
  if (_.isString(endDate) && endDate.length !== 0) {
    url = `${url}&endDate=${endDate}`
  }
  log(`print url: ${url}`)
  // console.log('download shipping url => ', url)
  return url
}

export function getHistorysReportViewExcelUrl(params: {
  store_id: number
  startDate: string
  endDate: string
  pp_id: number
}): string | null {
  const { store_id, startDate, endDate, pp_id } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }

  const rootAPI = settings.app.GO_API_ROOT

  const url = `${rootAPI}/report/product_history?store_id=${store_id}&startDate=${startDate}&endDate=${endDate}&pp_id=${pp_id}`

  // log('print url: ' + url)
  // console.log('download shipping url => ', url)
  return url
}

export function getReportProductDailySalesExcelUrl(params: {
  store_id: number | string
  completed_at_from?: string
  completed_at_to?: string
  created_at_from?: string
  created_at_to?: string
  pp_ids: number[]
  showUPC: boolean
  showSKU: boolean
  showCategory: boolean
  showPrice: boolean
  showProfit: boolean
  showOrderIDS: boolean
  channel_ids?: number[]
  created_by_role: string
  created_by_profile_id: number
  segmentOrderOriginIndex: number
  mkp_ids: number[]
}): string | null {
  const {
    store_id,
    completed_at_from = null,
    completed_at_to = null,
    created_at_from = null,
    created_at_to = null,
    pp_ids = null,
    showUPC,
    showSKU,
    showCategory,
    showPrice,
    showProfit,
    showOrderIDS,
    channel_ids,
    created_by_role,
    created_by_profile_id,
    mkp_ids = null,
    segmentOrderOriginIndex = 0,
  } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  // https://superdevgo.xselly.com/api/report/product_daily_sales?store_id=3&created_at_with_time_from=2021-06-29%2012:37:00&created_at_with_time_to=2021-06-29%2012:37:00&channel_id=6
  const rootAPI = settings.app.GO_API_ROOT

  let url = `${rootAPI}/report/product_daily_sales?store_id=${store_id}`
  if (!_.isNil(completed_at_from)) {
    url += `&completed_at_with_time_from=${completed_at_from}`
  }
  if (!_.isNil(completed_at_to)) {
    url += `&completed_at_with_time_to=${completed_at_to}`
  }
  if (!_.isNil(created_at_from)) {
    url += `&created_at_with_time_from=${created_at_from}`
  }
  if (!_.isNil(created_at_to)) {
    url += `&created_at_with_time_to=${created_at_to}`
  }
  if (pp_ids.length > 0) {
    pp_ids.map((data) => {
      url += `&pp_ids=${data}`
    })
  }
  if (showUPC) {
    url += `&showUPC=${showUPC}`
  }
  if (showSKU) {
    url += `&showSKU=${showSKU}`
  }
  if (showCategory) {
    url += `&showCategory=${showCategory}`
  }
  if (showPrice) {
    url += `&showPrice=${showPrice}`
  }
  if (showProfit) {
    url += `&showProfit=${showProfit}`
  }
  if (showOrderIDS) {
    url += `&showOrderIDS=${showOrderIDS}`
  }
  if (!_.isNil(channel_ids)) {
    channel_ids.map((data) => {
      url += `&channel_ids=${data}`
    })
    // url += `&channel_ids=${channel_ids}`
  }
  if (!_.isNil(created_by_role)) {
    url += `&created_by_role=${created_by_role}`
  }
  if (!_.isNil(created_by_profile_id)) {
    url += `&created_by_profile_id=${created_by_profile_id}`
  }

  if (segmentOrderOriginIndex === 1) {
    url += `&order_origin=xselly_only`
  }
  if (segmentOrderOriginIndex === 2) {
    url += `&order_origin=mkp_only`
    if (!_.isNil(mkp_ids)) {
      mkp_ids.forEach((mkpid) => {
        url += `&mkp_ch_ids=${mkpid}`
      })
    }
  }
  // console.log('download shipping url => ', url)
  return url
}

export function getReportPaymentExcelUrl(params: {
  store_id: number | string
  startDate: string
  endDate: string
  accounts: number[]
}): string | null {
  const { store_id, startDate, endDate, accounts } = params
  if (!store_id || !startDate) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.GO_API_ROOT}/report/payment_statement?store_id=${store_id}&startDate=${startDate}&endDate=${endDate}&payment_account_ids=`
  let i = 0
  accounts.map((id: number) => {
    if (i > 0) {
      url += `,${id}`
    } else {
      url += `${id}`
    }
    i += 1
  })
  // console.log('download shipping url => ', url)
  return url
}

export function getHelperSalesReportExcelUrl(params: {
  store_id: number | string
  startDate: string
  endDate: string
  dateType: string
  helper_profile_id: number
  channel_id: number
}): string | null {
  const { store_id, startDate, endDate, dateType, helper_profile_id, channel_id } = params
  if (!store_id || !startDate) {
    // store_id and startDate are required
    return null
  }
  let url = `${settings.app.GO_API_ROOT}/report/helper_sales?store_id=${store_id}&start_datetime=${startDate}&end_datetime=${endDate}&date_type=${dateType}`

  if (!_.isNil(channel_id)) {
    url += `&channel_id=${channel_id}`
  }
  if (!_.isNil(helper_profile_id)) {
    url += `&helper_profile_id=${helper_profile_id}`
  }
  // console.log('download REPORT url => ', url)
  return url
}

/**
 *
 * @param {number} store_id (Required)
 * @returns {string||null}
 */

export function getReportStockExcelUrl(params: {
  store_id: number
  sku: boolean
  upc: boolean
  desc: boolean
  prices: boolean
  category: boolean
  combineProductVariantName: boolean
  productBundle: boolean
}): string | null {
  const { store_id, sku, upc, desc, prices, category, combineProductVariantName, productBundle } = params
  return store_id
    ? `${settings.app.GO_API_ROOT}/report/stock?store_id=${store_id}&showSKU=${sku}&showUPC=${upc}&showDesc=${desc}&showPrices=${prices}&showCategory=${category}&combineProductVariantName=${combineProductVariantName}&showProductBundle=${productBundle}`
    : null
}

export function getReportWarehouseAdjustmentUrl(params: {
  store_id: number
  warehouse_ids: number[]
  created_at_from: string
  created_at_to: string
  // action_type: string
  created_by_hepler_profile_ids: number[]
  showSKU: boolean
  showUPC: boolean
  created_by_role: string

  add_return: boolean
  add_purchase: boolean
  add_deposit: boolean
  add_cancel_shipping: boolean
  add_not_specified: boolean
  add_others: boolean

  deduct_damange: boolean
  deduct_lost: boolean
  deduct_withdraw: boolean
  deduct_create_shipping: boolean
  deduct_not_specified: boolean
  deduct_others: boolean

  set: boolean
  count: boolean
}): string | null {
  const {
    store_id,
    warehouse_ids,
    created_at_from,
    created_at_to,
    // action_type,
    created_by_hepler_profile_ids,
    showSKU,
    showUPC,
    created_by_role,
    add_return,
    add_purchase,
    add_cancel_shipping,
    add_deposit,
    add_not_specified,
    add_others,

    count,
    set,
    deduct_damange,
    deduct_lost,
    deduct_withdraw,
    deduct_create_shipping,
    deduct_not_specified,
    deduct_others,
  } = params

  let url = `${settings.app.GO_API_ROOT}/report/stock_history?store_id=${store_id}&created_at_from=${created_at_from}&created_at_to=${created_at_to}`

  if (warehouse_ids && warehouse_ids.length > 0) {
    warehouse_ids.forEach((warehouseId) => {
      url += `&warehouse_ids=${warehouseId}`
    })
  }

  if (!_.isNil(created_by_hepler_profile_ids)) {
    url += `&created_by_hepler_profile_ids=${created_by_hepler_profile_ids}`
  }
  if (showSKU) {
    url += `&showSKU=${showSKU}`
  }
  if (showUPC) {
    url += `&showUPC=${showUPC}`
  }
  if (count) {
    url += `&adjust_reasons=count`
  }
  if (set) {
    url += `&adjust_reasons=set`
  }
  if (add_return) {
    url += `&adjust_reasons=add_return`
  }
  if (add_purchase) {
    url += `&adjust_reasons=add_purchase`
  }
  if (add_cancel_shipping) {
    url += `&adjust_reasons=add_cancel_shipping`
  }
  if (add_deposit) {
    url += `&adjust_reasons=add_deposit`
  }
  if (add_not_specified) {
    url += `&adjust_reasons=add_not_specified`
  }
  if (add_others) {
    url += `&adjust_reasons=add_others`
  }
  if (deduct_damange) {
    url += `&adjust_reasons=deduct_damange`
  }
  if (deduct_lost) {
    url += `&adjust_reasons=deduct_lost`
  }
  if (deduct_withdraw) {
    url += `&adjust_reasons=deduct_withdraw`
  }
  if (deduct_create_shipping) {
    url += `&adjust_reasons=deduct_create_shipping`
  }
  if (deduct_not_specified) {
    url += `&adjust_reasons=deduct_not_specified`
  }
  if (deduct_others) {
    url += `&adjust_reasons=deduct_others`
  }
  url += `&created_by_role=${created_by_role}`

  return url
  // return store_id
  //   ? `${settings.app.GO_API_ROOT}/report/stock_history?store_id=${store_id}&warehouse_ids=${warehouse_ids}&created_at_from=${created_at_from}&created_at_to=${created_at_to}&action_type=${action_type}`
  //   : null
}

export function getReportPeakUrl(params: {
  store_id: number
  start_date: string
  end_date: string
  date_type: string
  payment_states: number[]
  shipping_states: number[]
}): string | null {
  const { store_id, start_date, end_date, date_type, payment_states, shipping_states } = params
  if (!_.isNumber(store_id)) {
    // throw new Error('getReportDailySalesExcelUrl is required store_id.')
    return null
  }

  let url = `${settings.app.GO_API_ROOT}/report/peak_receipt?store_id=${store_id}`
  if (_.isString(start_date)) {
    url += `&start_date=${start_date}`
  }
  if (_.isString(end_date)) {
    url += `&end_date=${end_date}`
  }
  if (_.isString(date_type)) {
    url += `&date_type=${date_type}`
  }
  if (!_.isNil(payment_states)) {
    payment_states.map((payment: number) => {
      url += `&payment_states=${payment}`
    })
  }
  if (!_.isNil(shipping_states)) {
    shipping_states.map((payment: number) => {
      url += `&shipping_states=${payment}`
    })
  }
  return url
}

export function getReportDailySalesExcelUrl(params: {
  store_id: number
  startDate?: string
  endDate?: string
  daysInPast?: number
}): string | null {
  const { store_id, startDate, endDate, daysInPast } = params
  if (!_.isNumber(store_id)) {
    // throw new Error('getReportDailySalesExcelUrl is required store_id.')
    return null
  }

  let endpoint = `${settings.app.API_ROOT}/report/dailysales?store_id=${store_id}`
  if (_.isString(startDate)) {
    endpoint += `&startDate=${startDate}`
  }
  if (_.isString(endDate)) {
    endpoint += `&endDate=${endDate}`
  }
  if (_.isNumber(daysInPast)) {
    endpoint += `&daysInPast=${daysInPast}`
  }
  return endpoint
}

export function getStoreNameFromStoreId(storeId: string | number, incPrefix?: boolean): string | null {
  const targetStoreId = _.isString(storeId) ? parseInt(storeId) : storeId
  const state = p.op.getAppState()
  const mystores = getMyStores(state)
  let foundStore = null
  foundStore = mystores.find((s) => s.get('id') === targetStoreId)
  if (foundStore) {
    return incPrefix ? `ร้านฉัน: ${foundStore.get('name')}` : foundStore.get('name')
  }

  const sellerstores = getSellerStores(state)
  foundStore = sellerstores.find((s) => s.get('id') === targetStoreId)
  if (foundStore) {
    return incPrefix ? `ร้านผู้ขายส่ง: ${foundStore.get('name')}` : foundStore.get('name')
  }

  return null
}

export function appendObjectIfImmutableDataChange(
  source: Map<string, any>,
  editing: Map<string, any>,
  target: object,
  key: string,
  parseType?: string
): void {
  let srcValue = parseByType(source.get(key), parseType || null)
  let newValue = parseByType(editing.get(key), parseType || null)
  if (srcValue.trim) {
    srcValue = srcValue.trim()
  }
  if (newValue.trim) {
    newValue = newValue.trim()
  }
  if (!_.isNull(srcValue) && !_.isNull(newValue) && !_.isUndefined(srcValue) && !_.isUndefined(newValue) && srcValue !== newValue) {
    target[key] = parseByType(newValue, parseType || null)
  }
}

// Universal parse value to target type (if cannot will return empty string)
export function parseByType(value: any, type: string): any | '' {
  switch (type) {
    case 'int':
      return parseInt(value) || 0
    case 'integer':
      return parseInt(value) || 0
    case 'radio':
      return parseInt(value) || 0
    case 'numberbool':
      return value ? 1 : 0
    case 'number':
      return parseFloat(value) || 0
    case 'float':
      return parseFloat(value) || 0
    case 'string':
      return value ? value.toString() : ''
    case 'text':
      return value ? value.toString() : ''
    case 'lowerstring':
      return value ? value.toString().toLowerCase() : ''
    case 'upperstring':
      return value ? value.toString().toUpperCase() : ''
    case 'json':
      return value ? JSON.parse(value) : ''
    default:
      return value ? value.toString() : ''
  }
}

// universal validation for prepared API body.
export function appendToObjectIfImmutableKeyIsNotEmpty(key: string, source: Map<string, any>, target: object, parseType = 'string'): void {
  // Not null and not ''
  const sourceValue = source.get(key)
  if (!_.isNull(sourceValue) && !_.isUndefined(sourceValue) && sourceValue !== '') {
    if (parseType === 'integer') {
      target[key] = parseInt(sourceValue)
    } else if (parseType === 'int') {
      target[key] = parseInt(sourceValue)
    } else if (parseType === 'float') {
      target[key] = parseFloat(sourceValue)
    } else if (parseType === 'number') {
      target[key] = parseFloat(sourceValue)
    } else if (parseType === 'string') {
      target[key] = sourceValue.toString().trim()
    } else if (parseType === 'text') {
      target[key] = sourceValue.toString().trim()
    } else if (parseType === 'email') {
      target[key] = sourceValue.toString().toLowerCase().trim()
    } else if (sourceValue.trim) {
      target[key] = sourceValue.trim()
    } else {
      target[key] = sourceValue
    }
  }
}
//
// export function isXSellyOrderId(testStr) {
//   if (!testStr || testStr.length > 7) {
//     return false
//   }
//   const result = typeof testStr === 'number' || /^\d+$/.test(testStr)
//   // log('isXSellyOrderId.testStr: ' + testStr + ' result: ' + result)
//   return result
// }

// validation required fields
export function checkRequireFields(
  reqFields: string[],
  reqDisplays: string[],
  chkObj: object
): { status: boolean; key?: string; display?: string } {
  for (let i = 0; i < reqFields.length; i++) {
    const key = reqFields[i]
    const display = reqDisplays[i]
    if (!_.has(chkObj, key)) {
      log(`check key = ${key} in body doesn't passed...`)
      return { status: false, key, display }
    }
    log(`checkRequireFields check key = ${key} in chkObj passed...`)
  }
  return { status: true }
}

export function isImmutableDiff(
  immutableOld: Map<string, any>,
  immutableNew: Map<string, any>,
  keyPath: string[],
  isDiffCallback: (newValue: any, oldValue: any) => void
): void {
  const newValue = immutableNew.getIn(keyPath) ? immutableNew.getIn(keyPath) : null
  const oldValue = immutableOld.getIn(keyPath) ? immutableOld.getIn(keyPath) : null
  if ((oldValue === null && newValue) || (newValue === null && oldValue) || oldValue !== newValue) {
    isDiffCallback(newValue, oldValue)
  }
}

/** Returns true if the specified object is immutable and not null
 *
 * @param obj
 * @returns {boolean}
 */
export function isImmutableAndNotNullObj(obj: any) {
  if (_.isNull(obj) || _.isUndefined(obj) || !isImmutable(obj)) {
    return false
  }
  return true
}

export function isXSellyOrderId(text: string): boolean {
  return /^[0-9]*$/.test(text) && text.length <= 12
}

export function getFileNameFromURL(fileURL) {
  const parseUrl = fileURL.replace('%2F', '/')
  return parseUrl.substring(parseUrl.lastIndexOf('/') + 1)
}

export function hasImageExtensionFromURL(fileURL: string): boolean {
  if (!fileURL || _.isString(fileURL)) {
    return false
  }
  return /\.(gif|jpg|jpeg|tiff|png)$/i.test(fileURL)
}

export function isAnyCharOneOrMore(text) {
  return /^.{1,}$/.test(text)
}

export function isEmailValidFormat(emailStr) {
  return REGEX_EMAIL.test(emailStr)
}

export function isEffilyPasswordValidFormat(passwordStr) {
  return REGEX_PASSWORD.test(passwordStr)
}

export function isNumberOnly(str) {
  return REGEX_NUMBER_ONLY.test(str)
}

export function isUsernameOnlyValidChars(username) {
  return REGEX_USERNAME.test(username)
}

export function isUsernameValidFormat(txt) {
  const isFullfillment = txt.length >= 4 && txt.length <= 20
  if (!isFullfillment) {
    return false
  }
  return isUsernameOnlyValidChars(txt)
}

// export function getHHMMNow() {
//   const d = new Date()
//     return ((d.getHours() < 10)?"0":"") + d.getHours() +":"+ ((d.getMinutes() < 10)?"0":"") + d.getMinutes() +":"+ ((d.getSeconds() < 10)?"0":"") + d.getSeconds()
// }

export function getHoursNow() {
  return new Date().getHours()
}

// export function deleteImmutableListAtIndex(list: Immutable.List<any>, idx: number): Immutable.List<any> {
//   if (!list || list.size === 0 || idx >= list.size) {
//     return list
//   }
//   if (p.op.isAndroid()) {
//     // workaround for bug https://github.com/facebook/immutable-js/issues/1474
//     // Simply create a new list and repopulate it
//     let jsList
//     if (list.size === 1 && idx === 0) {
//       jsList = []
//     } else {
//       jsList = list.toJS()
//       jsList.splice(idx, 1)
//       // log('jsList: ' + jsList)
//       // log('newJsList: ' + newJsList)
//     }
//     return fromJS(jsList)
//   } else {
//     return list.delete(idx)
//   }
// }

// Override method เพราะว่า performance method ด้านบน ทำให้ App ค้าง (not responding)
export function deleteImmutableListAtIndex(list: Immutable.List<any>, idx: number): Immutable.List<any> {
  if (!list || list.size === 0 || idx >= list.size) {
    return list
  }
  if (p.op.isAndroid()) {
    if (list.size === 1 && idx === 0) {
      return List([])
    }

    let newList = List([])
    list.forEach((data, index) => {
      if (index !== idx) {
        newList = newList.push(data)
      }
    })
    return newList
  }
  return list.delete(idx)
}

// Solved setState with async await
// Ref: https://github.com/facebook/react/issues/2642
interface IAnyComponentWithSetState<P, S> {
  setState<K extends keyof S>(
    state: ((prevState: Readonly<S>, props: Readonly<P>) => Pick<S, K> | S | null) | (Pick<S, K> | S | null),
    callback?: () => void
  ): void
  state: Readonly<S> | S
  [key: string]: any
}
// // O: ของเดิม
// export async function setStatePromise<S = {}>(
//   that: IAnyComponentWithSetState<any, Partial<S> & IAnyObject> | any,
//   newState: S & IAnyObject
// ) {
//   return new Promise((resolve) => {
//     that.setState(newState, () => {
//       resolve(null)
//     })
//   })
// }

// // O: ของใหม่ setStatePromise เพื่อแก้ไข state auto-complete สำหรับ component ปกติ
// https://stackoverflow.com/a/50924506
// https://newbedev.com/typescript-conditional-types-extract-component-props-type-from-react-component
// https://www.typescriptlang.org/docs/handbook/utility-types.html
// type ExtractAnyComponentGenericState<S> = S extends IAnyComponentWithSetState<any, infer X> ? X : never

type ExtractExtendedComponentState<TComponentOrTState> =
  TComponentOrTState extends IAnyComponentWithSetState<any, infer TState> ? TState : TComponentOrTState
type ExtractExtendedComponentState1<TComponentOrTState> =
  TComponentOrTState extends IAnyComponentWithSetState<any, infer TState> ? TState : unknown
type ExtractExtendedComponentState2<TComponentOrTState> =
  ExtractExtendedComponentState<TComponentOrTState> extends IAnyComponentWithSetState<any, infer TState> ? TState : unknown
type ExtractExtendedComponentState3<TComponentOrTState> =
  ExtractExtendedComponentState<ExtractExtendedComponentState<TComponentOrTState>> extends IAnyComponentWithSetState<any, infer TState>
    ? TState
    : unknown

export async function setStatePromise<S = {}>(
  that: IAnyComponentWithSetState<any, S>, // component ปกติ
  // | ExtractExtendedComponentState<S>
  newState: // | Pick<S, keyof S>
  // | Pick<S, keyof S>
  | Pick<ExtractExtendedComponentState1<typeof that>, keyof ExtractExtendedComponentState1<typeof that>>
    | Pick<ExtractExtendedComponentState2<typeof that>, keyof ExtractExtendedComponentState2<typeof that>>
    | Pick<ExtractExtendedComponentState3<typeof that>, keyof ExtractExtendedComponentState3<typeof that>>
    // | Pick<ExtractAnyComponentGenericState<typeof that>, keyof ExtractAnyComponentGenericState<typeof that>>
    // | ExtractAnyComponentGenericState<typeof that>
    // | Partial<ExtractAnyComponentGenericState<typeof that>>
    // | any
    | Partial<ExtractExtendedComponentState1<typeof that>>
    | Partial<S>
    | S
    | {}
  // | null
) {
  return new Promise((resolve) => {
    that.setState(newState as Pick<S, keyof S>, () => {
      resolve(null)
    })
  })
}

// example from: https://dev.to/ysfaran/usestatewithpromise-a-custom-hook-to-await-state-updates-of-usestate-284o
export function useStateWithPromise<T>(initialState: T): [T, (newState: T) => Promise<void>] {
  const [state, setState] = useState<T>(initialState)
  const resolverRef = useRef(null)

  useEffect(() => {
    if (resolverRef.current) {
      resolverRef.current(state)
      resolverRef.current = null
    }
    /**
     * Since a state update could be triggered with the exact same state again,
     * it's not enough to specify state as the only dependency of this useEffect.
     * That's why resolverRef.current is also a dependency, because it will guarantee,
     * that handleSetState was called in previous render
     */
  }, [resolverRef.current, state])

  const handleSetState: (newState: T) => Promise<void> = useCallback(
    (stateAction) => {
      setState(stateAction)
      return new Promise((resolve) => {
        resolverRef.current = resolve
      })
    },
    [setState]
  )

  return [state, handleSetState]
}

// For debug only
export async function doSomethingAndDelay(something: () => void, ms: number) {
  return new Promise((resolve) => {
    something()
    setTimeout(resolve, ms)
  })
}

export async function getAppToken(): Promise<string | null> {
  let token = await p.op.storageGet(CONS.AUTHENTICATION_STORAGE_KEY, false)
  log('   token => ', token)
  if (!token || token.length === 0) {
    return null
  }
  token = token.substring(0, 6) === 'Bearer' ? token : `Bearer ${token}`

  // @ts-ignore it's work fine
  return token
}

// Bitwise :: https://www.w3schools.com/js/js_bitwise.asp
export function decNum2binStr(dec: number): string {
  return (dec >>> 0).toString(2)
}

export function binStr2decStr(bin: string): string {
  return parseInt(bin, 2).toString(10)
}

export function decNum2binNum(dec: number): number {
  return parseInt(decNum2binStr(dec))
}

export function binNum2decNum(bin: number): number {
  return parseInt(binStr2decStr(bin.toString()))
}

export function decimalTobinaryArr(dec: number, digits: number): number[] {
  let binaryStr: string = decNum2binStr(dec)
  if (binaryStr.length < digits) {
    for (let i = binaryStr.length; i < digits; i++) {
      binaryStr = `0${binaryStr}`
    }
  }

  return binaryStr.split('').map((char) => parseInt(char))
}

export function binaryArrToDecimal(binArr: number[]): number {
  return binNum2decNum(parseInt(binArr.join('')))
}

export function pushArrayByArray(source: any[], target: any[], indexes: number[]) {
  indexes.forEach((idx: any) => {
    target.push(source[idx])
  })
}

export function canRequestExtraExcelColumns(subscriptionType: number): boolean {
  return subscriptionType !== CONS.SUBSCRIPTION_PACKAGE.FREE
}
// ref: https://gist.github.com/bgrins/6194623
export function isBase64DataURL(text: string): boolean {
  return !!text.match(
    /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i
  )
}

// modified from: https://www.sitepoint.com/get-url-parameters-with-javascript/
export function getDeepLinkParamsFromUrl(url: string): { e: number; [key: string]: any } | null {
  let decoededURL = url ? decodeURIComponent(url) : null
  // console.log('getDeepLinkParamsFromUrl url => ', url)
  if (decoededURL) {
    decoededURL = decoededURL.replace(/"/g, '')
    decoededURL = decoededURL.replace(/'/g, '')
  }
  // get query string from url (optional) or window
  const splitedByParamsURL = decoededURL ? decoededURL.split('xselly.com/d/?') : null
  if (!splitedByParamsURL || splitedByParamsURL.length <= 1) {
    return null
  }
  const paramsIndex = splitedByParamsURL.length - 1
  let queryString = splitedByParamsURL[paramsIndex]
  if (!queryString || queryString.length < 1) {
    return null
  }

  // we'll store the parameters here
  const obj = { e: null }

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0]

    // split our query string into its component parts
    const arr = queryString.split('&')

    for (let i = 0; i < arr.length; i++) {
      const key = arr[i]
      // for (const key of arr) {
      // separate the keys and the values
      // const a = arr[i].split('=')
      const a = key.split('=')

      // in case params look like: list[]=thing1&list[]=thing2
      let paramNum
      const paramName = a[0].replace(/\[\d*\]/, (v) => {
        paramNum = v.slice(1, -1)
        return ''
      })

      // set parameter value (use 'true' if empty)
      const paramValue = typeof a[1] === 'undefined' ? true : a[1]

      // (optional) keep case consistent
      // paramName = paramName.toLowerCase()
      // paramValue = paramValue.toLowerCase()

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]]
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue)
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue
      }
    }
  }

  if (obj && obj.e && _.isString(obj.e)) {
    obj.e = parseInt(obj.e)
  }

  return obj
}

export function _getPrefixForImageSlip() {
  // moment นี้อาจจะใช้บนเว็บไม่ได้
  const now = moment()
  const txtYear = now.get('year').toString().substring(3) // เอาตัวสุดท้สย
  const txtMonth = now.get('month') + 1 // moment's month begin from 0
  const txtDate = now.get('date')
  // log('year => ', moment().get('year'))
  // log('month => ', moment().get('month')) // moment's month begin from 0
  // log('date => ', moment().get('date'))
  return `${txtYear}${txtMonth}/${txtDate}/`
}

export function getHHMMSSInString() {
  // moment นี้อาจจะใช้บนเว็บไม่ได้
  // console.log('moment4', moment)
  const HHMMSS = moment().format('HHMMSS')
  return `${HHMMSS}`
}

export function generateRandomString(strNumber: number): string {
  // อยากได้กี่ตัว ให้ส่ง strNumber เข้ามา
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < strNumber; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

// Index start at RIGHT first.
// Index =>   3    2     1      0
// Number =>  8    4     2      1
export function getIntValueFromBinaryIndex(binaryIndex: number): number {
  // log('getIntValueFromBinaryIndex binaryIndex => ', binaryIndex)
  // log('getIntValueFromBinaryIndex Math.pow(2, binaryIndex) => ', Math.pow(2, binaryIndex))
  return 2 ** binaryIndex
}

export function roundToTwoDecimal(val: number) {
  // https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
  return Math.round(val * 100) / 100
}

export function getIsSetBoolFromBinaryAtIndex(inputIntValue: number, targetBinaryIndex: number): boolean {
  // log('getIsSetBoolFromBinaryAtIndex inputIntValue => ', inputIntValue)
  // log('getIsSetBoolFromBinaryAtIndex targetBinaryIndex => ', targetBinaryIndex)
  const targetIntValue = getIntValueFromBinaryIndex(targetBinaryIndex)
  return (inputIntValue & targetIntValue) === targetIntValue
}

export function getToggleIntFromBinaryAtIndex(inputIntValue: number, targetBinaryIndex: number): number {
  const targetIntValue = getIntValueFromBinaryIndex(targetBinaryIndex)
  const currentIsSet = getIsSetBoolFromBinaryAtIndex(inputIntValue, targetBinaryIndex)
  // log('getToggleIntFromBinaryAtIndex targetIntValue => ', targetIntValue)
  // log('getToggleIntFromBinaryAtIndex currentIsSet => ', currentIsSet)
  return currentIsSet ? inputIntValue - targetIntValue : inputIntValue + targetIntValue
}

export function getTxtvalueDiscount(valueDiscount: IVolumeDiscountMap): string {
  const variants = valueDiscount.get('variants')
  const minVal = variants.getIn([0, 'val'])
  const maxVal = variants.getIn([variants.size - 1, 'val'])
  const min = variants.getIn([0, 'min'])
  const max = variants.getIn([variants.size - 1, 'min'])
  const name = valueDiscount.get('name')
  if (valueDiscount.get('type') === 1) {
    return `${name}\nลด ฿${minVal}-฿${maxVal} สำหรับจำนวน ${min}-${max} ขึ้นไป (${variants.size} ขั้น)`
  }
  return `${name}\nลด ${minVal}%-${maxVal}% สำหรับจำนวน ${min}-${max} ขึ้นไป (${variants.size} ขั้น)`
}

export async function delay(ms: number): Promise<void> {
  await new Promise<void>((resolve) => {
    setTimeout(resolve, ms)
  })
}

// Should be deprecated soon
export function pushNativeBaseRef(refVariable, refKey, nbRef) {
  if (!_.isEmpty(nbRef) && _.has(nbRef, 'focus')) {
    pushToRefs(refVariable, refKey, nbRef)
  } else if (!_.isEmpty(nbRef) && !_.has(nbRef, 'focus') && _.has(nbRef, '_root')) {
    pushToRefs(refVariable, refKey, nbRef._root)
  }
}

// Should be deprecated soon
// ใช้แบบ Ref ชุดเดียว key ห้ามซ้ำเด็ดขาด
export function pushToRefs(refVariable, refKey, refValue) {
  // refVariable is Array of object
  if (!_.find(refVariable, (obj) => obj.key === refKey) && refValue) {
    refVariable.push({ key: refKey, value: refValue })
  }
}

// Should be deprecated soon
export async function pushNavRef(that, inputArrStateKey, refKey, nbRef) {
  if (that && _.isFunction(that.setState) && _.has(that, 'state')) {
    log('pushNavRef inputArrStateKey => ', inputArrStateKey)
    if (!_.isEmpty(nbRef) && _.has(nbRef, 'focus')) {
      await pushNavRefToState(that, inputArrStateKey, refKey, nbRef)
    } else if (!_.isEmpty(nbRef) && !_.has(nbRef, 'focus') && _.has(nbRef, '_root')) {
      await pushNavRefToState(that, inputArrStateKey, refKey, nbRef._root)
    }
  }
}

// Should be deprecated soon
// ใช้แบบ Ref ชุดเดียว key ห้ามซ้ำเด็ดขาด
export async function pushNavRefToState(that, inputArrStateKey, refKey, refValue) {
  // refVariable is Array of object
  if (!_.isArray(that.state[inputArrStateKey])) {
    throw new Error('Not found state of inputRefs')
  }
  const newState = {}
  newState[inputArrStateKey] = _.cloneDeep(that.state[inputArrStateKey])
  // @ts-ignore
  const foundIndex = _.findIndex(newState[inputArrStateKey], (refItem) => refItem.key === refKey)
  if (foundIndex === -1 && refValue) {
    log('pushNavRefToState inputArrStateKey => ', inputArrStateKey)
    newState[inputArrStateKey].push({ key: refKey, value: refValue })
    await new Promise((resolveSetState) => {
      that.setState(newState, resolveSetState)
    })
  }
}

// Should be deprecated soon
export function jumpToNextRef(refVariable, currentRef, scrollRef = null, extraOffset = 0) {
  // Current Ref: will jump until last of group keyboard will dismiss
  if (refVariable && refVariable.length > 0 && currentRef) {
    // @ts-ignore
    const foundIndex = parseInt(_.findIndex(refVariable, (obj) => obj.key === currentRef))
    if (foundIndex > -1) {
      if (refVariable[foundIndex + 1]) {
        const nexRef = refVariable[foundIndex + 1].value
        scrollToRef(scrollRef, nexRef, extraOffset)
        nexRef.focus()
      } else {
        // Keyboard.dismiss()
      }
    }
  }
}

export function scrollToRef(scrollRef, targetRef, extraOffset = 0) {
  if (scrollRef && scrollRef.scrollToPosition && targetRef && targetRef.measure && !p.op.isIOS()) {
    targetRef.measure((fx, fy, width, height, px, py) => {
      // log('Component width is: ' + width)
      // log('Component height is: ' + height)
      // log('X offset to frame: ' + fx)
      // log('Y offset to frame: ' + fy)
      log(`X offset to page: ${px}`)
      log(`Y offset to page: ${py}`)
      scrollRef.scrollToPosition(0, py + extraOffset, true)
    })
  }
}

export function jumpToBackRef(refVariable, currentRef, scrollRef = null) {
  // Current Ref: will jump until last of group keyboard will dismiss
  if (refVariable && refVariable.length > 0 && currentRef) {
    // @ts-ignore
    const foundIndex = parseInt(_.findIndex(refVariable, (obj) => obj.key === currentRef))
    if (foundIndex > -1) {
      const targetIndex = foundIndex - 1
      const targetRef = refVariable[targetIndex] && _.has(refVariable[targetIndex], 'value') ? refVariable[targetIndex] : null
      if (targetRef) {
        const backRef = _.has(targetRef, 'value') ? targetRef.value : null
        if (backRef && _.has(backRef, 'focus') && _.isFunction(backRef.focus)) {
          log('jumpToBackRef backRef => ', backRef)
          // scrollToRef(scrollRef, backRef)
          backRef.focus()
        }
      } else {
        // Keyboard.dismiss()
      }
    }
  }
}

export function isLastRef(refVariable, currentRef) {
  if (refVariable && refVariable.length > 0 && currentRef) {
    const refSize = refVariable.length
    if (refSize > 0) {
      // @ts-ignore
      const foundIndex = _.findIndex(refVariable, (obj) => obj.key === currentRef)
      const lastIndex = refSize - 1
      if (foundIndex === lastIndex) {
        return true
      }
    }
  }
  return false
}

// Should be deprecated soon
export function isFirstRef(refVariable, currentRef) {
  if (refVariable && refVariable.length > 0 && currentRef) {
    const refSize = refVariable.length
    if (refSize > 0) {
      // @ts-ignore
      const foundIndex = _.findIndex(refVariable, (obj) => obj.key === currentRef)
      if (foundIndex === 0) {
        return true
      }
    }
  }
  return false
}

export function appendIfImmutableDataChange(source, editing, target, key, parseType) {
  let srcValue = parseByType(source.get(key), parseType || null)
  let newValue = parseByType(editing.get(key), parseType || null)
  if (srcValue.trim) {
    srcValue = srcValue.trim()
  }
  if (newValue.trim) {
    newValue = newValue.trim()
  }
  // log('appendIfImmutableDataChange key, old, new => ', key, srcValue, newValue, parseType)
  if (!_.isNull(srcValue) && !_.isNull(newValue) && !_.isUndefined(srcValue) && !_.isUndefined(newValue) && srcValue !== newValue) {
    target[key] = parseByType(newValue, parseType || null)
  }
}

export function formatDateForDisplay(dateObj) {
  return dayjs(dateObj).format(CONS.DATE_FORMAT)
}

export function appendToObjectIfHasKeyInObject(sourceObj, targetObj, key, parseType = null) {
  if (_.has(sourceObj, key)) {
    if (parseType) {
      targetObj[key] = parseByType(sourceObj[key], parseType)
    } else {
      targetObj[key] = sourceObj[key]
    }
  }
}

// export function getActiveRouteName(navigationState: NavigationState | NavigationRoute): string | null {
//   if (!navigationState) {
//     return null
//   }
//   const route = navigationState.routes[navigationState.index]
//   // dive into nested navigators
//   if (route.routes) {
//     return getActiveRouteName(route)
//   }
//   return route.routeName
// }

// export function getActiveRouteNames(navigationState: NavigationState | NavigationRoute, prevRouteNames: string[] = []): string[] | null {
//   if (!navigationState) {
//     return null
//   }
//   const route = navigationState.routes[navigationState.index]
//   let newRouteNames
//   const currentRouteName = route.routeName
//   // const latestRouteName = prevRouteNames > 0 ? prevRouteNames[prevRouteNames.length - 1] : null
//   // if (_.isString(latestRouteName) && (latestRouteName.includes('stack') || latestRouteName.includes('Stack'))) {
//   if (_.isString(currentRouteName) && route.routes && (currentRouteName.includes('stack') || currentRouteName.includes('Stack'))) {
//     const stackRouteNames = route.routes.map((r) => r.routeName)
//     if (stackRouteNames.length > 0) {
//       stackRouteNames.pop() // pop out lastest duplicated stack routeName
//     }
//     newRouteNames = prevRouteNames.concat([currentRouteName].concat(stackRouteNames))
//   } else {
//     newRouteNames = prevRouteNames.concat(currentRouteName)
//   }
//   // dive into nested navigators
//   if (route.routes) {
//     return getActiveRouteNames(route, newRouteNames)
//   }
//   return newRouteNames
// }

// export function getIsAuthFromNavigationState(navigationState: NavigationState | NavigationRoute): boolean {
//   if (!navigationState) {
//     return false
//   }
//   const route = navigationState.routes[navigationState.index]
//   // get name from root navigators
//   return route.routeName === 'AuthStackNavigator'
// }

export function requiredNewArrayNoteOrder(array: any[], type: number, newDataNote: Object) {
  const data = []
  let addNewNote = true
  array.map((val) => {
    if (val.type === type) {
      addNewNote = false
      data.push(newDataNote)
    } else {
      data.push(val)
    }
  })
  if (addNewNote) {
    data.push(newDataNote)
  }
  return data
}

export function deleteNotesOrder(array: any[], type: number) {
  const data = []
  array.map((val) => {
    if (val.type != type) {
      data.push(val)
    }
  })
  return data
}

// FIXME: should return IOrder interface type
export function getFocusedOrder(sourceOrder = null, targetIndex = null) {
  if (!sourceOrder || _.isNil(targetIndex)) {
    return null
  }

  let focusedOrder
  if (targetIndex <= 0) {
    focusedOrder = sourceOrder
  } else {
    const suborders =
      Map.isMap(sourceOrder) && sourceOrder.has('suborders') && sourceOrder.get('suborders').size > 0 ? sourceOrder.get('suborders') : null

    if (_.isNull(suborders)) {
      focusedOrder = Map({}) // Empty Map
    } else {
      focusedOrder = List.isList(suborders) && suborders.get(targetIndex - 1) ? suborders.get(targetIndex - 1) : Map({})
    }
  }
  return focusedOrder
}

export function getShippingTypeNameById(shippingTypeId: string | number): string | null {
  if (!_.isInteger(shippingTypeId) && !_.isString(shippingTypeId)) {
    return null
  }
  const shippingTypeItem = CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS.find((item) => item && item.value.toString() === shippingTypeId.toString())
  if (shippingTypeItem && _.isString(shippingTypeItem.key)) {
    return p.op.t(`Order.shippingTypeItems.${shippingTypeItem.key}`)
  }

  return null
}

function canComputeOrderStateColor(orderType: 1 | 2 | 3 | number, state: number): boolean {
  if (orderType && _.includes([1, 2, 3], orderType) && _.isNumber(state)) {
    return true
  }
  return false
}

export function getOrderStateColor(orderType: 1 | 2 | 3 | number, state: number): string | null {
  if (!canComputeOrderStateColor(orderType, state)) {
    return null
  }

  if (state === 109) {
    // ยืนยันเสร็จสิ้น
    return COLORS.BRAND_Success
  }

  if (
    (orderType === 1 && state === 102) ||
    (orderType === 2 && _.includes([101, 102], state)) ||
    (orderType === 3 && _.includes([101, 103], state))
  ) {
    // รอฉันยืนยันออเดอร์
    return COLORS.APP_MAIN
  }

  // อื่นๆ (ฉันไม่ต้องทำอะไร)
  return COLORS.TEXT_INACTIVE
}

export function getPaymentStateColor(orderType: 1 | 2 | 3 | number, state: number): string | null {
  if (!canComputeOrderStateColor(orderType, state)) {
    return null
  }

  if (state === 119) {
    // ชำระครบ เลขตรง
    return COLORS.BRAND_Success
  }

  if (orderType === 1 && _.includes([111, 112, 113, 114], state)) {
    // รอลูกค้าชำระ (รอฉันบันทึกรับชำระ) / รอฉันคืนเงินลูกค้า​ (รอฉันแจ้งคืนเงิน) / รอฉันยืนยันรับชำระ
    return COLORS.APP_MAIN
  }
  if (orderType === 2 && _.includes([112, 113, 114], state)) {
    // รอฉันคืนเงินตัวแทน / รอฉันยืนยันรับชำระ / รอฉันยืนยันรับชำระ
    return COLORS.APP_MAIN
  }
  if (orderType === 3 && _.includes([111, 115], state)) {
    // รอฉันแจ้งชำระ / รอฉันยืนยันรับเงินคืน
    return COLORS.APP_MAIN
  }

  // อื่นๆ (ฉันไม่ต้องทำอะไร)
  return COLORS.TEXT_INACTIVE
}

export function getShippingStateColor(orderType: 1 | 2 | 3 | number, state: number): string | null {
  if (!canComputeOrderStateColor(orderType, state)) {
    return null
  }

  if (state === 129) {
    // จัดส่งครบถ้วน
    return COLORS.BRAND_Success
  }

  if (_.includes([1, 2], orderType) && state === 121) {
    // รอฉันจัดส่ง
    return COLORS.APP_MAIN
  }

  // อื่นๆ (ฉันไม่ต้องทำอะไร)
  return COLORS.TEXT_INACTIVE
}

export function getLineUrlByLineId(lineId: string): string {
  if (_.isString(lineId) && lineId.length > 0) {
    if (lineId.indexOf('@') === 0 || lineId.indexOf('%40') === 0) {
      let newString = lineId.replace('@', '')
      newString = newString.replace('%40', '')
      return `https://line.me/ti/p/%40${newString}`
    }
  }
  return `https://line.me/ti/p/~${lineId}`
}

export function getInstagramUrlByInstagramId(id: string): string {
  return `https://instagram.com/${id}`
}

// checkOnchangeData ส่ง obj เข้ามาเท่านั้น
export function checkOnchangeData(oldData, newData) {
  const checkVariants: any = detailedDiff(oldData, newData)
  if (!_.isEmpty(checkVariants.added)) {
    // alert('VARIANTS ADD')
    return true
  }
  if (!_.isEmpty(checkVariants.deleted)) {
    // alert('VARIANTS DELETE')
    return true
  }
  if (!_.isEmpty(checkVariants.updated)) {
    // alert('VARIANTS UPDATE')
    return true
  }
  return false
}

export async function getDiscountDetails(order) {
  const discountDetails = order.get('discount_details')
  let products = order.get('products')
  const subOrders = isImmutable(order.get(`suborders`)) ? order.get(`suborders`).toJS() : order.get(`suborders`)
  const newDiscountDetails = {
    vd: null,
    ugpg: null,
  }
  const VD = []
  const UGPG = []

  if (_.isNil(discountDetails)) {
    return null
  }
  if (products.size < 1) {
    products = []
    if (!_.isNil(subOrders)) {
      subOrders.map((order) => {
        if (!_.isNil(order.products)) {
          order.products.map((subOr) => {
            products.push(subOr)
          })
        }
      })
    }
    // return null
  }
  products = fromJS(products)
  discountDetails.map((val) => {
    let product = products.find((pd) => pd.get('pp_id') === val.get('pp_id'))
    if (_.isNil(product)) {
      // product = products.find(pd => pd.get('h') === val.get('pp_id'))
      product = products.find((pd) => pd.get('h') === val.get('pp_id'))
    }
    // if (_.isNil(product)) {
    //   // product = products.find(pd => pd.get('h') === val.get('pp_id'))
    //   product = products.find(pd => {
    //     return pd.get('pp_id') === val.get('pp_id')
    //   })
    // }
    const newProduct = val.toJS()
    if (_.isNil(product)) {
      return null
    }
    newProduct.name = product.get('name')
    newProduct.qty = product.get('qty')
    if (val.get('promotion_type') === CONS.ORDER_DISCOUNT_KEY.VD) {
      VD.push(newProduct)
    } else if (val.get('promotion_type') === CONS.ORDER_DISCOUNT_KEY.UGPG) {
      UGPG.push(newProduct)
    }
  })
  // @ts-ignore
  if (VD !== []) {
    newDiscountDetails.vd = VD
    // newDiscountDetails.push(VD)
  }
  // @ts-ignore
  if (UGPG !== []) {
    newDiscountDetails.ugpg = UGPG
    // newDiscountDetails.push(UGPG)
  }
  // @ts-ignore
  if (VD !== [] || UGPG !== []) {
    return newDiscountDetails
  }
  return null
}

export function doesOrderWaitsToBeShippedThenPaid(order) {
  const shipBeforePay = order.get('ship_before_pay')
  const payment_state = order.get('payment_state')
  const shipping_state = order.get('shipping_state')
  // const orderState = order.get('order_state')
  // console.log(order.toJS())
  // console.log(orderState)
  // console.log("shipBeforePay: " + shipBeforePay)
  // console.log("payment_state: " + payment_state)
  // console.log("shipping_state: " + shipping_state)
  if (!_.isNil(shipBeforePay) && shipBeforePay && payment_state === 111 && shipping_state < 129) {
    // console.log("returning true")
    return true
  }
  // console.log("returning false")
  return false
}

export function getXShippingStatusLabel(x: any) {
  // x = Number || String // x = เลข state ของ xshipping
  if (!_.isNil(x) && (_.isNumber(x) || _.isString(x))) {
    const status = CONS.XSHIPPING_STATUS.find((data) => data.value === x)
    if (_.isNil(status)) {
      return `เกิดข้อผิดพลาด ${x}`
    }
    return p.op.t(`xshippingStatus.${status.key}`)
  }
}

export function getXShippingIconStatus(x: any) {
  // x = Number || String // x = เลข state ของ xshipping
  const iconNameCheckMark = 'checkmark-circle-outline'
  const iconNameError = 'error-outline'
  const ionicons = 'Ionicons'
  const materialIcons = 'MaterialIcons'
  let status = { name: iconNameCheckMark, family: ionicons, color: COLORS.TEXT_ACTIVE }
  if (!_.isNil(x) && (_.isNumber(x) || _.isString(x))) {
    // if (_.includes([9001, 2610], x)) {
    if (_.includes(CONS.XSHIPPING_STATUS_DELIVERY_SUCCESS, x)) {
      status = { name: iconNameCheckMark, family: ionicons, color: COLORS.GREEN }
      // } else if (_.includes([2500, 2510, 2511, 2520, 9003], x)) {
    } else if (_.includes(CONS.XSHIPPING_STATUS_DELIVERY_FAILED, x)) {
      status = { name: iconNameError, family: materialIcons, color: COLORS.RED }
    }
  }
  return status
}

export function checkPaperangAutoSaveImg(selectedStore: any) {
  const paperang = selectedStore.get('printing_paperang')
  const autoSaveImg = paperang.getIn(['p', 'i'])
  const newAutoSaveImg = paperang.getIn(['p', 'm'])
  let paperangAutoSave = false
  if (_.isNil(newAutoSaveImg)) {
    if (_.isNil(autoSaveImg) || autoSaveImg === 0) {
      paperangAutoSave = true
    }
  } else if (_.isNil(newAutoSaveImg) || newAutoSaveImg === 0) {
    paperangAutoSave = true
  }
  return paperangAutoSave
}

export function checkPaperangAutoSaveImgFromPrintingBill(selectedStore: any) {
  const paperang = selectedStore.get('printing_bill_paperang')
  const autoSaveImg = paperang.getIn(['p', 'd'])
  let paperangAutoSave = false
  if (_.isNil(autoSaveImg) || autoSaveImg === 0) {
    paperangAutoSave = true
  }
  return paperangAutoSave
}

export async function getInitPlue(additionParams: any) {
  // HARD CODE FOR APP
  let v = null
  let b = null
  let s = null
  const time = p.op.getBuildTimestamp()
  let os = 'w'
  if (Platform.OS === 'ios') {
    os = 'i'
    v = DeviceInfo.getVersion()
    b = DeviceInfo.getBuildNumber()
    s = DeviceInfo.getSystemVersion()
  } else if (Platform.OS === 'android') {
    os = 'a'
    v = DeviceInfo.getVersion()
    b = DeviceInfo.getBuildNumber()
    s = DeviceInfo.getSystemVersion()
  } else {
    v = null
    b = null
    s = null
  }
  // const init = `?t=${time}&v=${v}&b=${b}&o=${os}&s=${s}`
  let initX = `?t=${time}&o=${os}`
  if (!_.isNil(v)) {
    const vv = `${v}`
    initX += `&v=${vv.replace(/ /g, '')}`
  }
  if (!_.isNil(b)) {
    const bb = `${b}`
    initX += `&b=${bb.replace(/ /g, '')}`
  }
  if (!_.isNil(s)) {
    const ss = `${s}`
    initX += `&s=${ss.replace(/ /g, '')}`
  }
  const latestPickedStoreId = await p.op.storageGet(CONS.STATE_SAVE_KEYS.LATEST_PICKED_STORE_ID, false)
  // console.log('latestPickedStoreId => ', latestPickedStoreId)
  if (latestPickedStoreId && latestPickedStoreId !== '') {
    initX += `&ss_id=${latestPickedStoreId}`
  }

  const selectedStoreOrdersDates = getSelectedStoreOrdersDates()
  const selectedStoreOrdersDatesOptionKey = getSelectedStoreOrdersDatesOptionKey()
  const sDateRange = getDateRangeFromOption(selectedStoreOrdersDatesOptionKey)
  if (additionParams && _.isString(additionParams.created_at_from)) {
    initX = `${initX}&created_at_from=${additionParams.created_at_from}`
  } else if (selectedStoreOrdersDatesOptionKey && selectedStoreOrdersDatesOptionKey !== 'Custom') {
    initX = `${initX}&created_at_from=${sDateRange.begin.format(CONS.SERVER_DATETIME_FORMAT)}`
  } else if (selectedStoreOrdersDates && selectedStoreOrdersDates.begin) {
    initX = `${initX}&created_at_from=${selectedStoreOrdersDates.begin.format(CONS.SERVER_DATETIME_FORMAT)}`
  }

  if (additionParams && _.isString(additionParams.created_at_to)) {
    initX = `${initX}&created_at_to=${additionParams.created_at_to}`
  } else if (selectedStoreOrdersDatesOptionKey && selectedStoreOrdersDatesOptionKey !== 'Custom') {
    initX = `${initX}&created_at_to=${sDateRange.end.format(CONS.SERVER_DATETIME_FORMAT)}`
  } else if (selectedStoreOrdersDates && selectedStoreOrdersDates.end) {
    initX = `${initX}&created_at_to=${selectedStoreOrdersDates.end.format(CONS.SERVER_DATETIME_FORMAT)}`
  }

  initX = `${initX}&skip_count=true`

  return initX
}

export function checkBitBinaries(bitConstant: number, bitToCheck: number) {
  // bitConstant = bit ปัจจุปัน
  // bitToCheck = bit ที่ต้องการตรวจสอบ
  // return true || false
  return andBit(bitConstant, bitToCheck) === bitToCheck
}

export function orBit(newBitToChange: number, oldBit: number) {
  return newBitToChange | oldBit
}

export function andBit(newBitToChange: number, oldBit: number) {
  return newBitToChange & oldBit
}

// O: ดูเหมือน iOS จะไม่สามารถเช็ค Promise แบบนี้ได้
export function isAsyncFunction(myFunc: (...args: any) => any | Promise<any>) {
  // @ts-ignore myFunc should have then already
  return _.isFunction(myFunc) && _.has(myFunc, 'then') && _.isFunction(myFunc.then)
}

/**
 * Returns true if the current store is the owner of an organization
 * @param selectedStore can be Immutable object or regular Javascript object
 */
export function isOrgOwnerStore(selectedStore: any) {
  if (!selectedStore) {
    return false
  }
  const is_owner_key = 'is_owner'
  if (isImmutable(selectedStore)) {
    // Handle as an immutable Object
    const org = selectedStore.get('org')
    return !_.isNil(org) && org.size > 0 && org.get(0).get(is_owner_key)
  }
  // Handle as a regular Javascript object
  const { org } = selectedStore
  return !_.isNil(org) && org.length > 0 && org[0][is_owner_key]
}

/**
 * Returns null if not have org
 * @param selectedStore can be Immutable object or regular Javascript object
 */
export function getOrgId(selectedStore: any) {
  if (!selectedStore) {
    return null
  }
  const idKey = 'id'
  if (isImmutable(selectedStore)) {
    // Handle as an immutable Object
    const org = selectedStore.get('org')
    return !_.isNil(org) && org.size > 0 && org.get(0).get(idKey)
  }
  // Handle as a regular Javascript object
  const { org } = selectedStore
  return !_.isNil(org) && org.length > 0 && org[0][idKey]
}

export function getOrgResellerCode(selectedStore: any) {
  if (!selectedStore) {
    return null
  }
  const idKey = 'reseller_code'
  if (isImmutable(selectedStore)) {
    // Handle as an immutable Object
    const org = selectedStore.get('org')
    return !_.isNil(org) && org.size > 0 && org.get(0).get(idKey)
  }
  // Handle as a regular Javascript object
  const { org } = selectedStore
  return !_.isNil(org) && org.length > 0 && org[0][idKey]
}

export function getOrgResellerType(selectedStore: any) {
  // reseller_type: Dealer = 1 , VIP = 2 , Member = 3
  if (!selectedStore) {
    return null
  }
  const idKey = 'reseller_type'
  if (isImmutable(selectedStore)) {
    // Handle as an immutable Object
    const org = selectedStore.get('org')
    return !_.isNil(org) && org.size > 0 && org.get(0).get(idKey)
  }
  // Handle as a regular Javascript object
  const { org } = selectedStore
  return !_.isNil(org) && org.length > 0 && org[0][idKey]
}

export function getOrgResellerPending(selectedStore: any) {
  if (!selectedStore) {
    return null
  }
  let isPending = false
  const org = selectedStore.get(`org`)
  const orgJS = _.isNil(org) ? null : isImmutable(org) ? org.toJS()[0] : org[0]
  if (!_.isNil(orgJS)) {
    isPending = _.isNil(orgJS.is_pending_reseller_code) ? false : orgJS.is_pending_reseller_code
  }
  return isPending
}

export function getWarehousesDetail(storeWarehouses: List<IWarehousesDetailMap>, warehousesId: number): IWarehousesDetailMap | null {
  const foundWarehouse = storeWarehouses.find((fwh) => Map.isMap(fwh) && fwh.get('id') === warehousesId)
  if (!_.isNil(foundWarehouse)) {
    return foundWarehouse
  }
  return null
}

export function getWarehouseDisplayName(
  storeWarehouses: List<IWarehousesDetailMap>,
  targetWarehouse: IWarehousesDetailMap,
  targetWhIndex: number
) {
  const DisplayLabel = 'คลัง'
  if (!storeWarehouses || storeWarehouses.size <= 1) {
    return DisplayLabel
  }
  const whName = targetWarehouse.get('name') || `(ไม่ระบุชื่อ ${targetWhIndex + 1})`
  return `${DisplayLabel}${whName}`
}

// ย้ายไปไว้ที่ xshare/x/utils/stringuitl.ts > removeUnknownString
// export function replaceOutUnknowString(strContainUnknownSpace: string): string {
//   // FIXED case 1 of https://effily.atlassian.net/browse/XSELLY-725
//   // สับ Unknown character ที่แม่ค้า copy ติด clipboard มา ออกไป
//   return strContainUnknownSpace.replace(/​/g, '')
// }

export function isMarketPlacesOrder(order: IOrderMap | Map<string, any>) {
  // return order.hasIn(['mkp', 'id'])
  return order.has('mkp_id') && _.isNumber(order.getIn(['mkp_id']))
}

export function getMarketplceChannelNameById(mkpChannels: List<ImmutableObject<IMKPChannelDetail>>, mkp_channel_id: number) {
  if (!mkp_channel_id) {
    return null
  }
  const foundMkpChannel: ImmutableObject<IMKPChannelDetail> = mkpChannels.find((mkpc) => mkpc.get('id') === mkp_channel_id)
  if (!Map.isMap(foundMkpChannel)) {
    return null
  }
  return foundMkpChannel.get('name')
}

export function filterMkpChannelIsActive(mkpChannel: IMKPChannelDetail): boolean {
  return mkpChannel.is_active
}

export function isMkpChannelActiveAtLeastOne(mkpChannels: IMKPChannelDetail[]) {
  for (let i = 0; i < mkpChannels.length; i++) {
    const mkpCh = mkpChannels[i]
    if (filterMkpChannelIsActive(mkpCh)) {
      return true
    }
  }
  return false
}

export function filterMkpChannelMapIsActive(mkpChannel: ImmutableObject<IMKPChannelDetail>): boolean {
  return mkpChannel.get('is_active')
}

export function isMkpChannelMapsActiveAtLeastOne(mkpChannels: List<ImmutableObject<IMKPChannelDetail>>) {
  for (let i = 0; i < mkpChannels.size; i++) {
    const mkpCh = mkpChannels.get(i)
    if (filterMkpChannelMapIsActive(mkpCh)) {
      return true
    }
  }
  return false
}

// parseSmartFloat ใช้สำหรับ parseFloat string หรือ number ให้เป็น float อย่างแน่นอน
// ข้อควรระวัง ควรรู้ว่าข้างในเป็นอะไรกันแน่ เพราะถ้าเป็น null | undefined | unknown string จะ return ค่าเป็น 0
export function parseSmartFloat(strOrNum: string | number): number {
  if (_.isNumber(strOrNum)) {
    return strOrNum
  }

  if (_.isNil(strOrNum)) {
    return 0
  }

  const parsedValue = parseFloat(strOrNum)
  if (_.isNaN(parsedValue)) {
    return 0
  }

  return parsedValue
}

// parseSmartInt ทำงานเหมือนกับ parseSmartFloat แต่ output เป็น int
export function parseSmartInt(strOrNum: string | number): number {
  if (_.isNumber(strOrNum)) {
    return strOrNum
  }

  if (_.isNil(strOrNum)) {
    return 0
  }

  const parsedValue = parseInt(strOrNum)
  if (_.isNaN(parsedValue)) {
    return 0
  }

  return parsedValue
}

// date => 2007-12-31 08:30:00
export function getDateTimeFormatSupportNewDate(date: string): Date {
  if (_.isNil(date)) {
    return null
  }
  const dateTrim = date.trim()
  const yyyymmdd = dateTrim.substring(0, 10)
  const hhmmss = dateTrim.substring(11, 19)
  // console.log('dateTrim => ', dateTrim)
  // console.log('dateTrim / => ', dateTrim.length)
  // console.log('yyyymmdd // => ', yyyymmdd)
  // console.log('hhmmss /// => ', dateTrim.substring(10, 19))
  // new Date(`${newDateFormat}T${newTimeFormat}:00+07:00`)
  // console.log(`TEST => `, `${yyyymmdd}T${hhmmss}+07:00`)
  return new Date(`${yyyymmdd}T${hhmmss}+07:00`)
}

export function getTimeFormatYYYYMMDDhhmmss(newDate?: Date) {
  const DATE = _.isNil(newDate) ? new Date() : newDate
  const year = DATE.getFullYear()
  const month = DATE.getMonth() + 1
  const day = DATE.getDate()
  const h = DATE.getHours()
  const m = DATE.getMinutes()
  const s = DATE.getSeconds()
  let newMonth = `${month}`
  let newDay = `${day}`
  let newh = `${h}`
  let newm = `${m}`
  let news = `${s}`
  if (month < 10) {
    newMonth = `0${month}`
  }
  if (day < 10) {
    newDay = `0${day}`
  }
  if (h < 10) {
    newh = `0${h}`
  }
  if (m < 10) {
    newm = `0${m}`
  }
  if (s < 10) {
    news = `0${s}`
  }
  return `${year}-${newMonth}-${newDay} ${newh}:${newm}:${news}`
}

export function getTimeFormatYYYYMMDDhhmmssIfNeedSecondToZero(newDate?: Date) {
  const DATE = _.isNil(newDate) ? new Date() : newDate
  const year = DATE.getFullYear()
  const month = DATE.getMonth() + 1
  const day = DATE.getDate()
  const h = DATE.getHours()
  const m = DATE.getMinutes()
  let newMonth = `${month}`
  let newDay = `${day}`
  let newh = `${h}`
  let newm = `${m}`
  const news = '00'
  if (month < 10) {
    newMonth = `0${month}`
  }
  if (day < 10) {
    newDay = `0${day}`
  }
  if (h < 10) {
    newh = `0${h}`
  }
  if (m < 10) {
    newm = `0${m}`
  }
  return `${year}-${newMonth}-${newDay} ${newh}:${newm}:${news}`
}

export function getTimeFormatYYYYMMDDhhmm(date?: Date) {
  const newDate = _.isNil(date) ? new Date() : date
  const year = new Date(newDate).getFullYear()
  const month = new Date(newDate).getMonth() + 1
  const day = new Date(newDate).getDate()
  const h = new Date(newDate).getHours()
  const m = new Date(newDate).getMinutes()
  let newMonth = `${month}`
  let newDay = `${day}`
  let newh = `${h}`
  let newm = `${m}`
  if (month < 10) {
    newMonth = `0${month}`
  }
  if (day < 10) {
    newDay = `0${day}`
  }
  if (h < 10) {
    newh = `0${h}`
  }
  if (m < 10) {
    newm = `0${m}`
  }
  return `${year}-${newMonth}-${newDay} ${newh}:${newm}`
}

export function getDateFormatYYYYMMDD(date?: Date) {
  const newDate = _.isNil(date) ? new Date() : date
  const year = new Date(newDate).getFullYear()
  const month = new Date(newDate).getMonth() + 1
  const day = new Date(newDate).getDate()
  let newMonth = `${month}`
  let newDay = `${day}`
  if (month < 10) {
    newMonth = `0${month}`
  }
  if (day < 10) {
    newDay = `0${day}`
  }
  return `${year}-${newMonth}-${newDay}`
}

export function getDateFormathhmm(date?: Date) {
  const newDate = _.isNil(date) ? new Date() : date
  const h = new Date(newDate).getHours()
  const m = new Date(newDate).getMinutes()
  const s = new Date(newDate).getSeconds()
  let newh = ''
  let newm = ''
  let news = ''
  if (h < 10) {
    newh = `0${h}`
  } else {
    newh = `${h}`
  }
  if (m < 10) {
    newm = `0${m}`
  } else {
    newm = `${m}`
  }
  if (s < 10) {
    news = `0${s}`
  } else {
    news = `${s}`
  }
  // console.log(`newH -- `, newh)
  return `${newh}:${newm}:00`
}

export function canUseVolumeDiscount(subscription: any) {
  if (!subscription) {
    return false
  }

  const vdQuota = isImmutable(subscription) ? subscription.get(`vd_quota`) : subscription.vd_quota
  if (vdQuota < 1) {
    return false
  }
  return true
}

// RETURN MKP Name
export function getMKPName(MKP_ID: number) {
  switch (MKP_ID) {
    case 1:
      return 'Shopee'
    case 2:
      return 'Lazada'
    case 3:
      return 'Tiktok Shop'
    case 4:
      return 'LINE SHOPPING'
    case 5:
      return 'Shopify'
    default:
      return '-'
  }

  // if (MKP_ID === 1) {
  //   return `Shopee`
  // }
  // if (MKP_ID === 2) {
  //   return 'Lazada'
  // }
  // return '-'
}

// RETURN MKP CHANNEL Name
export function getMKPChannelName(ug_id: number): string {
  const selectedStore = getStoreSelected(p.op.getAppState())
  let channels = selectedStore.get('channels')
  if (!_.isNil(channels)) {
    channels = isImmutable(channels) ? channels.toJS() : channels
    const channel = _.find(channels, (ch: IMKPChannelDetail) => ch.id === ug_id)
    if (!_.isNil(channel)) {
      return channel.name
    }
  }
  return '-'
}

// RETURN MKP CHANNEL ID
export function getMKPId(mkpChannelId: number): number {
  const selectedStore = getStoreSelected(p.op.getAppState())
  let channels = selectedStore.get('channels')
  if (!_.isNil(channels)) {
    channels = isImmutable(channels) ? channels.toJS() : channels
    const channel = _.find(channels, (ch: IMKPChannelDetail) => ch.id === mkpChannelId)
    if (!_.isNil(channel)) {
      return channel.mkp_id
    }
  }
  return 0
}

export function getSelectedStoreOrdersDates(): IDateRange {
  return getSelectedStoreOrdersDatesSelector(p.op.getAppState())
}

export function getSelectedStoreOrdersDatesOptionKey(): IXDateRangeSelectorOptionKey {
  return getSelectedStoreOrdersDatesOptionKeySelector(p.op.getAppState())
}

export function isJSON(txt: string): boolean {
  let json = txt
  try {
    // FIXME: O: Temporary ignored barcode
    // https://github.com/react-native-community/react-native-camera/issues/2875
    if (txt.indexOf('errorCode') >= 0) {
      return true
    }
    json = JSON.parse(txt)
  } catch (e) {
    return false
  }
  return typeof json === 'object'
}

export function isTrueOr1(testParam): boolean {
  return testParam === true || testParam === 1
}

export function translateOrderCopyTemplate(
  templateString: string,
  orderValues: {
    orderId: number
    orderAmountTotal: number
    orderAmountProducts: number
    productTotalQty: number
    orderCreateDateTime: string

    orderCodAmount?: number
    orderShippingCost?: number
    orderEtcCost?: number
    orderDiscount?: number
    orderMemberDiscount?: number
    orderCodFee?: number

    isCodOrder?: boolean

    txtProductItems: string
    txtProductWithPriceItems: string
    txtShippingTypeLabel: string
    txtOrderFullAddress: string
    txtOrderLink: string
  }
) {
  const {
    orderId,
    orderAmountTotal,
    orderAmountProducts,
    orderCreateDateTime,
    productTotalQty,

    orderCodAmount = 0,
    orderShippingCost = 0,
    orderEtcCost = 0,
    orderDiscount = 0,
    orderMemberDiscount = 0,
    orderCodFee = 0,

    isCodOrder = false,

    txtProductItems = '',
    txtProductWithPriceItems = '',
    txtShippingTypeLabel = '',
    txtOrderFullAddress = '',
    txtOrderLink = '',
  } = orderValues

  let txtClipboard = templateString

  txtClipboard = txtClipboard.replace(/\[order_number\]/g, `#${orderId}`)

  txtClipboard = txtClipboard.replace(/\[product_total_qty\]/g, `${productTotalQty}`)

  txtClipboard = txtClipboard.replace(/\[order_create_datetime\]/g, `${orderCreateDateTime}`)

  if (isCodOrder) {
    txtClipboard = txtClipboard.replace(/\[total_amount\]/g, fmt.formatCurrency(orderCodAmount))
  } else {
    txtClipboard = txtClipboard.replace(/\[total_amount\]/g, fmt.formatCurrency(orderAmountTotal))
  }

  txtClipboard = txtClipboard.replace(/[\n]?\[product_and_price_items\]/g, txtProductWithPriceItems)
  txtClipboard = txtClipboard.replace(/[\n]?\[product_items\]/g, txtProductItems)

  txtClipboard = txtClipboard.replace(/[\n]?\[product_amount_label\]/g, `\nรวมค่าสินค้า ${fmt.formatCurrency(orderAmountProducts)}`)

  if (orderShippingCost > 0) {
    txtClipboard = txtClipboard.replace(/[\n]?\[shipping_amount_label\]/g, `\nค่าจัดส่ง ${fmt.formatCurrency(orderShippingCost)}`)
  } else {
    txtClipboard = txtClipboard.replace(/[\n]?\[shipping_amount_label\]/g, '')
  }

  if (orderEtcCost > 0) {
    txtClipboard = txtClipboard.replace(/[\n]?\[etc_amount_label\]/g, `\nค่าอื่นๆ ${fmt.formatCurrency(orderEtcCost)}`)
  } else {
    txtClipboard = txtClipboard.replace(/[\n]?\[etc_amount_label\]/g, '')
  }

  if (orderDiscount > 0) {
    txtClipboard = txtClipboard.replace(/[\n]?\[order_discount_amount_label\]/g, `\nส่วนลด ${fmt.formatCurrency(orderDiscount)}`)
  } else {
    txtClipboard = txtClipboard.replace(/[\n]?\[order_discount_amount_label\]/g, '')
  }

  if (orderMemberDiscount > 0) {
    txtClipboard = txtClipboard.replace(
      /[\n]?\[member_discount_amount_label\]/g,
      `\nส่วนลดสมาชิก ${fmt.formatCurrency(orderMemberDiscount)}`
    )
  } else {
    txtClipboard = txtClipboard.replace(/[\n]?\[member_discount_amount_label\]/g, '')
  }

  if (isCodOrder && orderCodFee > 0) {
    txtClipboard = txtClipboard.replace(/[\n]?\[cod_amount_label\]/g, `\nค่าธรรมเนียมเก็บเงินปลายทาง ${fmt.formatCurrency(orderCodFee)}`)
  } else {
    txtClipboard = txtClipboard.replace(/[\n]?\[cod_amount_label\]/g, '')
  }

  txtClipboard = txtClipboard.replace(/\[shipping_type\]/g, txtShippingTypeLabel)
  txtClipboard = txtClipboard.replace(/\[receiver_address\]/g, txtOrderFullAddress)
  // txtOrderLink ที่ใส้ช่องว่างด้านหลัง เพราะว่า ไม่ให้ text อื่นๆที่พิมพ์ต่อท้ายแล้วทำลิงค์ออเดอร์พัง
  txtClipboard = txtClipboard.replace(/\[order_link\]/g, `${txtOrderLink} `)
  return txtClipboard
}

export function getDonutData(orderSummary: IMap<IOrderSummary> | IOrderSummary): ISummaryItem[] {
  let summary: IMap<IOrderSummary> | null = null
  if (Map.isMap(orderSummary)) {
    summary = orderSummary
  } else if (_.isObject(orderSummary)) {
    summary = fromJS(orderSummary)
  } else {
    return []
  }
  let dataArr: ISummaryItem[]
  dataArr = []

  const sc = COLORS.SUMMARY_ORDER_DONUT_COLOR_SCALE
  // Case 1
  // layout 1:
  // ยืนยันราคา     4    ชำระ    5
  // ยืนยันรับชำระ 2
  const myTasksConfirmOrder = summary.get('myTasks_confirmOrder')
  const myTasksPay = summary.get('myTasks_pay')
  const myTasksConfirmGettingPaid = summary.get('myTasks_confirmGettingPaid')
  dataArr.push({ x: 'myTasks_confirmOrder', y: myTasksConfirmOrder, color: sc.myTasks_confirmOrder })
  dataArr.push({ x: 'myTasks_pay', y: myTasksPay, color: sc.myTasks_pay })
  dataArr.push({
    x: 'myTasks_confirmGettingPaid',
    y: myTasksConfirmGettingPaid,
    color: sc.myTasks_confirmGettingPaid,
  })

  // Case 2
  // layout 2: ร้านฉันมี สินค้าอย่างน้อง 1 รายการ
  // ยืนยันราคา     4    ชำระ    5
  // ยืนยันรับชำระ 2    จัดส่ง   0
  if (summary.has('myTasks_ship')) {
    const myTasksShip = summary.get('myTasks_ship')
    dataArr.push({ x: 'myTasks_ship', y: myTasksShip, color: sc.myTasks_ship })
  }

  // Case 3
  // layout 3: myTasks_paySalesOrdersPaid กลับมาด้วย ใน summary
  // ยืนยันราคา     4     ชำระ
  // ยืนยันรับชำระ 2        พร้อมชำระต่อ   3
  // จัดส่ง   0                  อื่นๆ                 2
  if (summary.has('myTasks_paySalesOrdersPaid')) {
    const myTasksPaySalesOrdersPaid = summary.get('myTasks_paySalesOrdersPaid')
    const myTasksPayOther = myTasksPay && myTasksPaySalesOrdersPaid ? myTasksPay - myTasksPaySalesOrdersPaid : myTasksPay
    dataArr.push({
      x: 'myTasks_paySalesOrdersPaid',
      y: myTasksPaySalesOrdersPaid,
      isSubItem: true,
      isHighlight: myTasksPaySalesOrdersPaid > 0,
      color: sc.myTasks_paySalesOrdersPaid,
    })
    dataArr.push({ x: 'myTasks_payOther', y: myTasksPayOther, isSubItem: true, color: sc.myTasks_payOther })

    // Modifiy myTasks_pay invisible in donut
    dataArr[1].isHeaderItem = true
    dataArr[1].y = 0
    dataArr[1].y = 0
    dataArr[1].color = COLORS.TEXT_INACTIVE
  }
  return dataArr
}

export function getDonutOrderWaitingMeCount(data: ISummaryItem[]): number | null {
  if (!data || !_.isArray(data)) {
    return null
  }
  return data.reduce((prevValue, currentItem) => {
    if (currentItem.isHeaderItem) {
      return prevValue
    }
    return prevValue + currentItem.y
  }, 0)
}

export function isUsePaperangPrinting(selectedStore: ISelectedStoreMap): boolean {
  return !!(selectedStore.has('s_use_printing_paperang') && selectedStore.get('s_use_printing_paperang'))
}

export function isUseA4PDFPrinting(selectedStore: ISelectedStoreMap): boolean {
  return !!(selectedStore.has('s_use_printing_pdf') && selectedStore.get('s_use_printing_pdf'))
}

export function isUseBillPrinting(selectedStore: ISelectedStoreMap): boolean {
  return !!(selectedStore.has('s_use_printing_bill_paperang') && selectedStore.get('s_use_printing_bill_paperang'))
}

export function isUseStickerPDFPrinting(selectedStore: ISelectedStoreMap): boolean {
  return !!(selectedStore.has('s_use_printing_sticker_pdf') && selectedStore.get('s_use_printing_sticker_pdf'))
}

export function getAddresFormatLable(address: ISelectedAddresses | IAddress): string {
  let txtAddress = ''
  txtAddress = address.address1
  txtAddress = address.address2 ? `${txtAddress} ${address.address2}` : txtAddress
  txtAddress = address.sub_district ? `${txtAddress} ${address.sub_district}` : txtAddress
  txtAddress = address.district ? `${txtAddress} ${address.district}` : txtAddress
  txtAddress = address.province ? `${txtAddress} ${address.province}` : txtAddress
  txtAddress = address.postal_code ? `${txtAddress}\n${address.postal_code}` : txtAddress
  txtAddress = address.telephone ? `${txtAddress}\nโทร. ${address.telephone}` : txtAddress
  return txtAddress
}

interface ISubmitPrintingDocumentsOptions {
  printKey: PrintOptionKey
  presentMode?: PresentModeKey
  store_id: number
  order_ids: number[]
  billOptions?: {
    printing_type?: number
    size?: number
  }
  handleOpenPaperang?: (url: string) => void | Promise<void>
}

export async function submitPrintingDocuments(options: ISubmitPrintingDocumentsOptions) {
  const { printKey } = options
  // console.log('util.ts.submitPrintingDocuments.options => ', options)
  if (printKey === CONS.PRINT_OPTIONS.BILL_PAPERANG) {
    await handleSubmitPrintingOrdersBill(options)
  } else if (printKey === CONS.PRINT_OPTIONS.REPORT_PRODUCT_DAILY_SALES) {
    await handleSubmitPrintingOrdersReportProductDailySales(options)
  } else {
    await handleSubmitPrintingOrdersShippingLabel(options)
  }
}

async function handleSubmitPrintingOrdersBill(options: ISubmitPrintingDocumentsOptions) {
  const { printKey, presentMode, store_id, order_ids, billOptions = {}, handleOpenPaperang } = options
  const { printing_type = 2, size = 2 } = billOptions
  const url = getShippingLabelBillUrl({ store_id, order_ids, printing_type, size })
  if (JSON.stringify(printKey).includes(CONS.PRINT_OPTIONS.PAPERANG) && _.isFunction(handleOpenPaperang)) {
    handleOpenPaperang(url)
  } else {
    const formatWithLeadingZero = (number) => (number < 10 ? `0${number}` : number)
    const getCurrentDateTime = () => {
      const now = new Date()

      const year = now.getFullYear().toString().substr(-2) // Get the last two digits of the year
      const month = formatWithLeadingZero(now.getMonth() + 1) // Months are zero-based
      const day = formatWithLeadingZero(now.getDate())
      const hours = formatWithLeadingZero(now.getHours())
      const minutes = formatWithLeadingZero(now.getMinutes())
      const seconds = formatWithLeadingZero(now.getSeconds())

      let formattedDateTime = `${year}${month}${day}_${hours}${minutes}${seconds}`
      if (order_ids.length === 1) {
        formattedDateTime += `_${order_ids[0]}`
      }
      return formattedDateTime
    }
    const fileType = p.op.isWeb() ? 'pdf' : 'png'
    const name = order_ids.length > 1 ? 'orders_bills_' : 'orders_bill_'
    const fileName = `${name}${getCurrentDateTime()}.${fileType}`
    // console.log('fileName => ', fileName)
    p.op.openFileFromUrl({ url, fileName, fileType, presentMode })
  }
  p.op.aLogEvent(CONS.EVENT_NAME.RECEIPT_PPR, { s: store_id })
}

async function handleSubmitPrintingOrdersReportProductDailySales(options: ISubmitPrintingDocumentsOptions) {
  const { printKey, store_id, order_ids, billOptions = {}, handleOpenPaperang } = options
  const { printing_type = 2, size = 2 } = billOptions
  // @ts-ignore
  let url = getReportProductDailySalesExcelUrl({
    pp_ids: [], // FIXME: O: required ทำไมหว่า -_-?
    store_id,
    showUPC: false,
    showSKU: true,
    showPrice: false,
    showProfit: false,
    showOrderIDS: true,
  })

  const serialzedQueryParamsString = serializeObjectToQueryParamsString({ order_ids }, { removeArraySquareBrackets: true })
  if (serialzedQueryParamsString) {
    url = `${url}&${serialzedQueryParamsString}`
  }
  await p.op.openFileFromUrl({ url, fileName: 'product daily sales.xlsx', fileType: 'xlsx' })
}

async function handleSubmitPrintingOrdersShippingLabel(options: ISubmitPrintingDocumentsOptions) {
  const { printKey, presentMode, store_id, order_ids, handleOpenPaperang } = options

  const ppr = printKey === CONS.PRINT_OPTIONS.PAPERANG
  const sticker = printKey === CONS.PRINT_OPTIONS.STICKER_PDF

  const url = getShippingLabelPDFUrl({
    store_id,
    orders: order_ids,
    only_not_printed: false,
    limit: 50,
    // root4Go,
    isGoApi: true,
    paperang: ppr,
    sticker,
  })

  const nowDate = dayjs().format('YYYYMMDD_HHmmss')
  let fileName = order_ids.length > 1 ? `XSelly_ShippingLable_${nowDate}` : JSON.stringify(order_ids[0])
  if (_.includes([CONS.PRINT_OPTIONS.PAPERANG], printKey)) {
    fileName += '.png'
    if (_.isFunction(handleOpenPaperang)) {
      handleOpenPaperang(url)
    } else {
      await p.op.openFileFromUrl({ url, fileName, fileType: 'png', presentMode })
    }
    p.op.aLogEvent(CONS.EVENT_NAME.SHIPPING_LABLE_SINGLE_PPR, { s: store_id })
    // } else if (_.includes([CONS.PRINT_OPTIONS.A4_PDF, CONS.PRINT_OPTIONS.STICKER_PDF], printKey)) {
  } else {
    fileName += '.pdf'
    await p.op.openPdfFromUrl({ url, fileName, presentMode })
    p.op.aLogEvent(CONS.EVENT_NAME.SHIPPING_LABLE_SINGLE_A4, { s: store_id })
  }
}
// export async function channelsStatus(): Promise<boolean> {
//   const asd = true
//   return asd
// }
// asyncIfLoadingCompletedCallBack?: (channels: IMKPChannelDetail[]) => Promise<void> | null

export function channelsStatus(): 'DONT_HAVE_CHANNELS' | `LOADING` | `COMPLETED` {
  const state = p.op.getAppState()
  const selectedStore = getStoreSelected(state)
  const loadingInProgress = getLoadingInProgress(state)
  const isHasMKP = selectedStore.has(`has_mkp`)
  if (!isHasMKP) {
    return 'DONT_HAVE_CHANNELS'
  }
  const isChannelLoading = loadingInProgress.has(`channels`)
  if (isChannelLoading) {
    return `LOADING`
  }
  return `COMPLETED`
}

export async function getActionSheetAddOneProductToCartSelectedVariantIndex(params: {
  selectedProductListItem: IProductItemData
  store_id: number
  seller_store_id?: number
  ug_id?: number
  pg_ids?: number[]
  btnRef?: any
}) {
  const { selectedProductListItem, store_id, seller_store_id, ug_id, pg_ids, btnRef } = params
  const variants = selectedProductListItem.v || []
  // ถ้าไม่มีให้เลือก return null (ไม่มี index)
  if (variants.length === 0) {
    return null
  }
  // ถ้ามีแค่ 1 variant ให้เลือกไปเลย
  if (variants.length === 1) {
    return 0
  }

  // ถ้ามีหลาย variant ให้ show ActionSheet เพื่อเลือก variant
  const displayVariants: IProductItemVariantData[] = []
  const btnLabels = []
  variants.forEach((v) => {
    if (isSkipCheckEmptyProductStock() || v.q > 0) {
      const variantName = v.n
      // const variantPrice = seller_store_id ? v.p : v.s[0].p
      let variantPrice

      // แก้ปัญหา "ไม่มีรายการราคา" แล้วจะหยิบสินค้าเข้าตะกร้าไม่ได้ จึงปรับราคาเป็น 0 แทน undefined
      // ref https://app.clickup.com/t/3b44rz5
      if (seller_store_id) {
        variantPrice = !_.isNil(v.p) ? v.p : 0
        // if (!_.isNil(v.p)) {
        //   variantPrice = v.p
        // } else {
        //   variantPrice = 0
        //   variantName = `(ไม่ระบุราคา) ${variantName}`
        // }
      } else {
        variantPrice = _.isArray(v.s) && v.s.length > 0 && !_.isNil(v.s[0].p) ? v.s[0].p : 0
        // if (_.isArray(v.s) && v.s.length > 0 && !_.isNil(v.s[0].p)) {
        //   variantPrice = v.s[0].p
        // } else {
        //   variantPrice = 0
        //   variantName = `(ไม่ระบุราคา) ${variantName}`
        // }
      }

      const txtVariantPrice = `${variantName} ${fmt.formatCurrency(variantPrice)} (${v.q})`
      btnLabels.push(txtVariantPrice)
      // log('variantPrice, txtvariantPrice', variantPrice, txtVariantPrice)
      displayVariants.push(v)
    }
  })
  btnLabels.push('ยกเลิก')

  const cancelButtonIndex = btnLabels.length - 1
  let selectedDisplayedVariantIndex = -1

  // ถ้าเหลือ variant เดียวที่มี qty ก็ให้เลือกให้เลย
  if (displayVariants.length === 1) {
    selectedDisplayedVariantIndex = 0
  } else {
    selectedDisplayedVariantIndex = await new Promise<number>((selectIdx) => {
      p.op.showActionSheet(
        {
          buttonRef: p.op.isWeb() && btnRef ? btnRef : null,
          options: btnLabels,
          cancelButtonIndex,
          // destructiveButtonIndex: -1,
          title: `เพิ่ม ${getQuickAddProductQuantity()} ชิ้นในออเดอร์...`,
        },
        (buttonIndex: string | number) => {
          const idx = _.isString(buttonIndex) ? parseInt(buttonIndex) : buttonIndex
          selectIdx(idx)
        }
      )
    })
  }

  // ถ้าไม่ได้เลือกให้ index = -1
  if (selectedDisplayedVariantIndex === cancelButtonIndex) {
    return -1
  }

  if (!displayVariants[selectedDisplayedVariantIndex]) {
    return -1
  }

  const selectedVariantPPID = displayVariants[selectedDisplayedVariantIndex].i
  const selectedIndex = variants.findIndex((vItem) => vItem.i === selectedVariantPPID)

  return selectedIndex
}

export function getQuickAddProductQuantity() {
  return APP_CONFIG.order.create_order.quick_add_product_to_order_qty || 1 // + จาก mode ts จากของเดิม
}

export async function getPullProductParamsFromProductListItem(params: {
  selectedUserGroups: List<UserGroupMap>
  selectedProductListItem: IProductItemData | IProductDetailItem
  selectedVariantIndex: number
  store_id: number
  seller_store_id?: number
  ug_id?: number
  pg_ids?: number[]
  qty?: number
}) {
  const { selectedUserGroups, selectedProductListItem, selectedVariantIndex = null, store_id, seller_store_id, ug_id, pg_ids } = params
  if (!_.isNumber(selectedVariantIndex) || selectedVariantIndex < 0) {
    // required selected variant index
    return null
  }
  if (!store_id) {
    // required store_id
    return null
  }

  const isFullProductDetailItem = _.has(selectedProductListItem, 'name') && _.has(selectedProductListItem, 'description')
  // @ts-ignore
  let spi: IProductItemData = selectedProductListItem

  // console.log('getPullProductParamsFromProductListItem:: isFullProductDetailItem => ', isFullProductDetailItem)

  if (isFullProductDetailItem) {
    // @ts-ignore
    spi = convertFullProductDetailToShortProductListItem(selectedProductListItem)
  }

  // console.log('getPullProductParamsFromProductListItem:: spi => ', spi)

  const v = spi.v[selectedVariantIndex]
  if (!v) {
    // possibly cancel operation
    return null
  }

  const parent_store_id = spi.s ? spi.s : seller_store_id
  let cost = !_.isNil(v.c) ? parseFloat(v.c) : null
  const product_id = spi.id
  const name = spi.n
  const variant = v.n // variant name
  // const qty = 1 // +1 จากของเดิม
  const available_qty = v.q || 0
  const pp_id = v.i
  const h = v.h ? v.h : null
  let thumbnail_uris = spi.t
  // const h = spi.h ? spi.h : null

  if (v.img_url) {
    thumbnail_uris = [v.img_url]
  }

  // const price = parseFloat(v.p)
  // const price_rate_value = parseFloat(v.p)
  // const price_rate_type = 1

  // FIXME: Implement VDs
  // @ts-ignore FIXME: declare my type please
  const { my_vds } = spi
  // @ts-ignore FIXME: declare my type please
  const { my_vds_type } = spi
  // @ts-ignore FIXME: declare my type please
  const { seller_vds } = spi
  // @ts-ignore FIXME: declare my type please
  const { seller_vds_type } = spi

  let price = null // to be compute
  let pg_id = null // to be compute
  let ugpgSaleDiscountAmount = null // to be compute
  let ugpgSaleDiscountPercent = null // to be compute

  const productDiscount = spi.pdc
  // @ts-ignore force parse value
  const ugpgPurchaseDiscountAmount = productDiscount && productDiscount.ua ? parseFloat(productDiscount.ua) : null
  // @ts-ignore force parse value
  const ugpgPurchaseDiscountPercent = productDiscount && productDiscount.up ? parseFloat(productDiscount.up) : null

  let hasEmptyPrice = false

  if (seller_store_id) {
    // ถ้าเปิดด้วยสินค้าของร้านขายส่ง
    price = v.p ? parseFloat(v.p) : null
    // log('####pullProductToOrder.price', price)
    cost = price
  } else {
    // ถ้าเปิดด้วยสินค้าของร้านฉัน
    // const prices = v.s
    // if (!prices || !List.isList(prices) || prices.size < 1) { // should be impossible case
    //   p.op.alert('สินค้าชิ้นนี้ไม่มีราคา', 'กรุณาระบุราคาของสินค้าชิ้นนี้ก่อนใช้เปิดออเดอร์')
    //   return
    // }
    let prices = v.s
    if (!prices || !_.isArray(prices) || prices.length < 1) {
      // should be impossible case
      prices = []
    }

    price = _.has(prices, [0, 'p']) ? parseFloat(prices[0].p) : null
    if (!price) {
      price = v.p ? parseFloat(v.p) : null
    }
    pg_id = _.has(prices, [0, 'g']) ? prices[0].g : null
    // if (_.isNull(price) || _.isUndefined(price) || !pg_id) {
    if (_.isNull(price) || _.isUndefined(price)) {
      // p.op.alert('ไม่พบราคาสินค้าชิ้นนี้', 'กรุณาระบุราคาของสินค้าชิ้นนี้ก่อนใช้เปิดออเดอร์')
      // return
      // const isUserConfirmed = await p.op.isUserConfirm('ไม่พบราคาสินค้าชิ้นนี้', 'กรุณายืนยันว่าจะให้จะหยิบสินค้าเข้าออเดอร์แล้วกำหนดราคาไว้ ฿0 โดยคุณสามารถปรับราคาได้ภายหลัง')
      const txtProductName = variant ? `${name} ${variant}` : name
      const isUserConfirmed = await p.op.isUserConfirm(
        'ไม่พบราคาสินค้า',
        `กรุณายืนยันว่าจะให้จะหยิบสินค้า "${txtProductName}" เข้าสู่ออเดอร์แล้วกำหนดราคาไว้ ฿0 โดยคุณสามารถปรับราคาได้ภายหลัง`
      )
      if (!isUserConfirmed) {
        return
      }
      price = 0
      hasEmptyPrice = true
    }

    if (ug_id && pg_id) {
      // ถ้ามีการเลือกเปิดโดย UG มา และมี pg_id สำหรับคิดส่วนลด
      const focusedUserGroup = selectedUserGroups.find((ug) => Map.isMap(ug) && ug.get('id') === ug_id)
      if (!Map.isMap(focusedUserGroup) || !focusedUserGroup.get('id')) {
        p.op.alert('ไม่พบข้อมูลกลุ่มสมาชิก', 'กรุณาลองใหม่อีกครั้ง') // should be impossible case
        return
      }
      const discountRelations = focusedUserGroup.get('pgs') // discount relation
      // @ts-ignore
      const focusedDiscount: any = discountRelations.find((pgd: Map<string, any>) => Map.isMap(pgd) && pgd.get('id') === pg_id)
      if (Map.isMap(focusedDiscount)) {
        ugpgSaleDiscountAmount = focusedDiscount.get('discount_amount') ? parseFloat(focusedDiscount.get('discount_amount')) : null
        ugpgSaleDiscountPercent = focusedDiscount.get('discount_percent') ? parseFloat(focusedDiscount.get('discount_percent')) : null
      }
    } else if (_.isArray(pg_ids) && pg_ids.length > 0) {
      // TODO: ตอนนี้ยังไม่มีส่วนลดของ PG โดดๆ อนาคตมีก็มา compute ตรงนี้
    }
  }

  const willPullToOrderProduct = {
    variant,
    cost,
    product_id,
    name,
    qty: params.qty || getQuickAddProductQuantity(), // + จาก mode ts จากของเดิม
    available_qty,
    pp_id,
    price,
    price_rate_value: hasEmptyPrice ? -1.33 : price, // default price ถ้าถูก user เปลี่ยน จะทำให้หน้าบ้านส่ง custom price ไป
    price_rate_type: 1, // default mode
    thumbnail_uris,
    h,
    parent_store_id,

    // FIXME: Maybe use in when Enable Vds in version 2.1
    my_vds,
    my_vds_type,
    seller_vds,
    seller_vds_type,

    // for create api body with pg_id
    ug_id,
    pg_id,

    // for compute real-time discount
    ugpgPurchaseDiscountAmount, // discount per each
    ugpgPurchaseDiscountPercent, // discount per each
    ugpgSaleDiscountAmount, // discount per each
    ugpgSaleDiscountPercent, // discount per each
  }
  return willPullToOrderProduct
}

export function convertFullProductDetailToShortProductListItem(pd: IProductDetailItem): IProductItemData {
  let isZeroWeight = true
  let totalAvailableQty = 0
  const svs: IProductItemVariantData[] = pd.variants.map((vd) => {
    const sv: IProductItemVariantData = {
      i: vd.pp_id,
      n: vd.name,
      c: vd.cost,
      // @ts-ignore
      p: vd.price || '0.00',
      q: vd.available_qty,
    }

    if (vd.prices) {
      sv.s = vd.prices.map((vps) => ({
        // string of currency price
        p: vps.price,
        // product group id
        g: vps.pg_id,
      }))
    }

    if (vd.h) {
      sv.h = vd.h
    }

    totalAvailableQty += vd.available_qty
    if (vd.weight) {
      isZeroWeight = false
    }

    return sv
  })

  const ps: IProductItemData = {
    id: pd.id,
    n: pd.name,
    t: pd.thumbnail_uris,
    // string of currency min price
    i: pd.min,
    // string of currency max price
    x: pd.max,
    // total available_qty
    v: svs,
    q: totalAvailableQty,
  }

  if (!pd.parent_id) {
    ps.m = 1 // is My Product
  }

  if (pd.parent_store_id) {
    ps.s = pd.parent_store_id
  }

  if (isZeroWeight) {
    ps.z = 1
  }

  console.log('convertFullProductDetailToShortProductListItem:: ps => ', ps)

  return ps
}

export function isPackFreeAndSelectedStoreOwner() {
  return acl.packFree() && acl.isSelectedStoreOwner()
}

export function getTimeFormathhmm(dateTime: Date): string {
  let hours = dateTime.getHours().toString()
  if (Number(hours) < 10) {
    hours = `0${hours}`
  }
  let minutes = dateTime.getMinutes().toString()
  if (Number(minutes) < 10) {
    minutes = `0${minutes}`
  }
  return `${hours}:${minutes}`
}

// checkHasMoreMinutesTime ถ้า dateTimeOne มีนาทีเยอะกว่าหรือเท่ากับ dateTimeTwo จะ return true
export function checkHasMoreMinutesTime(dateTimeOne: Date, dateTimeTwo: Date): boolean {
  const one = `${getDateFormatYYYYMMDD()} ${getTimeFormathhmm(dateTimeOne)}:00`
  const two = `${getDateFormatYYYYMMDD()} ${getTimeFormathhmm(dateTimeTwo)}:00`
  const DATETIME_ONE = moment(one)
  const DATETIME_TWO = moment(two)

  const result = DATETIME_ONE.diff(DATETIME_TWO, 'minutes')
  if (result >= 0) {
    return true
  }
  return false
}

export function getMKPChannels(): IMKPChannelDetail[] {
  const selectedStore = getStoreSelected(p.op.getAppState())
  return isImmutable(selectedStore.get('channels')) ? selectedStore.get('channels').toJS() : selectedStore.get('channels')
}

export function isMkpChannelExist(mkpChannelId: number) {
  const mkpChannels = getMKPChannels()

  const foundIdx = mkpChannels.findIndex((mkpc) => mkpc.id === mkpChannelId)
  if (foundIdx >= 0) {
    return true
  }

  return false
}

export function getMKPChannelByUGID(ugid: number): IMKPChannelDetail {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const channels = isImmutable(selectedStore.get('channels')) ? selectedStore.get('channels').toJS() : selectedStore.get('channels')
  if (_.isNil(channels) || !_.isArray(channels) || channels.length < 1) {
    return null
  }
  return _.find(channels, (ch: IMKPChannelDetail) => ch.id === ugid)
}

export function isUseMKPChannels(): IMKPChannelDetail[] {
  const selectedStore = getStoreSelected(p.op.getAppState())
  return selectedStore.has('has_mkp') && selectedStore.get('has_mkp')
}

export function getSubscriptionFromRedux(): any {
  return getSubscription(p.op.getAppState())
}

export function getSelectedProductFromRedux(): any {
  return getSelectedProduct(p.op.getAppState())
}

export function isSomSaiOrgOwner(): any {
  const selectedStore = getSubscriptionFromRedux()
  const isHaveOrg = selectedStore.has(`org`) && selectedStore.get(`org`).size > 0
  let isOrgOwner = false
  if (isHaveOrg) {
    isOrgOwner = isOrgOwnerStore(selectedStore)
  }
  return isHaveOrg && isOrgOwner
}

export function isSomSaiApp(): any {
  return APP_CONFIG.app_name === CONS.APP_CONFIG_NAMES.SOMSAI
}

export function isXSellyErrorResponse(errorResponseObj: IXSellyErrorResponse | { [key: string]: any }): boolean {
  if (errorResponseObj && errorResponseObj.error) {
    return _.isNumber(errorResponseObj.error.status_code) && _.isString(errorResponseObj.error.error_code)
  }
  return false
}

function isSingleNumericString(str: string) {
  if (!_.isString(str)) {
    return false
  }
  return /^\d$/.test(str)
}

export function isXSellyErrorV1(errorResponseObj: IXSellyErrorResponse): boolean {
  if (!isXSellyErrorResponse(errorResponseObj)) {
    return false
  }
  const errorCode = errorResponseObj.error.error_code
  return isSingleNumericString(errorCode[0])
}

function isSingleEnglishString(str: string) {
  if (!_.isString(str)) {
    return false
  }
  return /^[a-zA-Z]$/.test(str)
}

export function isXSellyErrorV2(errorResponseObj: IXSellyErrorResponse): boolean {
  if (!isXSellyErrorResponse(errorResponseObj)) {
    return false
  }
  const errorCode = errorResponseObj.error.error_code
  // Note:: จริงๆ Error V2 ควรเช็คด้วย isSingleEnglishString เพียงอย่างเดียว
  // แต่มี custom error ที่ดักด้วย error code V1 รวมอยู่ใน translated object ด้วย
  // จึงต้องอลุ่มอล่วยให้ V1 ส่วนนั้นถือเป็น V2 ด้วย โดยเช็คด้วย isSingleNumericString
  return isSingleEnglishString(errorCode[0]) || isSingleNumericString(errorCode[0])
}

export function parseXSellyErrorToMessageText(xsellyErrorObj: IXSellyError): string {
  const errCode = xsellyErrorObj.error_code
  const msgText = parseXSellyErrorKeyToMessageText(errCode)
  // console.log('parseXSellyErrorToMessageText errCode => ', errCode)
  // console.log('parseXSellyErrorToMessageText msgText => ', msgText)

  if (!msgText) {
    // ถ้าไม่มี error code ใน translated file ให้ return error_code ออกไปตรงๆ
    return `กรุณาติดต่อทีมงาน (${errCode})`
  }
  return msgText
}

export function parseXSellyErrorKeyToMessageText(errorCode: string): string | null {
  // const eMsgTranslated = p.op.t('e_msg_by_error_code')
  const eMsgTranslated = p.op.getTranslatorObj()
  // console.log('parseXSellyErrorKeyToMessageText eMsgTranslated => ', eMsgTranslated)

  if (!(errorCode in eMsgTranslated.e_msg_by_error_code) || !_.has(eMsgTranslated.e_msg_by_error_code[errorCode], 'm')) {
    // ถ้าไม่มี error code ใน translated file ให้ return null
    return null
  }
  // return p.op.ot((i18) => i18.e_generals[errorCode])
  return p.op.t(`e_msg_by_error_code.${errorCode}.m`)
}

export function parseXSellyErrorToTitleText(xsellyErrorObj: IXSellyError): string {
  const errCode = xsellyErrorObj.error_code
  const titleText = parseXSellyErrorKeyToTitleText(errCode)
  if (!titleText) {
    // ถ้าไม่มี error code ใน translated file ให้ return error_code ออกไปตรงๆ
    return `เกิดข้อผิดพลาด`
  }
  return titleText
}

export function parseXSellyErrorKeyToURL(errorCode: string): string | null {
  const eMsgTranslated = p.op.getTranslatorObj()
  if (!(errorCode in eMsgTranslated.e_msg_by_error_code) || !_.has(eMsgTranslated.e_msg_by_error_code[errorCode], 'cu')) {
    // ถ้าไม่มี error code ใน translated file ให้ return null
    return null
  }
  // if (eMsgTranslated.e_msg_by_error_code[errorCode].cu == null) {
  //   // handle the case where "cu" is specified but "null"
  //   return null
  // }
  return p.op.t(`e_msg_by_error_code.${errorCode}.cu`)
}

export function parseXSellyErrorToURL(xsellyErrorObj: IXSellyError): string {
  const errCode = xsellyErrorObj.error_code
  const titleText = parseXSellyErrorKeyToURL(errCode)
  // if (!titleText) {
  //   // ถ้าไม่มี error code ใน translated file ให้ return error_code ออกไปตรงๆ
  //   return `เกิดข้อผิดพลาด`
  // }
  return titleText
}

export function parseXSellyErrorKeyToURLText(errorCode: string): string | null {
  const eMsgTranslated = p.op.getTranslatorObj()
  if (!(errorCode in eMsgTranslated.e_msg_by_error_code) || !_.has(eMsgTranslated.e_msg_by_error_code[errorCode], 'ct')) {
    // ถ้าไม่มี error code ใน translated file ให้ return null
    return null
  }
  // if (eMsgTranslated.e_msg_by_error_code[errorCode].cu == null) {
  //   // handle the case where "cu" is specified but "null"
  //   return null
  // }
  return p.op.t(`e_msg_by_error_code.${errorCode}.ct`)
}

export function parseXSellyErrorToURLText(xsellyErrorObj: IXSellyError): string {
  const errCode = xsellyErrorObj.error_code
  const titleText = parseXSellyErrorKeyToURLText(errCode)
  // if (!titleText) {
  //   // ถ้าไม่มี error code ใน translated file ให้ return error_code ออกไปตรงๆ
  //   return `เกิดข้อผิดพลาด`
  // }
  return titleText
}

export function parseXSellyErrorKeyToTitleText(errorCode: string): string | null {
  const eMsgTranslated = p.op.getTranslatorObj()
  if (!(errorCode in eMsgTranslated.e_msg_by_error_code) || !_.has(eMsgTranslated.e_msg_by_error_code[errorCode], 't')) {
    // ถ้าไม่มี error code ใน translated file ให้ return null
    return null
  }
  if (eMsgTranslated.e_msg_by_error_code[errorCode].t == null) {
    // handle the case where "t" is specified but "null"
    return null
  }
  return p.op.t(`e_msg_by_error_code.${errorCode}.t`)
}

export function alertWithXSellyErrorV2(xsellyErrorObj: IXSellyError) {
  p.op.alert('เกิดข้อผิดพลาด', parseXSellyErrorToMessageText(xsellyErrorObj))
}

export async function bgSyncStatus(
  callerObj: IBgSyncStatusManager,
  body: any,
  fetchIntervalSecond = 5000,
  timeout = 60000,
  callbackNotFoundKeyInJobs: (key: 'PRODUCT' | 'ORDER', value: boolean) => void,
  timeOutCallBack?: () => void
) {
  let isEndForLoop = false
  let i = 0
  await new Promise(async (resolve) => {
    // Set Time Out
    setTimeout(() => {
      // ถ้าจบ loop แล้ว ไม่ต้องสั่ง timeOutCallBack
      if (isEndForLoop) {
        resolve(null)
      } else {
        isEndForLoop = true
        timeOutCallBack()
        resolve(null)
      }
    }, timeout)

    for (isEndForLoop; !isEndForLoop; i++) {
      const response: IBackgroundJobListResponse = await api.postV2(api.POST_BACKGROUND_JOB_LIST, body)

      // console.log(' I => ', i)
      // console.log('response => ', response)
      if (!_.isNil(response.jobs) && (_.isNil(response.count) || response.count < 1)) {
        if (!_.isNil(callerObj) && _.isFunction(callerObj.successCallback)) {
          callerObj.successCallback(response)
          resolve(null)
          isEndForLoop = true
          break
        }
      }

      const JOBS = response.jobs
      let isHasProductJob = false
      let isHasOrderJob = false
      JOBS.forEach((job) => {
        if (job.t === 'mkp.sync.product') {
          isHasProductJob = true
        }
        if (job.t === 'mkp.sync.order') {
          isHasOrderJob = true
        }
      })

      // ถ้าอันไหนเสร็จไม่เสร็จก็ส่ง callback กลับไปบอก view
      if (_.isFunction(callbackNotFoundKeyInJobs)) {
        callbackNotFoundKeyInJobs('PRODUCT', isHasProductJob)
        callbackNotFoundKeyInJobs('ORDER', isHasOrderJob)
      }

      // console.log(' --- 01 --- ', fetchIntervalSecond)
      await delay(fetchIntervalSecond)
      // console.log(' --- 02 --- ', callerObj.shouldStopLooping())
      if (!_.isNil(callerObj) && _.isFunction(callerObj.shouldStopLooping)) {
        if (callerObj.shouldStopLooping()) {
          resolve(null)
          isEndForLoop = true
          break
        }
      }
      if (isEndForLoop) {
        break
      }
    }
  })
  // หลัง resolve สั่งหยุด loop => isEndForLoop
  isEndForLoop = true
  // console.log(' !! END FUNCTION !!')
}

export async function updateMKPChannelsRedux(channel: IMKPChannelDetail) {
  const channels: IMKPChannelDetail[] = getMKPChannels()
  let newChannels: IMKPChannelDetail[] = []
  if (_.isNil(channels) || !_.isArray(channels)) {
    return
  }
  if (channels.length === 1) {
    newChannels.push(channel)
  } else {
    const findChannelById = _.find(channels, (ch: IMKPChannelDetail) => ch.id === channel.id)
    if (_.isNil(findChannelById)) {
      newChannels = channels
      newChannels.push(channel)
    } else {
      channels.map((ch: IMKPChannelDetail) => {
        if (ch.id === channel.id) {
          newChannels.push(channel)
        } else {
          newChannels.push(ch)
        }
      })
    }
  }
  return newChannels
}

export function canHelperPrintShippingLabel(): boolean {
  const owner = acl.isSelectedStoreOwner()
  if (!owner) {
    const isCanDo = acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.ORDER_PRINT_SHIPPING)
    if (!isCanDo) {
      return false
    }
  }
  return true
}

export function canHelperEditProductStock(): boolean {
  const owner = acl.isSelectedStoreOwner()
  if (!owner) {
    const isCanDo = acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.PRODUCT_STOCK_EDIT)
    if (!isCanDo) {
      return false
    }
  }
  return true
}

export function hasHelperPermission(perm: HelperPermissionType) {
  const isOwner = acl.isSelectedStoreOwner()
  if (isOwner) {
    return true
  }
  return acl.canDoAtSelectedStore(perm)
}

export function hasHelperPermissions(perms: HelperPermissionType[]) {
  const isOwner = acl.isSelectedStoreOwner()
  if (isOwner) {
    return true
  }
  return perms.reduce((prevPerm, focusPerm) => prevPerm && acl.canDoAtSelectedStore(focusPerm), true)
}

export function warningHelperDontHavePermission() {
  p.op.showConfirmationOkOnly('ไม่ได้รับสิทธิ์', 'คุณไม่ได้รับสิทธิ์ในการใช้งานส่วนนี้ กรุณาติดต่อผู้ดูแลของท่านเพื่อขอรับสิทธิ์')
}

export function changeSecondTime<T = Dayjs | Moment>(dateTime: T, second: number): T {
  if (dateTime instanceof dayjs) {
    // @ts-ignore
    return dayjs(dateTime as Dayjs).set('seconds', second)
  }
  // @ts-ignore
  return moment(dateTime as Moment).seconds(second)
}

export function changeMillisecondsTime<T = Dayjs | Moment>(dateTime: T, milliseconds: number): T {
  if (dateTime instanceof dayjs) {
    // @ts-ignore
    return dayjs(dateTime as Dayjs).set('milliseconds', milliseconds)
  }
  // @ts-ignore
  return moment(dateTime as Moment).milliseconds(milliseconds)
}

export function getDateRangeFromOption(optKey: IXDateRangeSelectorOptionKey): IDateRange | null {
  const now = dayjs()
  const dr: IDateRange = {
    begin: now.clone(),
    end: now.clone(),
  }

  switch (optKey) {
    case CONS.DATERANGE_SELECTOR.OPTION.Today: {
      dr.begin = now.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Yesterday: {
      const yesterday = now.clone().subtract(1, 'days')
      dr.begin = yesterday.clone().startOf('day')
      dr.end = yesterday.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Last7Days: {
      const last7date = now.clone().subtract(6, 'days')
      dr.begin = last7date.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Last30Days: {
      const last30date = now.clone().subtract(29, 'days')
      dr.begin = last30date.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Last45Days: {
      const last45date = now.clone().subtract(44, 'days')
      dr.begin = last45date.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Last60Days: {
      const last60date = now.clone().subtract(59, 'days')
      dr.begin = last60date.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Last90Days: {
      const last90date = now.clone().subtract(89, 'days')
      dr.begin = last90date.clone().startOf('day')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.ThisWeekStartWithSun: {
      // dr.begin = now.clone().startOf('week')
      // dr.end = now.clone().endOf('week')
      dr.begin = now.clone().startOf('week')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.ThisWeekStartWithMon: {
      // dr.begin = now.clone().startOf('isoWeek')
      // dr.end = now.clone().endOf('isoWeek')
      dr.begin = now.clone().startOf('isoWeek')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.LastWeekStartWithSun: {
      const lastWeekDate = now.clone().subtract(1, 'weeks')
      dr.begin = lastWeekDate.clone().startOf('week')
      dr.end = lastWeekDate.clone().endOf('week')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.LastWeekStartWithMon: {
      const lastWeekDate = now.clone().subtract(1, 'weeks')
      dr.begin = lastWeekDate.clone().startOf('isoWeek')
      dr.end = lastWeekDate.clone().endOf('isoWeek')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.ThisMonth: {
      // dr.begin = now.clone().startOf('month')
      // dr.end = now.clone().endOf('month')
      dr.begin = now.clone().startOf('month')
      dr.end = now.clone().endOf('day')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.LastMonth: {
      const lastMonthDate = now.clone().subtract(1, 'months')
      dr.begin = lastMonthDate.clone().startOf('month')
      dr.end = lastMonthDate.clone().endOf('month')
      break
    }
    case CONS.DATERANGE_SELECTOR.OPTION.Custom: {
      return null
      // break
    }
    default:
      return null
  }

  return dr
}

export function getBgJobTypeText(bgJobType: BackgroundJobTypeType) {
  if (typeof CONS.BGJOB_TYPE_MAPTEXT[bgJobType] === 'string') {
    return CONS.BGJOB_TYPE_MAPTEXT[bgJobType]
  }
  return bgJobType
}

export function isJsonString(str: string) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export function getBgTaskErrorText(taskErrorCode: string) {
  // if (typeof CONS.BGTASK_ERROR_MAPTEXT[taskErrorCode] === 'string') {
  //   return CONS.BGTASK_ERROR_MAPTEXT[taskErrorCode]
  // }
  if (_.isString(taskErrorCode)) {
    const msgText = parseXSellyErrorKeyToMessageText(taskErrorCode)
    if (_.isString(msgText)) {
      return msgText
    }
  }

  if (isJsonString(taskErrorCode)) {
    const errObj = JSON.parse(taskErrorCode)
    if (isXSellyErrorResponse(errObj) && errObj.error.error_code) {
      const errorCode = errObj.error.error_code
      // try to get the error message from the th.ts first
      const title = p.op.t(`e_msg_by_error_code.${errorCode}.t`)
      const msg = p.op.t(`e_msg_by_error_code.${errorCode}.m`)
      if (title || msg) {
        return `${title} ${msg}`
      }
      // if (errorCode === '10_028') {
      //   return 'กรุณาตรวจสอบคลังสินค้า เนื่องจากสินค้าหมดสต๊อก'
      // }
    }
  }

  return taskErrorCode
}

// Translate the error_code's value i.e. 10_028 into a translated message in th.ts
// {
//   "error": {
//     "status_code": 400,
//     "error_code": "10_028",
//     "message": "1980622"
//   }
// }
export function getBgTaskJSONErrorText(taskErrorJson: any) {
  const errObj = taskErrorJson
  if (isXSellyErrorResponse(errObj) && errObj.error.error_code) {
    const errorCode = errObj.error.error_code
    return p.op.t(`e_msg_by_error_code.${errorCode}.m`)
  }

  return null
}

export function isXSellyApiErrorCode(errorCode: string) {
  if (!_.isString(errorCode)) {
    return false
  }

  const regex = /^\d{2}_\d{3}$/
  return regex.test(errorCode)
}

export function getErrorMessageFromErrorResponse(err: IXSellyErrorResponse) {
  if (!isXSellyErrorResponse(err)) {
    return {
      statusCode: -1,
      statusMessage: JSON.stringify(err),
    }
  }

  let mm = null
  if (isXSellyErrorV1(err)) {
    // ถอด generic error V1
    // FIXME: ใช้ประโยชน์จากฟังก์ชั่นเก่าโดยไม่สนใจ path (เนื่องจากมี specific case ด้านบนมากพอแล้ว)
    //  @ts-ignore
    const { title = null, msg = null } = getErrMessageObj(err, '') || {}
    mm = msg
  }

  if (isXSellyErrorV2(err)) {
    // ถอด generic eror V1
    mm = parseXSellyErrorToMessageText(err.error)
  }

  return {
    statusCode: err.error.status_code ? err.error.status_code : 0,
    statusMessage: mm || `Unknown Error: ${err.error.error_code}`,
  }
}

export async function showAlertFetchError(fetchErrorMessage: { statusCode: number; statusMessage: string }) {
  const errMessage = `${fetchErrorMessage.statusCode} ${fetchErrorMessage.statusMessage}`
  const isUserConfirm = await p.op.isUserConfirm(
    'เกิดข้อผิดพลาดในการโหลดข้อมูล',
    `${errMessage}\n\nกรุณาคิดลอกข้อผิดพลาดส่งมาให้ทีมงาน หากไม่ได้รับความสะดวกในการใช้งาน`,
    'คัดลอกข้อผิดพลาด',
    'ปิด'
  )
  if (isUserConfirm) {
    Clipboard.setString(errMessage)
    p.op.showToast(`คัดลอก ${errMessage} แล้ว`, 'success')
  }
}
/*
export async function hasShipjungSystemID() {
  // TODO: Keng fix this
  const selectedStore = getSelectedStore(p.op.getAppState())
  const xshippings = selectedStore.get('xshippings')
  if (_.isNil(xshippings) || xshippings.size < 1) {
    return false
  }
  const xshippingJS = xshippings.toJS()
  const shipjungSystemId = getShipjungSystemID()
  const response = await new Promise((resolve) => {
    for (let i = 0; i < xshippingJS.length; i++) {
      if (xshippingJS[i].system_id === shipjungSystemId) {
        resolve(true)
        return
      }
    }
    resolve(false)
  })
  return response
}
*/
export async function getShipjungSystemID() {
  return CONS.SYSTEM_ID.SHIPJUNG
}

export function hasShipjungShipping() {
  const xShippingConfig = getXShippingConfigFromRedux(p.op.getAppState())
  if (_.isNil(xShippingConfig) || xShippingConfig.length < 1) {
    return false
  }
  // console.log('hasShipjungShipping:: xShippingConfig => ', xShippingConfig)
  const hasShipjung = xShippingConfig.some((config: IXShippingConfig) => config.system_id === CONS.SYSTEM_ID.SHIPJUNG)
  // console.log('hasShipjungShipping:: hasShipjung => ', hasShipjung)
  return hasShipjung
  /*
  const selectedStore = getStoreSelected(p.op.getAppState())
  const xshippings = selectedStore.get('xshippings')
  if (_.isNil(xshippings) || _.isNil(xshippings.xshippingConfig) || xshippings.xshippingConfig.size < 1) {
    console.log('hasShipjungShipping:: xshippings.xshippingConfig.size < 1')
    return false
  }
  const xshippingJS = xshippings.xshippingConfig.toJS()
  console.log('hasShipjungShipping:: xshippingJS => ', xshippingJS)
  let hasShipjung = false
  for (let i = 0; i < xshippingJS.length; i++) {
    if (xshippingJS[i].system_id === CONS.SYSTEM_ID.SHIPJUNG) {
      hasShipjung = true
      break
    }
  }
  return hasShipjung
  */
}

type ICheckMkpProductVariantsMappingErrorOutput = 'ONLY_ONE_VARAINT' | 'LESSER_CORE_VARIANTS'
export function checkMkpProductVariantsMappingError(
  mkpProduct: IMkpProductDetail,
  coreProduct: IProductDetailItem
): ICheckMkpProductVariantsMappingErrorOutput | null {
  if (coreProduct.variants.length < 2) {
    return 'ONLY_ONE_VARAINT'
  }

  if (coreProduct.variants.length < mkpProduct.variants.length) {
    return 'LESSER_CORE_VARIANTS'
  }

  return null
}

interface ICheckAvailableBackgroundJobArgType {
  store_id: number
  bgJobType: BackgroundJobTypeType
  jobLimit?: number // default is 1
}

interface ICheckAvailableBackgroundJobOutput {
  isAvailable: boolean
  bgJobResponse?: IBackgroundJobListResponse
}

// // checkAvailableBackgroundJobType ทำการเช็ค bgjob ด้วย type ว่ามี inprocess อยู่รึเปล่า
// // ตัวอย่างการใช้งาน
// async function _navToAutoCompletePaymentMultiOpWithBgJobCheck() {
//   try {
//     const { isAvailable, bgJobResponse } = await checkAvailableBackgroundJobType({
//       bgJobType: 'payment.create',
//       store_id: selectedStoreId,
//     })
//     if (isAvailable) {
//       await _doNavAction(
//         // NAV_TO_BGJOB_VIEW
//         NavActions.navToBackgroundJobInProcessByTypeView({
//           storeId: selectedStoreId,
//           initBgJobResponse: bgJobResponse,
//         })
//       )
//       return
//     }
//   } catch (err) {
//     console.log('_navToAutoCompletePaymentMultiOpWithBgJobCheck err => ', err)
//   }
//   await NAV_TO_TARGET
// }
export async function checkAvailableBackgroundJobType(
  arg: ICheckAvailableBackgroundJobArgType
): Promise<ICheckAvailableBackgroundJobOutput> {
  const { store_id, bgJobType, jobLimit = 1 } = arg
  const requestBody = {
    store_id,
    offset: 0,
    limit: 10,
    return_count: true,
    // created_within_mins: 10080,
    status: 'inprocess',
    types: [bgJobType],
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      retry: 0,
      timeout: 60000,
    },
    isErrorAlertDisabled: true,
    isApiV2: true,
  }

  try {
    const bgJobResponse = await api.post(api.POST_BACKGROUND_JOB_LIST, requestBody, apiOptions)
    // console.log('doFetchProducts res => ', res)
    if (typeof bgJobResponse.count === 'number') {
      const jobCount = bgJobResponse.count
      if (jobCount < jobLimit) {
        return { isAvailable: true, bgJobResponse }
      }
    }
  } catch (err) {
    // console.log('fetchBgJobs err => ', err)
    throw err
  }
  return { isAvailable: false }
}

export function getAllMultiOpModes() {
  return Object.keys(CONS.MULTI_OP_MODES).map((k) => CONS.MULTI_OP_MODES[k])
}

interface IAlertWithNavToBgJobListViewParams {
  title: string
  message: string
  dispatch: NavigationDispatch
  selectedStoreId: number
  initBgJobUUID?: string
  onUserConfirm?: () => void
}
export async function alertWithNavToBgJobListView(params: IAlertWithNavToBgJobListViewParams) {
  const { title, message, dispatch, selectedStoreId, onUserConfirm, initBgJobUUID = null } = params
  const isUserConfirm = await p.op.isUserConfirm(title, message, 'ปิด', 'ดูคิวคำสั่งงาน')
  if (_.isFunction(onUserConfirm)) {
    onUserConfirm()
    await delay(100)
  }
  if (!isUserConfirm) {
    dispatch(NavActions.navToBackgroundJobListView({ storeId: selectedStoreId, initWithJobUUID: initBgJobUUID }))
  }
}

export function filterPaymentAccountPickerExcludeDefault(pa: IPaymentAccount) {
  if (isSystemBankID(pa.bank_id)) {
    return false
  }
  return true
}

/**
 * Returns `true` if the specified `targetVal` is found in the value of the map
 * Note: This func is not suitable for large map as the loop will continue thru the end even though
 * the targetVal is found early in the loop
 * @param map
 * @param targetVal
 */
const doesMapContainVal = (map, targetVal) => {
  let isTargetValFound = false
  // Has to loop all items as we can't break the loop once found. Hence this function is good for small list
  _.map(CONS.SYSTEM_BANK_IDS, (val, key) => {
    if (val === targetVal) {
      isTargetValFound = true
    }
  })
  return isTargetValFound
}

export function isSystemBankID(bankId: number) {
  return doesMapContainVal(CONS.SYSTEM_BANK_IDS, bankId)
}

export function getBankNameFromBankID(bankId: number) {
  const foundBank = CONS.BANK_INFO.find((bi) => bi.id === bankId)
  return _.isObject(foundBank) && _.isString(foundBank.name) ? foundBank.name : null
}

export function isVerifySlipBankID(bankId: number) {
  // https://dd.xselly.com/doc/verify-slip-bank_id-edN1avFrSj
  return _.includes([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 22, 23, 24, 33, 39, 40, 41], bankId)
}

export function convertVerifySlipBankCodeToBankId(bankCode: string) {
  return CONS.VERIFY_SLIP_BANK_CODE_TO_BANK_ID[bankCode]
}

export function getPriceNameTextByPgId(pgId: number): string | null {
  const state = p.op.getAppState()
  const productGroups = getSelectedStoreProductGroups(state)
  const foundPg = productGroups.find((pg) => pg.get('id') === pgId)
  if (foundPg) {
    return foundPg.get('name')
  }
  return null
}

export function getWarehouseNameTextByWhId(whId: number): string | null {
  const state = p.op.getAppState()
  const warehouses = getSelectedStoreWarehouses(state)

  const warehouseSize = warehouses.size || 1
  if (warehouseSize === 1 && _.isNil(warehouses.getIn([0, 'name']))) {
    // กรณีที่มี "warehouse แค่ตัวเดียว" และ "ไม่มีชื่อ warehouse" ให้ตั้งชื่อ warehouse เป็นคลังธรรมดา
    return ' '
  }

  const foundWh = warehouses.find((wh) => wh.get('id') === whId)
  if (foundWh) {
    return foundWh.get('name')
  }

  return null
}

export function isIntegerText(value: string) {
  return value.match(/^(\d+)$/)
}

export function isFloatText(value: string) {
  return value.match(/^[+-]?\d+(\.\d+)?$/)
}

export function isStringEmpty(s: string) {
  return s === null || s === undefined || s === '' || s.length === 0
}

export function getProductQtyUpdateTemplate(params: { store_id: number | string }): string | null {
  const { store_id } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  const url = `${settings.app.GO_API_ROOT}/excel/template/product_qty_update?store_id=${store_id}`

  // console.log('download shipping url => ', url)
  return url
}

export function getProductStockQtyEditTemplate(params: { store_id: number | string; o: string }): string | null {
  const { store_id, o } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  const url = `${settings.app.GO_API_ROOT}/excel/template/product_stock_qty_edit?store_id=${store_id}&o=${o}`

  // console.log('download shipping url => ', url)
  return url
}

export function getProductBarcodeUpdateTemplate(params: { store_id: number | string }): string | null {
  const { store_id } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  const url = `${settings.app.GO_API_ROOT}/excel/template/product_barcode_update?store_id=${store_id}`

  // console.log('download shipping url => ', url)
  return url
}

export function getAddProductTemplate(params: { store_id: number | string }): string | null {
  const { store_id } = params
  if (!store_id) {
    // store_id and startDate are required
    return null
  }
  const url = `${settings.app.GO_API_ROOT}/excel/template/product_add?store_id=${store_id}`

  // console.log('download shipping url => ', url)
  return url
}

export function getVisibleShippingTypesIds(): number[] {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const storeSetting = selectedStore.has('store_setting') ? selectedStore.get('store_setting') : null
  const visibleShippingTypes = []
  CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS.map((shipping) => {
    visibleShippingTypes.push(shipping.value)
  })
  if (_.isNil(storeSetting)) {
    return []
  }
  const showOnlyShippingTypeIds = storeSetting.has('ui_show_only_shipping_type_ids')
    ? storeSetting.get('ui_show_only_shipping_type_ids').toJS()
    : null
  if (_.isNil(showOnlyShippingTypeIds) || showOnlyShippingTypeIds.length < 1) {
    return []
  }
  return showOnlyShippingTypeIds
}

export function isNullOrUndefined(obj: any) {
  return _.isNull(obj) || _.isUndefined(obj)
}

export function getLengthIfNotNullOrGetZero(obj: any[]) {
  if (isNullOrUndefined(obj)) {
    return 0
  }
  return obj.length
}

export function getVisibleShippingTypes(forcedShowAll?: boolean): IShippingType[] {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const storeSetting = selectedStore.has('store_setting') ? selectedStore.get('store_setting') : null
  const visibleShippingTypes = []
  CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS.map((shipping) => {
    // O: Modify add text label
    // showVisibleShippingTypes.push(shipping)
    visibleShippingTypes.push({
      ...shipping,
      label: getShippingTypeNameById(shipping.value),
      shippingState: getShippingHasXShippingLabel(shipping.value),
    })
  })

  if (forcedShowAll || _.isNil(storeSetting)) {
    return visibleShippingTypes
  }

  const showOnlyShippingTypeIds = storeSetting.has('ui_show_only_shipping_type_ids')
    ? storeSetting.get('ui_show_only_shipping_type_ids').toJS()
    : null
  if (_.isNil(showOnlyShippingTypeIds) || showOnlyShippingTypeIds.length < 1) {
    return visibleShippingTypes
  }

  const showVisibleShippingTypes = visibleShippingTypes.map((shipping) => ({ ...shipping, hidden: true }))
  // showOnlyShippingTypeIds.map((shippingID: number) => {
  //   const shipping = _.find(CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS, (sh) => sh.value === shippingID)
  //   if (!_.isNil(shipping)) {
  //     showVisibleShippingTypes.push({ ...shipping, label: getShippingTypeNameById(shipping.value) })
  //   }
  // })
  for (let i = 0; i < showOnlyShippingTypeIds.length; i++) {
    const showShippingTypeId = showOnlyShippingTypeIds[i]
    const foundShippingType = showVisibleShippingTypes.find((s) => s.value === showShippingTypeId)
    if (foundShippingType) {
      foundShippingType.hidden = false
    }
  }
  // console.log('showVisibleShippingTypes => ', showVisibleShippingTypes)
  return showVisibleShippingTypes
}

export function generateShippingTypeItems(): IShippingType[] {
  const selectorShippingTypeItems = [...CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS]
  const visibleShippingTypeItems = getVisibleShippingTypes()
  selectorShippingTypeItems.forEach((dsti, idx) => {
    selectorShippingTypeItems[idx].label = getShippingTypeNameById(dsti.value)
    selectorShippingTypeItems[idx].hidden = true
  })
  visibleShippingTypeItems.forEach((vsti) => {
    const vstID = vsti.value
    const dstiFoundIndex = selectorShippingTypeItems.findIndex((dsti) => dsti.value === vstID)
    selectorShippingTypeItems[dstiFoundIndex].hidden = false
  })
  return selectorShippingTypeItems
}

export async function confirmForceCreateShipping(): Promise<boolean> {
  const isUserConfirm = await p.op.isUserConfirm(
    'บันทึกจัดส่งแม้จำนวนสินค้าในคลังไม่พอ',
    'กรุณายืนยันว่าคุณต้องการบันทึกจัดส่งออเดอร์ แม้จะมีจำนวนสินค้าไม่พอสำหรับการตัดสต็อก',
    'ยืนยัน',
    'ยกเลิก'
  )
  return isUserConfirm
}

// ถ้าเวลายังเหลืออยู่ จะ return true
export function isRemainingTime(chankingTime: string): boolean {
  const TIME_LEFT = moment(chankingTime).diff(moment(), 's')
  return TIME_LEFT > 0
}

export function remainingDay(chankingTime: string): number {
  const TIME_LEFT = moment(chankingTime).diff(moment(), 'd')
  return TIME_LEFT
}

export function remainingHour(chankingTime: string): number {
  const TIME_LEFT = moment(chankingTime).diff(moment(), 'h')
  return TIME_LEFT
}

export function remainingSecond(chankingTime: string): number {
  const TIME_LEFT = moment(chankingTime).diff(moment(), 's')
  return TIME_LEFT
}

export function getMKPChannelWraning(channel: IMKPChannelDetail): {
  isShowWarning: boolean
  warningText: string
  warningBackground: string
} {
  if (_.isNil(channel) || _.isNil(channel.expire_time) || channel.expire_time === '') {
    return null
  }
  const TIME_LEFT = remainingDay(channel.expire_time)
  let isShowWarning = false
  const isTiktok = channel.mkp_id === 3
  let warningText = p.op.t('marketplace_channels.warning.auth_running_out_of_time', { day: TIME_LEFT })
  let warningBackground = COLORS.BRAND_Warning

  if (!channel.is_active && !channel.is_auth) {
    return {
      isShowWarning: true,
      warningText: p.op.t('marketplace_channels.warning.mkp_not_is_active_is_not_auth'),
      warningBackground: COLORS.RED,
    }
  }

  // ถ้าเหลือเวลา auth น้อยกว่า 17 วัน
  if ((TIME_LEFT < 17 && !isTiktok) || (isTiktok && TIME_LEFT < 7)) {
    isShowWarning = true
    // ถ้า auth หมดเวลาแล้ว
    if (TIME_LEFT < 0) {
      warningText = p.op.t('marketplace_channels.warning.connection_expired_press_button')
      warningBackground = COLORS.RED
      // ถ้า auth จะหมดเวลาในไม่กี่ชั่วโมง
    } else if (TIME_LEFT === 0) {
      const hr = remainingDay(channel.expire_time)
      // ถ้า auth เหลือเวลามากกว่า 1 ชั่วโมง
      if (hr > 0) {
        warningText = p.op.t('marketplace_channels.warning.auth_running_out_of_hr', { hr })
      } else {
        warningText = p.op.t('marketplace_channels.warning.connection_expired_press_button')
        warningBackground = COLORS.RED
      }
    }
  }

  // ถ้าปิดการใช้งานอยู่ is_active = false
  if (!channel.is_active) {
    isShowWarning = true
    warningText = p.op.t('marketplace_channels.warning.mkp_not_is_active')
    warningBackground = COLORS.RED
  }
  return { isShowWarning, warningText, warningBackground }
}

export function getDefaultVisibleShippingTypesIds() {
  const defaultVisibleShippingTypes = []
  CONS.ORDER_VIEW_SHIPPING_TYPE_ITEMS.map((shipping) => {
    defaultVisibleShippingTypes.push(shipping.value)
  })
  return defaultVisibleShippingTypes
}

export function _devSetHostURLs(laravelHost: string, goHost: string) {
  SETTINGS.app.API_ROOT = laravelHost
  SETTINGS.app.GO_API_ROOT = goHost
  // SETTINGS.s3.options.bucket = RUNTIME_ENDPOINT_CONFIG.s3_options_bucket

  if (laravelHost === FLAVOUR_CONFIG.prod_app_apiRoot) {
    SETTINGS.s3.options.keyPrefix = FLAVOUR_CONFIG.prod_s3_options_keyPrefix
  } else {
    SETTINGS.s3.options.keyPrefix = FLAVOUR_CONFIG.dev_s3_options_keyPrefix
  }
  setConfiguration('API_ROOT', SETTINGS.app.API_ROOT)
  setConfiguration('GO_API_ROOT', SETTINGS.app.GO_API_ROOT)
  // log(SETTINGS.app.API_ROOT)
}

export function getShippingHasXShippingLabel(shippingValue: number): { label: string; color: string; isXShippingReady: boolean } | null {
  if (_.isNil(shippingValue)) {
    return null
  }
  const xshippingConfig: IXShippingConfig[] = getXShippingConfigFromRedux(p.op.getAppState())
  // console.log('xshippingConfig => ', xshippingConfig)
  const getActiveXShipping = (): IXShippingConfig | null => {
    let isAc = null
    xshippingConfig.map((sh: IXShippingConfig) => {
      if (shippingValue === sh.shipping_type_id) {
        isAc = sh
      }
    })
    return isAc
  }

  const isShipjung = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 2) {
      return true
    }
    return false
  }
  const isJAndT = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 3) {
      return true
    }
    return false
  }
  const isKerry = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 4) {
      return true
    }
    return false
  }
  const isFlash = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 6) {
      return true
    }
    return false
  }
  const isBest = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 7) {
      return true
    }
    return false
  }
  const isEcoPostAndEms = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 8) {
      return true
    }
    return false
  }

  const isSpx = (shConfig: IXShippingConfig): boolean => {
    if (shConfig.system_id === 11) {
      return true
    }
    return false
  }

  const { FORM_SUCCESS } = COLORS
  const { TEXT_INACTIVE } = COLORS
  let hasXShippingLabel = null
  let textColor = TEXT_INACTIVE
  if (_.isNil(xshippingConfig)) {
    return null
  }
  if (shippingValue === 38) {
    // J&T
    const configJAndT: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configJAndT)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isJAndT(configJAndT)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configJAndT)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 39) {
    // J&T COD
    const configJAndTCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configJAndTCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isJAndT(configJAndTCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configJAndTCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 44) {
    // J&T นัดรับ
    const configJAndTPickUp: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configJAndTPickUp)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isJAndT(configJAndTPickUp)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configJAndTPickUp)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 65) {
    // J&T นัดรับ
    const configJAndTPickUpCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configJAndTPickUpCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isJAndT(configJAndTPickUpCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configJAndTPickUpCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_j_and_t_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 4) {
    // Kerry
    const configKerry: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configKerry)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isKerry(configKerry)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_kerry_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configKerry)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_kerry_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 24) {
    // Kerry COD
    const configKerryCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configKerryCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isKerry(configKerryCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_kerry_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configKerryCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_kerry_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 14) {
    // DHL
    const configDHL: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configDHL)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configDHL)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_dhl_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 29) {
    // DHL COD
    const configDHLCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configDHLCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configDHLCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_dhl_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 3 || shippingValue === 37) {
    // EMS
    const configEMS: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configEMS)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configEMS)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_ems_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isEcoPostAndEms(configEMS)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_ems_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 22) {
    // Flash
    const configFlash: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configFlash)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configFlash)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isFlash(configFlash)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 30) {
    // Flash COD
    const configFlashCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isFlash(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 7) {
    // Ninja
    const configNinja: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configNinja)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configNinja)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_ninja_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 26) {
    // Ninja COD
    const configNinjaCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configNinjaCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configNinjaCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_ninja_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 13) {
    // SCG
    const configSCG: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configSCG)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configSCG)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_scg_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 28) {
    // SCG COD
    const configSCGCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configSCGCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configSCGCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_scg_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 35 || shippingValue === 36) {
    // Best // Best COD
    const configBest: IXShippingConfig | null = getActiveXShipping()
    // console.log('configBest => ', configBest)
    if (_.isNil(configBest)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isBest(configBest)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_best_direct')
      textColor = FORM_SUCCESS
    } else if (isShipjung(configBest)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_best_from_shipjung')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 71 || shippingValue === 72) {
    // eCo-Post // eCo-Post COD
    const configEcoPost: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configEcoPost)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isEcoPostAndEms(configEcoPost)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_eco_post')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 85) {
    // SPX Dropoff
    const configSpx: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isSpx(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_spx_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 86) {
    // SPX Dropoff COD
    const configSpxCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configSpxCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configSpxCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isSpx(configSpxCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_spx_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 83) {
    // SPX Pickup
    const configSpx: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isSpx(configSpx)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_spx_direct')
      textColor = FORM_SUCCESS
    }
  } else if (shippingValue === 84) {
    // SPX Pickup COD
    const configFlashCOD: IXShippingConfig | null = getActiveXShipping()
    if (_.isNil(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
    } else if (isShipjung(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_flash_from_shipjung')
      textColor = FORM_SUCCESS
    } else if (isSpx(configFlashCOD)) {
      hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_spx_direct')
      textColor = FORM_SUCCESS
    }
  }

  // switch (shippingValue) {
  //   case 28: // SCG COD
  //     const configSCGCOD: IXShippingConfig | null = getActiveXShipping()
  //     if (_.isNil(configSCGCOD)) {
  //       hasXShippingLabel = p.op.t('xshipping.shipping.can_use_xshipping')
  //     } else if (isShipjung(configSCGCOD)) {
  //       hasXShippingLabel = p.op.t('xshipping.shipping.use_xshipping_scg_from_shipjung')
  //       textColor = FORM_SUCCESS
  //     }
  //   default:
  //   // hasXShippingLabel = null
  // }
  if (_.isNil(hasXShippingLabel)) {
    return null
  }
  // console.log('config 02 => ', { label: hasXShippingLabel, color: textColor })
  return { label: hasXShippingLabel, color: textColor, isXShippingReady: textColor === FORM_SUCCESS }
}

export function isStoreOwner(): boolean {
  return acl.isSelectedStoreOwner() && acl.canDoAtSelectedStore(CONS.PERM_STORE_HELPER.ORDER_EDIT)
}

export function isHelper(): boolean {
  const selectedStore = getStoreSelected(p.op.getAppState())
  return selectedStore.has('role_id') ? selectedStore.get('role_id') === CONS.STORE_ROLE.HELPER : false
}

interface SerializeObjectToQueryParamsStringOptions {
  // Note: เอา [] ของ order_ids[]= ออก เนื่องจากหลังบ้านไม่สามารถรับ []= ใน gin ได้
  // - https://stackoverflow.com/questions/6243051/how-to-pass-an-array-within-a-query-string (Standard)
  // - https://github.com/gin-gonic/gin/pull/570
  // - https://github.com/gin-gonic/gin/issues/2233 (Open Issue)
  removeArraySquareBrackets?: boolean
}

export function serializeObjectToQueryParamsString(
  obj: IAnyObject,
  options: SerializeObjectToQueryParamsStringOptions = {}
): string | null {
  const removeArraySquareBrackets = options.removeArraySquareBrackets ? options.removeArraySquareBrackets : false
  const queryParams = Object.keys(obj).map((key) => {
    if (_.isNil(obj[key])) {
      return undefined
    }
    if (obj[key].constructor === Array) {
      let arrSerialized = ''
      const arr = obj[key]
      const arrLength = arr.length
      for (let arrIdx = 0; arrIdx < arrLength; arrIdx++) {
        const arrValue = arr[arrIdx]
        if (removeArraySquareBrackets) {
          arrSerialized = `${arrSerialized + key}=${arrValue}`
        } else {
          arrSerialized = `${arrSerialized + key}[]=${arrValue}`
        }
        if (arrIdx < arrLength - 1) {
          arrSerialized += '&'
        }
      }
      return arrSerialized
    }

    const objValue = obj[key]
    return `${key}=${objValue}`
  })

  const filteredQueryParams = queryParams.filter((str) => !_.isUndefined(str) && str !== '')
  if (filteredQueryParams.length === 0) {
    return null
  }
  return filteredQueryParams.join('&')
}

export function convertQueryParamsStringToObject(paramString) {
  // const params = Object.fromEntries(new URLSearchParams(paramString))
  // console.log('convertQueryParamsStringToObject paramString => ', paramString)
  // const urlParams = new URLSearchParams(paramString);
  // console.log('urlParams => ', urlParams)
  // const entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
  // console.log('entries => ', entries)
  // const params = paramsToObject(entries); //{abc:"foo",def:"[asf]",xyz:"5"}
  const queryString = paramString.split('?')[1]
  const searchParams = {}
  if (queryString) {
    queryString.split('&').forEach((pair) => {
      const [key, value] = pair.split('=')
      if (searchParams[key]) {
        if (Array.isArray(searchParams[key])) {
          searchParams[key].push(value)
        } else {
          searchParams[key] = [searchParams[key], value]
        }
      } else {
        searchParams[key] = value
      }
    })
  }
  // console.log('convertQueryParamsStringToObject searchParams => ', searchParams)
  return searchParams
}

export async function loadSavedDefaultStateToCurrentViewState<StateType = {}>(
  thisClassComponent: IAnyComponentWithSetState<any, StateType>,
  storageSavedKey: string
): Promise<void> {
  // type RestParamsArgs = Parameters<typeof _loadSavedDefaultStateToCurrentViewState>
  // type arg1 = RestParamsArgs[0]
  const defaultState = await loadDefaultState<StateType>(storageSavedKey)
  if (!_.isEmpty(defaultState)) {
    await setStatePromise(thisClassComponent, defaultState as StateType)
  }
}

export async function saveDefaultCurrentViewState<StateType = {}>(
  thisClassComponent: IAnyComponentWithSetState<any, StateType>, // for typed auto-completion
  storageSavedKey: string,
  newState: StateType
): Promise<void> {
  await saveDefaultState(storageSavedKey, newState)
}

export async function loadDefaultState<StateType = IAnyObject>(storageSavedKey: string): Promise<StateType | {}> {
  const defaultObj = await p.op.storageGet(storageSavedKey, true)
  const isValidSavedDefaultObj = _.isObject(defaultObj) && !_.isEmpty(defaultObj)
  if (isValidSavedDefaultObj) {
    return defaultObj as StateType
  }
  return {}
}

export async function saveDefaultState<StateType = {}>(storageSavedKey: string, newState: StateType): Promise<void> {
  const savedDefaultObj = await loadDefaultState(storageSavedKey)
  const modifiedDefaultObj = { ...savedDefaultObj, ...newState }
  await p.op.storageSet(storageSavedKey, modifiedDefaultObj, true)
}

export function getHelperName(helperProfileId: number): string {
  let sellerType = 'ฉัน'
  if (!_.isNil(helperProfileId)) {
    const helper = helperProfileId
    const selectedStore = getStoreSelected(p.op.getAppState())
    const helpers = selectedStore.has('helpers') ? selectedStore.get('helpers') : null
    if (!_.isNil(helpers)) {
      helpers.map((h) => {
        if (h.get('pid') === helper) {
          if (h.has('n')) {
            sellerType = `${h.get('n')}`
          }
        }
      })
      return sellerType
    }
    return sellerType
  }
  return sellerType
}

export function getProfile(): IProfile {
  // const profile = getMyProfile(p.op.getAppState())
  return isImmutable(getMyProfile(p.op.getAppState())) ? getMyProfile(p.op.getAppState()).toJS() : getMyProfile(p.op.getAppState())
}

export function getSelectedStoreFromRedex() {
  return getStoreSelected(p.op.getAppState())
}

export function translateOrdersFilterToRequestBody(filterSetting: IOrdersFilter): Partial<IFetchOrdersRequestBody> {
  const {
    isCOD,
    is_cod,
    isShipBeforePay,
    hasPrintedAt,
    printedAtDateRangeOptionKey,
    printedAtFrom,
    printedAtTo,

    orderSegment,
    orderOrigin,

    segmentOrderChannelsIndex,
    orderChannelActiveMap,

    // segmentCreateAtIndex,
    createOrderDateRangeOptionKey,
    createOrderFrom,
    createOrderTo,

    selectorShippingTypeIds,

    hasPaymentCompletedAt,
    // segmentPaymentCompletedAtIndex,
    paymentCompletedAtDateRangeOptionKey,
    paymentCompletedAtFrom,
    paymentCompletedAtTo,

    hasShippingCompletedAt,
    // segmentShippingCompletedAtIndex,
    shippingCompletedAtDateRangeOptionKey,
    shippingCompletedAtFrom,
    shippingCompletedAtTo,

    erpChannelActiveMap,
    segmentErpChannelWhichInIndex,

    segmentErpDocTypeWhichInIndex,
    erpDocTypeActiveMap,

    segmentErpDocTypeWhichNotInIndex,
    erpDocTypeNotInActiveMap,

    hasReadyToShipDate,
    // segmentReadyToShipAtIndex,
    readyToShipDateRangeOptionKey,
    readyToShipDateFrom,
    readyToShipDateTo,

    hasDateDelivery,
    // segmentDateDeliveryAtIndex,
    dateDeliveryDateRangeOptionKey,
    dateDeliveryFrom,
    dateDeliveryTo,

    hasExpirationDate,
    // segmentAutoCancelOrderAtIndex,
    autoCancelOrderDateRangeOptionKey,
    autoCancelOrderFrom,
    autoCancelOrderTo,

    // mkpChannelIds,
    segmentOrderOriginIndex,
    mkpChannelActiveMap,

    mkpIsSelfDelivery,

    isTaxInvoiceRequested,

    lockOrder,

    hasAwbOrderNote,

    sortByIndex,
    sortTypeIndex,
  } = filterSetting
  // console.log('filterSetting => ', filterSetting)
  const body: Partial<IFetchOrdersRequestBody> = {}

  if (_.isBoolean(isTaxInvoiceRequested)) {
    body.is_tax_invoice_requested = isTaxInvoiceRequested
  }

  // อนาคตเอา isCOD เพราะไม่ใช้แล้ว
  if (_.isBoolean(isCOD)) {
    // body.isCOD = isCOD
    body.is_cod = isCOD
  } else if (_.isBoolean(is_cod)) {
    body.is_cod = is_cod
  }

  if (_.isBoolean(isShipBeforePay)) {
    body.isShipBeforePay = isShipBeforePay
    body.is_ship_before_pay = isShipBeforePay
  }

  if (_.isBoolean(hasPrintedAt)) {
    // const segmentHasPrintedAtIndex = segmentHasPrintedAtIndex || 0

    // เริ่ม apply filter has_printed_at
    body.has_printed_at = hasPrintedAt

    // // ถ้าหากมีการกรองที่ระบุเวลาเกิดขึ้น
    // if (hasPrintedAt) {
    //   const { printedAtFrom } = filterSetting
    //   const { printedAtTo } = filterSetting
    //   if (!_.isNil(printedAtFrom) && !_.isNil(printedAtTo)) {
    //     // apply filter by datetime
    //     // @ts-ignore
    //     body.printed_at_from = dayjs(printedAtFrom).format(CONS.SERVER_DATETIME_FORMAT)
    //     // @ts-ignore
    //     body.printed_at_to = dayjs(printedAtTo).format(CONS.SERVER_DATETIME_FORMAT)
    //     // body.printed_at_from = printedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    //     // body.printed_at_to = printedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
    //   }
    // }
  }

  if (hasPrintedAt && printedAtDateRangeOptionKey && printedAtDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(printedAtDateRangeOptionKey)
    body.printed_at_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.printed_at_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_printed_at = true
  }

  if (
    hasPrintedAt &&
    printedAtDateRangeOptionKey &&
    printedAtDateRangeOptionKey === 'Custom' &&
    !_.isNil(printedAtFrom) &&
    !_.isNil(printedAtTo)
  ) {
    body.printed_at_from = printedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.printed_at_to = printedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_printed_at = true
  }

  if (_.isString(orderSegment)) {
    body.order_segment = orderSegment
  }

  // สำหรับ mkp channels
  // if (_.has(filterSetting, 'mkpChannelIds') && _.isArray(mkpChannelIds) && mkpChannelIds.length > 0) {
  //   // body.ug_ids = mkpChannelIds
  //   body.mkp_ch_ids = mkpChannelIds
  // }

  if (
    _.has(filterSetting, 'mkpChannelActiveMap') &&
    segmentOrderOriginIndex === 1 &&
    _.isObject(mkpChannelActiveMap) &&
    !_.isEmpty(mkpChannelActiveMap)
  ) {
    body.mkp_ch_ids = Object.keys(mkpChannelActiveMap)
      .filter((key) => mkpChannelActiveMap[key])
      .map((key) => parseInt(key))
  }

  if (_.isString(orderOrigin)) {
    body.order_origin = orderOrigin
  }

  if (segmentOrderChannelsIndex === 1 && _.isObject(orderChannelActiveMap) && !_.isEmpty(orderChannelActiveMap)) {
    body.channel_ids = Object.keys(orderChannelActiveMap)
      .filter((key) => orderChannelActiveMap[key])
      .map((key) => parseInt(key))
  }

  // create order
  // if (!_.isNil(createOrderFrom) && !_.isNil(createOrderTo)) {
  //   body.created_at_from = createOrderFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.created_at_to = createOrderTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (createOrderDateRangeOptionKey && createOrderDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(createOrderDateRangeOptionKey)
    body.created_at_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.created_at_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
  }

  if (createOrderDateRangeOptionKey && createOrderDateRangeOptionKey === 'Custom' && !_.isNil(createOrderFrom) && !_.isNil(createOrderTo)) {
    body.created_at_from = createOrderFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.created_at_to = createOrderTo.format(CONS.SERVER_DATETIME_FORMAT)
  }

  if (_.isNil(body.created_at_from) || _.isNil(body.created_at_to)) {
    const dr = getDateRangeFromOption('Last30Days')
    body.created_at_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.created_at_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
  }

  // Selector Shipping Type
  // const selectorShippingTypeIds = _.isNil(selectorShippingTypeIds) ? null : selectorShippingTypeIds.toJS()
  if (_.isArray(selectorShippingTypeIds) && selectorShippingTypeIds.length > 0) {
    body.shipping_type_ids = selectorShippingTypeIds
  }

  // FILTER CREATE BODY
  // สภานะพร้อมส่ง
  // console.log('ABC => ', hasReadyToShipDate)
  if (_.isBoolean(hasReadyToShipDate)) {
    body.has_ready_to_ship_date = hasReadyToShipDate
  }
  // // if (_.isBoolean(hasReadyToShipDate) && hasReadyToShipDate === false) {
  // //   body.has_ready_to_ship_date = false
  // // }
  // if (hasReadyToShipDate && !_.isNil(readyToShipDateFrom) && !_.isNil(readyToShipDateTo)) {
  //   body.has_ready_to_ship_date = true
  //   body.ready_to_ship_date_from = readyToShipDateFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.ready_to_ship_date_to = readyToShipDateTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (hasReadyToShipDate && readyToShipDateRangeOptionKey && readyToShipDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(readyToShipDateRangeOptionKey)
    body.ready_to_ship_date_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.ready_to_ship_date_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_ready_to_ship_date = true
  }

  if (
    hasReadyToShipDate &&
    readyToShipDateRangeOptionKey &&
    readyToShipDateRangeOptionKey === 'Custom' &&
    !_.isNil(readyToShipDateFrom) &&
    !_.isNil(readyToShipDateTo)
  ) {
    body.ready_to_ship_date_from = readyToShipDateFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.ready_to_ship_date_to = readyToShipDateTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_ready_to_ship_date = true
  }

  // สถานะการชำระ
  if (_.isBoolean(hasPaymentCompletedAt)) {
    body.has_payment_completed_at = hasPaymentCompletedAt
  }

  // if (hasPaymentCompletedAt && !_.isNil(paymentCompletedAtFrom) && !_.isNil(paymentCompletedAtTo)) {
  //   body.has_payment_completed_at = true
  //   body.payment_completed_at_from = paymentCompletedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.payment_completed_at_to = paymentCompletedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (hasPaymentCompletedAt && paymentCompletedAtDateRangeOptionKey && paymentCompletedAtDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(paymentCompletedAtDateRangeOptionKey)
    body.payment_completed_at_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.payment_completed_at_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_payment_completed_at = true
  }

  if (
    hasPaymentCompletedAt &&
    paymentCompletedAtDateRangeOptionKey &&
    paymentCompletedAtDateRangeOptionKey === 'Custom' &&
    !_.isNil(paymentCompletedAtFrom) &&
    !_.isNil(paymentCompletedAtTo)
  ) {
    body.payment_completed_at_from = paymentCompletedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.payment_completed_at_to = paymentCompletedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_payment_completed_at = true
  }

  // สถานะการจัดส่ง
  if (_.isBoolean(hasShippingCompletedAt)) {
    body.has_shipping_completed_at = hasShippingCompletedAt
  }

  // if (hasShippingCompletedAt && !_.isNil(shippingCompletedAtFrom) && !_.isNil(shippingCompletedAtTo)) {
  //   body.has_shipping_completed_at = true
  //   body.shipping_completed_at_from = shippingCompletedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.shipping_completed_at_to = shippingCompletedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (hasShippingCompletedAt && shippingCompletedAtDateRangeOptionKey && shippingCompletedAtDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(shippingCompletedAtDateRangeOptionKey)
    body.shipping_completed_at_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.shipping_completed_at_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_shipping_completed_at = true
  }

  if (
    hasShippingCompletedAt &&
    shippingCompletedAtDateRangeOptionKey &&
    shippingCompletedAtDateRangeOptionKey === 'Custom' &&
    !_.isNil(shippingCompletedAtFrom) &&
    !_.isNil(shippingCompletedAtTo)
  ) {
    body.shipping_completed_at_from = shippingCompletedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.shipping_completed_at_to = shippingCompletedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_shipping_completed_at = true
  }

  if (segmentErpChannelWhichInIndex === 1 && _.isObject(erpChannelActiveMap) && !_.isEmpty(erpChannelActiveMap)) {
    body.erp_ch_ids = Object.keys(erpChannelActiveMap)
      .filter((erpChId) => erpChannelActiveMap[erpChId])
      .map((erpChId) => parseInt(erpChId))
  }

  if (segmentErpDocTypeWhichInIndex === 1 && _.isObject(erpDocTypeActiveMap) && !_.isEmpty(erpDocTypeActiveMap)) {
    body.erp_doc_types = Object.keys(erpDocTypeActiveMap)
      .filter((erpDocTypeId) => erpDocTypeActiveMap[erpDocTypeId])
      .map((erpChId) => parseInt(erpChId))
    if (body.erp_doc_types.length === 0) {
      delete body.erp_doc_types
    }
  }

  if (segmentErpDocTypeWhichNotInIndex === 1 && _.isObject(erpDocTypeNotInActiveMap) && !_.isEmpty(erpDocTypeNotInActiveMap)) {
    body.erp_doc_types_not_in = Object.keys(erpDocTypeNotInActiveMap)
      .filter((erpDocTypeId) => erpDocTypeNotInActiveMap[erpDocTypeId])
      .map((erpChId) => parseInt(erpChId))
    if (body.erp_doc_types_not_in.length === 0) {
      delete body.erp_doc_types_not_in
    }
  }

  // กำหนดส่ง
  if (_.isBoolean(hasDateDelivery)) {
    body.has_date_delivery = hasDateDelivery
  }
  // // if (_.isBoolean(hasDateDelivery) && hasDateDelivery === false) {
  // //   body.has_date_delivery = false
  // // }
  // if (hasDateDelivery && !_.isNil(dateDeliveryFrom) && !_.isNil(dateDeliveryTo)) {
  //   body.has_date_delivery = true
  //   body.date_delivery_from = dateDeliveryFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.date_delivery_to = dateDeliveryTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (hasDateDelivery && dateDeliveryDateRangeOptionKey && dateDeliveryDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(dateDeliveryDateRangeOptionKey)
    body.date_delivery_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.date_delivery_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_date_delivery = true
  }

  if (
    hasDateDelivery &&
    dateDeliveryDateRangeOptionKey &&
    dateDeliveryDateRangeOptionKey === 'Custom' &&
    !_.isNil(dateDeliveryFrom) &&
    !_.isNil(dateDeliveryTo)
  ) {
    body.date_delivery_from = dateDeliveryFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.date_delivery_to = dateDeliveryTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_date_delivery = true
  }

  //  ยกเลิกออเดอร์อัตโนมัติ
  if (_.isBoolean(hasExpirationDate)) {
    body.has_expiration_date = hasExpirationDate
  }
  // // if (_.isBoolean(hasExpirationDate) && hasExpirationDate === false) {
  // //   body.has_expiration_date = false
  // // }

  // if (hasExpirationDate && !_.isNil(autoCancelOrderFrom) && !_.isNil(autoCancelOrderTo)) {
  //   body.has_expiration_date = true
  //   body.expiration_date_from = autoCancelOrderFrom.format(CONS.SERVER_DATETIME_FORMAT)
  //   body.expiration_date_to = autoCancelOrderTo.format(CONS.SERVER_DATETIME_FORMAT)
  // }

  if (hasExpirationDate && autoCancelOrderDateRangeOptionKey && autoCancelOrderDateRangeOptionKey !== 'Custom') {
    const dr = getDateRangeFromOption(autoCancelOrderDateRangeOptionKey)
    body.expiration_date_from = dr.begin.format(CONS.SERVER_DATETIME_FORMAT)
    body.expiration_date_to = dr.end.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_expiration_date = true
  }

  if (
    hasExpirationDate &&
    autoCancelOrderDateRangeOptionKey &&
    autoCancelOrderDateRangeOptionKey === 'Custom' &&
    !_.isNil(autoCancelOrderFrom) &&
    !_.isNil(autoCancelOrderTo)
  ) {
    body.expiration_date_from = autoCancelOrderFrom.format(CONS.SERVER_DATETIME_FORMAT)
    body.expiration_date_to = autoCancelOrderTo.format(CONS.SERVER_DATETIME_FORMAT)
    body.has_expiration_date = true
  }

  let payment_states = []
  if (_.isBoolean(hasPaymentCompletedAt) && hasPaymentCompletedAt === true) {
    // ชําระเงินแล้ว
    payment_states = [119]
  }

  if (_.isBoolean(hasPaymentCompletedAt) && hasPaymentCompletedAt === false) {
    // ยังไม่ชําระเงิน
    payment_states = [111, 112, 113, 114, 115]
  }

  let shipping_states = []
  if (_.isBoolean(hasShippingCompletedAt) && hasShippingCompletedAt === true) {
    // จัดส่งแล้ว
    shipping_states = [129]
  }

  if (_.isBoolean(hasShippingCompletedAt) && hasShippingCompletedAt === false) {
    // ยังไม่จัดส่ง
    shipping_states = [121, 122]
  }

  if (payment_states.length > 0) {
    body.payment_states = payment_states
  }

  if (shipping_states.length > 0) {
    body.shipping_states = shipping_states
  }

  if (_.isBoolean(lockOrder)) {
    body.is_prevent_mod = lockOrder
  }

  if (_.isBoolean(hasAwbOrderNote)) {
    body.has_awb_order_note = hasAwbOrderNote
  }

  if (_.isBoolean(mkpIsSelfDelivery)) {
    body.mkp_is_self_delivery = mkpIsSelfDelivery
  }

  if (_.isNumber(sortByIndex)) {
    body.sortBy = CONS.ORDERS_SORT_BY_OPTIONS[sortByIndex].value
  }

  if (_.isNumber(sortTypeIndex)) {
    body.sortType = CONS.ORDERS_SORT_TYPE_OPTIONS[sortTypeIndex].value
  }

  return body
}

export function converOrderDetialToOrderListItem(od: IOrder): IOrderListItem {
  const oi: IOrderListItem = {
    c: od.created_at,
    d: od.completed_at,
    e: od.expiration_date,
    id: od.id,
    o: od.state,
    pn: od.partner_name,
    q: od.payment_state,
    s: od.shipping_state,
    t: od.transaction_cost,
    type: od.type,
    y: od.shipping_type_id,
  }

  if (_.isBoolean(od.ship_before_pay)) {
    oi.a = od.ship_before_pay
  }

  if (_.isBoolean(od.is_cod)) {
    oi.b = od.is_cod
  }

  if (!_.isNil(od.cod_amount)) {
    oi.f = od.cod_amount
  }

  if (!_.isNil(od.printed_at)) {
    oi.n = od.printed_at
  }

  if (!_.isNil(od.mkp_id)) {
    oi.m = od.mkp_id
  }

  if (!_.isNil(od.parent_id)) {
    oi.p = od.parent_id
  }

  if (!_.isNil(od.user_group_id)) {
    oi.ug = od.user_group_id
  }

  if (!_.isNil(od.x)) {
    oi.x = od.x
  }

  return oi
}

export function translateProductListFilterToRequestBody(
  fs: IProductListFilterState | IProductListFilterTemplate
): IProductListFilterOptions {
  const {
    // category,
    // mkpChIds,
    segmentCreatedAtIndex,
    createdAtFrom,
    createdAtTo,
    createdAtRangeOptionKey,
    segmentUpdatedAtIndex,
    updatedAtRangeOptionKey,
    updatedAtFrom,
    updatedAtTo,

    segmentHasMkpChIndex,
    segmentHasMkpChNotInIndex,
    mkpChannelActiveMap,
    mkpChannelNotInActiveMap,

    segmentHasParentIndex,
    segmentHasCreatedByMkpChIndex,
    hasCreatedByMkpChIds,
    segmentHasCreatedByMkpChSpecificIndex,

    sortByIndex,
    sortTypeIndex,

    selectedCategoryId,
    isSubCategoryIncluded,

    stockAvailableQtyEnabled,
    stockAvailableQtySelectedOptionKey,
    stockAvailableQtyValueEqual,
    stockAvailableQtyValueGreaterThan,
    stockAvailableQtyValueLessThan,
    stockAvailableQtyValueLessThanOrEqual,

    stockAvailableQtyNotMoveEnabled,
    stockAvailableQtyNotMoveMoreThan,

    stockQtyEnabled,
    stockQtySelectedOptionKey,
    stockQtyValueEqual,
    stockQtyValueGreaterThan,
    stockQtyValueLessThanOrEqual,

    stockQtyNotMoveEnabled,
    stockQtyNotMoveMoreThan,

    stockQtyToShipEnabled,
    stockQtyToShipSelectedOptionKey,
    stockQtyToShipValueEqual,
    stockQtyToShipValueGreaterThan,
    stockQtyToShipValueGreaterOrEqual,
    stockQtyToShipValueLessThanOrEqual,

    costFilterEnabled,
    costFilterSelectedOptionKey,
    costFilterValueEqual,
    costFilterValueGreaterThan,
    costFilterValueGreaterOrEqual,
    costFilterValueLessThanOrEqual,

    selectedProductGroupIds,
    selectedUserGroupId,
    sellerStoreId,

    isCostShow,
    isPriceShow,

    isMkpShow,
    segmentHasMkpChPairedModeIndex,
    segmentHasMkpChNotInPairedModeIndex,

    // isApiV2 = false,
    isProductTemplateFilter = false,

    stockQtyUpdatedAtEnabled,
    stockQtyUpdatedAtOptionKey,
    stockQtyUpdatedAtCustomOperatorKey,
    qtyUpdatedAtGe,
    qtyUpdatedAtLe,
    qtyUpdatedAtGt,
    qtyUpdatedAtLt,
    customQtyUpdatedAtGeEnabled,
    customQtyUpdatedAtLeEnabled,

    stockAvailableQtyUpdatedAtEnabled,
    stockAvailableQtyUpdatedAtOptionKey,
    stockAvailableQtyUpdatedAtCustomOperatorKey,
    availableQtyUpdatedAtGe,
    availableQtyUpdatedAtLe,
    availableQtyUpdatedAtGt,
    availableQtyUpdatedAtLt,
    customAvailableQtyUpdatedAtGeEnabled,
    customAvailableQtyUpdatedAtLeEnabled,

    showQtyUpdatedAt,
    showAvailableQtyUpdatedAt,
    showPtCreatedAt,
    showPpCreatedAt,
    showPtUpdatedAt,
    showPpUpdatedAt,
    hasCreatedByMkpCh,
    showCreatedByMkpChId,

    isBundleProduct,
    isAssemblyProduct,
    isStandardProduct,
    // standardProductType,
    isStandardProductNotPartOfAnything,
    isStandardProductPartOfBundle,
    isStandardProductPartOfAssembly,
  } = fs

  const fo: IProductListFilterOptions = {}

  if (segmentCreatedAtIndex === 1 && createdAtFrom && createdAtTo) {
    fo.created_at_from = createdAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    fo.created_at_to = createdAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  }

  if (segmentUpdatedAtIndex === 1 && updatedAtFrom && updatedAtTo) {
    fo.updated_at_from = updatedAtFrom.format(CONS.SERVER_DATETIME_FORMAT)
    fo.updated_at_to = updatedAtTo.format(CONS.SERVER_DATETIME_FORMAT)
  }

  // if (segmentHasMkpChIndex === 1) {
  //   fo.has_mkp_ch = false
  // }

  // if (segmentHasMkpChIndex === 2) {
  //   fo.has_mkp_ch = true
  // }

  // if (segmentHasMkpChIndex === 2 && mkpChIds && mkpChIds.length > 0) {
  //   fo.mkp_ch_ids = mkpChIds
  // }

  if (isMkpShow) {
    fo.show_mkp_ch_ids = true
  }

  if (segmentHasMkpChIndex === 1 && _.isObject(mkpChannelActiveMap) && !_.isEmpty(mkpChannelActiveMap)) {
    const mkp_ch_ids = Object.keys(mkpChannelActiveMap)
      .filter((mkpChId) => mkpChannelActiveMap[mkpChId])
      .map((mkpChId) => parseInt(mkpChId))

    if (mkp_ch_ids && mkp_ch_ids.length > 0) {
      fo.mkp_ch_ids = mkp_ch_ids
    }

    if (_.isNumber(segmentHasMkpChPairedModeIndex) && segmentHasMkpChPairedModeIndex === 1) {
      fo.mkp_ch_ids_mode = 'all'
    } else {
      fo.mkp_ch_ids_mode = 'at_least_one'
    }
  }

  if (segmentHasMkpChNotInIndex === 1 && _.isObject(mkpChannelNotInActiveMap) && !_.isEmpty(mkpChannelNotInActiveMap)) {
    const mkp_ch_ids_not_in = Object.keys(mkpChannelNotInActiveMap)
      .filter((mkpChId) => mkpChannelNotInActiveMap[mkpChId])
      .map((mkpChId) => parseInt(mkpChId))

    if (mkp_ch_ids_not_in && mkp_ch_ids_not_in.length > 0) {
      fo.mkp_ch_ids_not_in = mkp_ch_ids_not_in
    }

    if (_.isNumber(segmentHasMkpChNotInPairedModeIndex) && segmentHasMkpChNotInPairedModeIndex === 1) {
      fo.mkp_ch_ids_not_in_mode = 'all'
    } else {
      fo.mkp_ch_ids_not_in_mode = 'at_least_one'
    }
  }

  if (segmentHasParentIndex === 1) {
    fo.has_parent = true
  }

  if (segmentHasParentIndex === 2) {
    fo.has_parent = false
  }

  if (segmentHasCreatedByMkpChIndex === 1) {
    fo.has_created_by_mkp_ch = false
  }

  if (segmentHasCreatedByMkpChIndex === 2) {
    fo.has_created_by_mkp_ch = true
  }

  if (segmentHasCreatedByMkpChSpecificIndex === 1 && hasCreatedByMkpChIds && hasCreatedByMkpChIds.length > 0) {
    fo.created_by_mkp_ch_ids = hasCreatedByMkpChIds
  }

  if (_.isNumber(selectedCategoryId)) {
    fo.category_id = selectedCategoryId
  }

  if (_.isNumber(selectedCategoryId) && isSubCategoryIncluded) {
    fo.withSubCategories = isSubCategoryIncluded
  }

  // const PT_SORT_BY_OPTS = isProductTemplateFilter
  //   ? CONS.PRODUCT_LIST_SORT_BY_OPTION_VALUES
  //   : CONS.PRODUCT_VARIANT_LIST_SORT_BY_OPTION_VALUES
  const PT_SORT_BY_OPTS = isProductTemplateFilter ? CONS.PRODUCT_LIST_SORT_BY_OPTIONS : CONS.PRODUCT_VARIANT_LIST_SORT_BY_OPTIONS

  if (_.isNumber(sortByIndex)) {
    fo.sortBy = PT_SORT_BY_OPTS[sortByIndex].value
    fo.sort_by = PT_SORT_BY_OPTS[sortByIndex].value
  } else {
    fo.sortBy = PT_SORT_BY_OPTS[2].value
    fo.sort_by = PT_SORT_BY_OPTS[2].value
  }

  if (_.isNumber(sortTypeIndex)) {
    fo.sortType = CONS.PRODUCT_LIST_SORT_TYPE_OPTIONS[sortTypeIndex].value
    fo.sort_type = CONS.PRODUCT_LIST_SORT_TYPE_OPTIONS[sortTypeIndex].value
  } else {
    fo.sortType = CONS.PRODUCT_LIST_SORT_TYPE_OPTIONS[0].value
    fo.sort_type = CONS.PRODUCT_LIST_SORT_TYPE_OPTIONS[0].value
  }

  if (stockQtyEnabled && stockQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_ALMOST_EMPTY) {
    fo.qty_le = parseInt(stockQtyValueLessThanOrEqual)
  }

  if (stockQtyEnabled && stockQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_EMPTY) {
    // fo.qty_eq = parseInt(stockQtyValueEqual)
    fo.qty_eq = 0
  }

  if (stockQtyEnabled && stockQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_DEAD_STOCK) {
    fo.qty_gt = parseInt(stockQtyValueGreaterThan)

    if (stockQtyNotMoveEnabled) {
      fo.qty_not_move_days = parseInt(stockQtyNotMoveMoreThan)
    }
  }

  if (stockQtyEnabled && stockQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_CUSTOM) {
    fo.qty_gt = parseInt(stockQtyValueGreaterThan)
    fo.qty_le = parseInt(stockQtyValueLessThanOrEqual)

    if (stockQtyNotMoveEnabled) {
      fo.qty_not_move_days = parseInt(stockQtyNotMoveMoreThan)
    }
  }

  if (stockAvailableQtyEnabled && stockAvailableQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_ALMOST_EMPTY) {
    fo.available_qty_le = parseInt(stockAvailableQtyValueLessThanOrEqual)
  }

  if (stockAvailableQtyEnabled && stockAvailableQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_EMPTY) {
    // fo.available_qty_eq = parseInt(stockAvailableQtyValueEqual)
    fo.available_qty_eq = 0
  }

  if (stockAvailableQtyEnabled && stockAvailableQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_DEAD_STOCK) {
    fo.available_qty_gt = parseInt(stockAvailableQtyValueGreaterThan)

    if (stockAvailableQtyNotMoveEnabled) {
      fo.available_qty_not_move_days = parseInt(stockAvailableQtyNotMoveMoreThan)
    }
  }

  if (stockAvailableQtyEnabled && stockAvailableQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_EXCEEDED_QTY) {
    fo.available_qty_lt = parseInt(stockAvailableQtyValueLessThan)
  }

  if (stockAvailableQtyEnabled && stockAvailableQtySelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_CUSTOM) {
    fo.available_qty_gt = parseInt(stockAvailableQtyValueGreaterThan)
    fo.available_qty_le = parseInt(stockAvailableQtyValueLessThanOrEqual)

    if (stockAvailableQtyNotMoveEnabled) {
      fo.available_qty_not_move_days = parseInt(stockAvailableQtyNotMoveMoreThan)
    }
  }

  if (stockQtyToShipEnabled && stockQtyToShipSelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_HAVE_TO_SHIP) {
    fo.to_ship_qty_gt = parseInt(stockQtyToShipValueGreaterThan)
    // fo.to_ship_qty_ge = parseInt(stockQtyToShipValueGreaterOrEqual)
  }

  if (stockQtyToShipEnabled && stockQtyToShipSelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_NOT_HAVE_TO_SHIP) {
    // fo.to_ship_qty_eq = parseInt(stockQtyToShipValueEqual)
    fo.to_ship_qty_eq = 0
  }

  if (stockQtyToShipEnabled && stockQtyToShipSelectedOptionKey === CONS.PRODUCT_LIST_FILTER_STOCK_KEYS.STOCK_CUSTOM) {
    // fo.to_ship_qty_gt = parseInt(stockQtyToShipValueGreaterThan)
    fo.to_ship_qty_ge = parseInt(stockQtyToShipValueGreaterOrEqual)
    fo.to_ship_qty_le = parseInt(stockQtyToShipValueLessThanOrEqual)
  }

  if (costFilterEnabled && costFilterSelectedOptionKey === CONS.PRODUCT_LIST_FILTER_COST_KEYS.COST_FILTER_EQUAL) {
    fo.cost_eq = parseFloat(costFilterValueEqual)
  }

  if (costFilterEnabled && costFilterSelectedOptionKey === CONS.PRODUCT_LIST_FILTER_COST_KEYS.COST_FILTER_CUSTOM) {
    // fo.cost_gt = parseFloat(costFilterValueGreaterThan)
    fo.cost_ge = parseFloat(costFilterValueGreaterOrEqual)
    fo.cost_le = parseFloat(costFilterValueLessThanOrEqual)
  }

  if (isPriceShow && _.isArray(selectedProductGroupIds) && selectedProductGroupIds.length > 0) {
    fo.product_group_ids = selectedProductGroupIds
    fo.show_price = true
  }

  if (isPriceShow && _.isNumber(selectedUserGroupId)) {
    fo.user_group_id = selectedUserGroupId
    fo.show_price = true
  }

  if (isPriceShow && _.isNumber(sellerStoreId)) {
    fo.store_id = sellerStoreId
    fo.show_price = true
  }

  if (isCostShow) {
    fo.show_cost = true
  }

  if (stockQtyUpdatedAtEnabled) {
    if (stockQtyUpdatedAtOptionKey !== 'custom') {
      const { ge, gt, le, lt, operator } = getUpdatedAtDateRangeOptionKeyFromOptionKey(stockQtyUpdatedAtOptionKey)

      if (ge) {
        fo.qty_updated_at_ge = ge.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (gt) {
        fo.qty_updated_at_gt = gt.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (le) {
        fo.qty_updated_at_le = le.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (lt) {
        fo.qty_updated_at_lt = lt.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (operator) {
        fo.qty_updated_at_operator = operator
      }
    }

    if (stockQtyUpdatedAtOptionKey === 'custom' && customQtyUpdatedAtGeEnabled) {
      fo.qty_updated_at_ge = qtyUpdatedAtGe
    }

    if (stockQtyUpdatedAtOptionKey === 'custom' && customQtyUpdatedAtLeEnabled) {
      fo.qty_updated_at_le = qtyUpdatedAtLe
    }

    if (stockQtyUpdatedAtOptionKey === 'custom' && customQtyUpdatedAtGeEnabled && customQtyUpdatedAtLeEnabled) {
      fo.qty_updated_at_operator = stockQtyUpdatedAtCustomOperatorKey
    }
  }

  if (showQtyUpdatedAt) {
    fo.show_qty_updated_at = true
  }

  if (stockAvailableQtyUpdatedAtEnabled) {
    fo.show_available_qty_updated_at = true

    if (stockAvailableQtyUpdatedAtOptionKey !== 'custom') {
      const { ge, gt, le, lt, operator } = getUpdatedAtDateRangeOptionKeyFromOptionKey(stockAvailableQtyUpdatedAtOptionKey)

      if (ge) {
        fo.available_qty_updated_at_ge = ge.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (gt) {
        fo.available_qty_updated_at_gt = gt.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (le) {
        fo.available_qty_updated_at_le = le.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (lt) {
        fo.available_qty_updated_at_lt = lt.format(CONS.SERVER_DATETIME_FORMAT)
      }

      if (operator) {
        fo.available_qty_updated_at_operator = operator
      }
    }

    if (stockAvailableQtyUpdatedAtOptionKey === 'custom' && customAvailableQtyUpdatedAtGeEnabled) {
      fo.available_qty_updated_at_ge = availableQtyUpdatedAtGe
    }

    if (stockAvailableQtyUpdatedAtOptionKey === 'custom' && customAvailableQtyUpdatedAtLeEnabled) {
      fo.available_qty_updated_at_le = availableQtyUpdatedAtLe
    }

    if (stockAvailableQtyUpdatedAtOptionKey === 'custom' && customAvailableQtyUpdatedAtGeEnabled && customAvailableQtyUpdatedAtLeEnabled) {
      fo.available_qty_updated_at_operator = stockAvailableQtyUpdatedAtCustomOperatorKey
    }
  }

  if (showAvailableQtyUpdatedAt) {
    fo.show_available_qty_updated_at = true
  }

  if (showCreatedByMkpChId) {
    fo.show_created_by_mkp_ch_id = true
  }

  if (showPtCreatedAt) {
    fo.show_pt_created_at = true
  }

  if (showPpCreatedAt) {
    fo.show_pp_created_at = true
  }

  if (showPtUpdatedAt) {
    fo.show_pt_updated_at = true
  }

  if (showPpUpdatedAt) {
    fo.show_pp_updated_at = true
  }

  if (hasCreatedByMkpCh) {
    fo.has_created_by_mkp_ch = true
  }

  if (showCreatedByMkpChId) {
    fo.show_created_by_mkp_ch_id = true
  }

  if (_.isBoolean(isBundleProduct)) {
    fo.is_bundle_product = isBundleProduct
  }

  if (_.isBoolean(isAssemblyProduct)) {
    fo.is_assembly_product = isAssemblyProduct
  }

  let isStandardProductSubsetChecked = false
  if (isStandardProduct) {
    fo.is_standard_product = true

    // if (_.isString(standardProductType) && standardProductType.length > 0 && standardProductType !== 'all') {
    //   fo.standard_product_type = standardProductType
    // }
    if (isStandardProductNotPartOfAnything) {
      fo.is_standard_product_not_part_of_anything = true
      isStandardProductSubsetChecked = true
    }

    if (isStandardProductPartOfBundle) {
      fo.is_standard_product_part_of_bundle = true
      isStandardProductSubsetChecked = true
    }

    if (isStandardProductPartOfAssembly) {
      fo.is_standard_product_part_of_assembly = true
      isStandardProductSubsetChecked = true
    }

    if (isStandardProductNotPartOfAnything && isStandardProductPartOfBundle && isStandardProductPartOfAssembly) {
      delete fo.is_standard_product_not_part_of_anything
      delete fo.is_standard_product_part_of_bundle
      delete fo.is_standard_product_part_of_assembly
      isStandardProductSubsetChecked = false
    }
  }

  if (_.isBoolean(isStandardProduct) && !isStandardProductSubsetChecked) {
    fo.is_standard_product = isStandardProduct
  }

  if (isBundleProduct && isAssemblyProduct && isStandardProduct && !isStandardProductSubsetChecked) {
    delete fo.is_bundle_product
    delete fo.is_assembly_product
    delete fo.is_standard_product
  }

  // if (!isProductTemplateFilter) {
  //   fo.is_v2 = isApiV2
  // }

  return fo
}

export function getUpdatedAtDateRangeOptionKeyFromOptionKey(key: IStockFilterQtyUpdatedAtOptionKey): {
  ge?: Dayjs
  le?: Dayjs
  lt?: Dayjs
  gt?: Dayjs
  operator?: 'and' | 'or'
} {
  const now = dayjs()
  // if (key === 'today') {
  //   return { begin: now.clone().startOf('day'), end: now.clone().endOf('day') }
  // }

  if (key === 'lt_Days') {
    return { lt: now.clone().startOf('day') }
  }

  if (key === '7Days') {
    return { ge: now.clone().subtract(7, 'days').startOf('day'), le: now, operator: 'and' }
  }

  if (key === '30Days') {
    return { ge: now.clone().subtract(30, 'days').startOf('day'), le: now, operator: 'and' }
  }

  if (key === '45Days') {
    return { ge: now.clone().subtract(45, 'days').startOf('day'), le: now, operator: 'and' }
  }

  if (key === '60Days') {
    return { ge: now.clone().subtract(60, 'days').startOf('day'), le: now, operator: 'and' }
  }

  if (key === '90Days') {
    return { ge: now.clone().subtract(90, 'days').startOf('day'), le: now, operator: 'and' }
  }

  if (key === 'lt_7Days') {
    return { lt: now.clone().subtract(7, 'days') }
  }

  if (key === 'lt_30Days') {
    return { lt: now.clone().subtract(30, 'days') }
  }

  if (key === 'lt_45Days') {
    return { lt: now.clone().subtract(45, 'days') }
  }

  if (key === 'lt_60Days') {
    return { lt: now.clone().subtract(60, 'days') }
  }

  if (key === 'lt_90Days') {
    return { lt: now.clone().subtract(90, 'days') }
  }

  // today
  return { ge: now.clone().startOf('day'), le: now.clone().endOf('day'), operator: 'and' }
}

// https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
export function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export async function handleAfterCheckPdpaConfirmationStatus(status: 'accepted' | 'rejected' | 'closed') {
  if (status !== 'accepted') {
    await p.op.alertPromise(
      'ไม่สามารถให้บริการได้',
      'ขออภัยอย่างยิ่งในความไม่สะดวก เนื่องจากฟีเจอร์หลักๆใน XSelly เช่น การจัดการออเดอร์ การชำระ และการจัดส่งพัสดุ ต้องจัดเก็บและเข้าถึงข้อมูลที่เกี่ยวข้องได้ ดังนั้น XSelly จึงไม่สามารถให้บริการได้หากไม่ได้รับการยินยอมตามนโยบายความเป็นส่วนตัว'
    )
    await p.op.signOut()
    await delay(100)
  }
}

// --------------- Navigation util functions -----------------------------------------------------
type IXComp<T extends object = IAnyObject> = Readonly<IXScreenProps<T>>

export function getNavParam<T extends object = IAnyObject, Key extends keyof T = keyof T>(
  props: IXComp<T>,
  paramKey: Key | string,
  defaultValue: T[Key] = undefined
): T[Key] | undefined {
  try {
    // @ts-ignore
    if (_.isUndefined(props.route.params[paramKey])) {
      return _.isUndefined(defaultValue) ? undefined : defaultValue
    }

    // @ts-ignore
    return props.route.params[paramKey]
  } catch (err) {
    console.log('Navigation util function::getParam err => ', err)
    return _.isUndefined(defaultValue) ? undefined : defaultValue
  }
}

export function getNavParams<T extends object = IAnyObject>(props: IXComp<T>): T | undefined {
  try {
    return props.route.params
  } catch (err) {
    console.log('Navigation util function::getNavParams err => ', err)
    return undefined
  }
}

export function navGoBack<T extends object = IAnyObject>(props: IXComp<T>, arg2?: any): void {
  try {
    if (arg2) {
      console.log('util::navGoBack arg2 => ', arg2)
    }
    const { navigation } = props
    navigation.goBack()
  } catch (err) {
    console.log('Navigation util function::navGoBack err => ', err)
  }
}

export function navPopToCurrent<T extends object = IAnyObject>(props: IXComp<T>): void {
  try {
    const { navigation, route } = props
    const navState = navigation.getState()
    // console.log('Navigation util function::navPopToCurrent navigation => ', navigation)
    // console.log('Navigation util function::navPopToCurrent route => ', route)
    // const getId = navigation.getId()
    // console.log('Navigation util function::navPopToCurrent navState => ', navState)
    // console.log('Navigation util function::navPopToCurrent getId => ', getId)

    const currentKey = route.key
    const foundKeyIndex = navState.routes.findIndex((rt) => rt.key === currentKey)
    if (foundKeyIndex > -1) {
      const routeLength = navState.routes.length
      const shouldPopNum = routeLength - 1 - foundKeyIndex
      if (shouldPopNum > 0) {
        navigation.pop(shouldPopNum)
      }
    }
  } catch (err) {
    console.log('Navigation util function::navPopToCurrent err => ', err)
  }
}

export function navPopToRouteName<T extends object = IAnyObject>(
  props: IXComp<T>,
  routeName: string,
  isPopIncludedRouteName?: boolean
): void {
  try {
    const { navigation } = props
    const navState = navigation.getState()
    const foundKeyIndex = navState.routes.findIndex((rt) => rt.name === routeName)
    if (foundKeyIndex > -1) {
      const routeLength = navState.routes.length
      let shouldPopNum = routeLength - foundKeyIndex
      if (!isPopIncludedRouteName) {
        shouldPopNum -= 1
      }
      if (shouldPopNum > 0) {
        navigation.pop(shouldPopNum)
      }
    }
  } catch (err) {
    console.log('Navigation util function::navPopToRouteName err => ', err)
  }
}

export function isEmailValid(emailText: string): boolean {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return re.test(String(emailText))
}

export function isMkpchannelCanReauth(channel: IMKPChannelDetail): boolean {
  const isActive = channel.is_active
  const isAuth = channel.is_auth
  const mkpCd = channel.mkp_id
  const TIME_LEFT = remainingDay(channel.expire_time)
  let isTimeOut = false
  const isTiktok = mkpCd === 3
  // ถ้าเวลาเหลือน้อยกว่า 17 วันและไม่ใช่ Tiktok สามารถ re auth ได้
  // หรือ ถ้าเป็น tiktok และมีวันใช้งานเหลือน้อยกว่า 6 วันก็สามาร re auth ได้
  if ((TIME_LEFT < 17 && !isTiktok) || (isTiktok && TIME_LEFT < 7)) {
    isTimeOut = true
  }
  // console.log('channel => ', channel)
  if (isActive && isAuth && !isTimeOut) {
    return false
  }
  return !isActive || !isAuth || isTimeOut
}

// RETURN ERP CHANNEL SYSTEM Name
export function getErpChannelSystemName(erp_system_id: number): string {
  let erpSystemName = ''
  if (erp_system_id === 1) {
    erpSystemName = 'PEAK'
  }
  return erpSystemName
}

// RETURN ERP CHANNEL Name
export function getErpChannelName(erp_id: number): string {
  const selectedStore = getStoreSelected(p.op.getAppState())
  let channels = selectedStore.get('erp_channels')
  if (!_.isNil(channels)) {
    channels = isImmutable(channels) ? channels.toJS() : channels
    const channel = _.find(channels, (ch: IMKPChannelDetail) => ch.id === erp_id)
    if (!_.isNil(channel)) {
      return channel.name
    }
  }
  return '-'
}

// RETURN paymentAccounts Sort
export function sortPaymentAccounts(paymentAccounts: IPaymentAccount[]): IPaymentAccount[] {
  const pas = [...paymentAccounts]

  // sort by name asc
  pas.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  })

  //  sort by bank_id asc
  pas.sort((a, b) => a.bank_id - b.bank_id)

  // priority verify slip sort
  // https://stackoverflow.com/questions/17387435/javascript-sort-array-of-objects-by-a-boolean-property
  pas.sort((a, b) => {
    if (a.is_for_verify_slip === b.is_for_verify_slip) {
      return 0
    }
    // true values first
    return a.is_for_verify_slip ? -1 : 1
    // false values first
    // return (a === b)? 0 : a? 1 : -1;
  })
  return pas
}

// RETURN ERP CODE LABEL
export function getErpCodeLabel(erpDocs: IOrderErpChannels[]): string {
  // console.log('erpDocs => ', erpDocs)
  if (_.isNil(erpDocs)) {
    return ''
  }
  let label = ''
  erpDocs.forEach((doc, idx) => {
    let cancelLabel = '(ยกเลิก) '
    if (_.isNil(doc.cancelled_at)) {
      cancelLabel = ''
    }
    if (idx === 2) {
      label += `, (+${erpDocs.length - 2})`
    } else if (doc.erp_doc_code === '' || doc.erp_doc_code === null) {
      const docTypeName = CONS.ERP_DOC_TYPE_OPTIONS.find((data) => data.id === doc.erp_doc_type)?.label
      if (idx > 0) {
        label += `, กำลังสร้าง${docTypeName}`
      } else {
        label += `กำลังสร้าง${docTypeName}`
      }
    } else if (idx > 0 && idx < 2) {
      label += `, ${cancelLabel}${doc.erp_doc_code}`
    } else if (idx === 0) {
      label += `${cancelLabel}${doc.erp_doc_code}`
    }
  })
  return label
}

// export function isLegalEntityIndividual(legal_entity_type: number) {
//   const legalEntityTypeNymber = _.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type
//   // console.log('legalEntityTypeNymber  -- => ', legalEntityTypeNymber)
//   return CONS.ADDRESS_LEGAL_ENTITY_TYPE_INDIVIDUAL_MORE_OPTIONS.findIndex((opt) => opt.id === legalEntityTypeNymber) >= 0
// }

// export function isLegalEntityCorporation(legal_entity_type: number) {
//   const legalEntityTypeNymber = _.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type
//   return CONS.ADDRESS_LEGAL_ENTITY_TYPE_CORPORATION_MORE_OPTIONS.findIndex((opt) => opt.id === legalEntityTypeNymber) >= 0
// }

// export function getLegalEntityLabel(legal_entity_type: number) {
//   if (isLegalEntityIndividual(_.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type)) {
//     return CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]
//   }
//   if (isLegalEntityCorporation(_.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type)) {
//     return CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]
//   }
//   return CONS.ADDRESS_LEGAL_ENTITY_LABELS[0]
// }

export function prependHttpsIfNotExists(url: string) {
  if (_.isString(url) && !url.startsWith('https://') && !url.startsWith('http://')) {
    return `https://${url}`
  }
  return url
}

// export function convertNormalAddressToQuickAddress(addr: IAddress | IMap<IAddress>): IQuickAddress {
//   const newAddr: IQuickAddress | any = {
//     id: null,
//     name: '',
//     address1: null,
//     address2: null,
//     address3: '',
//     district: null,
//     sub_district: null,
//     province: null,
//     postal_code: '',
//     telephone: '',
//     legal_entity_id: null,
//     legal_entity_type: 0,
//     branch_type: null,
//     branch_number: null,
//   }

//   if (_.isNil(addr)) {
//     return newAddr
//   }

//   let addrObj: IAddress = addr as IAddress
//   if (isImmutable(addr)) {
//     addrObj = addr.toJS()
//   }

//   newAddr.name = addrObj.name || ''
//   // @ts-ignore
//   newAddr.address3 = addrObj.address3 || ''
//   // @ts-ignore
//   if (addrObj.address1 && (addrObj.address3 === null || addrObj.address3 === '')) {
//     const address1 = addrObj.address1 || null
//     const address2 = addrObj.address2 || null
//     // const sub_district = addrObj.sub_district || null
//     // const district = addrObj.district || null
//     // const province = addrObj.province || null
//     let txtFullAddress = ''
//     txtFullAddress = address1
//     txtFullAddress = address2 ? `${txtFullAddress} ${address2}` : txtFullAddress
//     // txtFullAddress = sub_district ? `${txtFullAddress} ${sub_district}` : txtFullAddress
//     // txtFullAddress = district ? `${txtFullAddress} ${district}` : txtFullAddress
//     // txtFullAddress = province ? `${txtFullAddress} ${province}` : txtFullAddress
//     newAddr.address3 = txtFullAddress
//   }
//   newAddr.sub_district = addrObj.sub_district || ''
//   newAddr.district = addrObj.district || ''
//   newAddr.province = addrObj.province || ''
//   newAddr.postal_code = addrObj.postal_code || ''
//   newAddr.postal_code = newAddr.postal_code.toString()
//   newAddr.telephone = addrObj.telephone || ''
//   newAddr.email = addrObj.email || ''
//   newAddr.legal_entity_type = addrObj.legal_entity_type || 0
//   newAddr.legal_entity_id = addrObj.legal_entity_id || ''
//   newAddr.branch_type = addrObj.branch_type || null
//   newAddr.branch_number = addrObj.branch_number || null

//   return newAddr
// }

// type IConvertAddressToInlineAddressOptions = {
//   replacedName?: string
//   withoutName?: boolean
// }

// export function convertAddressToInlineAddress(
//   inpAddr: IAddress | IQuickAddress | IMap<IAddress> | IMap<IQuickAddress>,
//   options?: IConvertAddressToInlineAddressOptions
// ): string | null {
//   if (_.isNil(inpAddr)) {
//     return null
//   }

//   // const addr: IAddress | IQuickAddress = Map.isMap(inpAddr) ? inpAddr.toJS() : inpAddr
//   const addr: IGenericAddress = Map.isMap(inpAddr) ? inpAddr.toJS() : inpAddr

//   if (_.isEmpty(addr)) {
//     return null
//   }
//   const opts = _.isNil(options) ? {} : options
//   const { replacedName, withoutName } = opts

//   const building_number = 'building_number' in addr && addr.building_number ? addr.building_number : null
//   // @ts-ignore
//   const address1 = addr.address1 || null
//   // @ts-ignore
//   const address3 = addr.address3 || null

//   const address2 = addr.address2 || null
//   const sub_district = addr.sub_district || null
//   const district = addr.district || null
//   const province = addr.province || null
//   const postal_code = addr.postal_code || null
//   const telephone = addr.telephone || null
//   const email = addr.email || null
//   const legal_entity_type = addr.legal_entity_type || 0
//   const legal_entity_id = addr.legal_entity_id || null
//   const branch_type = addr.branch_type || null
//   const branch_number = addr.branch_number || null

//   let txtFullAddress = ''
//   let name = addr.name || null
//   if (!_.isNil(replacedName) && _.isString(replacedName)) {
//     name = replacedName
//   }

//   if (_.isBoolean(withoutName) && withoutName) {
//     name = null
//   }

//   if (_.isString(name) && name.length > 0) {
//     txtFullAddress = `${name}\n`
//   }

//   // if (building_number) {
//   //   txtFullAddress = `${txtFullAddress}${building_number}`
//   // }

//   if (_.isString(address1) && address1.length > 0) {
//     txtFullAddress = address1 ? `${txtFullAddress}${address1}` : txtFullAddress
//   } else if (_.isString(address3) && address3.length > 0) {
//     txtFullAddress = address3 ? `${txtFullAddress}${address3}` : txtFullAddress
//   } else {
//     // console.log('convertAddressToInlineAddress:: Address 1 or 3 not found')
//     return null
//   }

//   txtFullAddress = address2 ? `${txtFullAddress} ${address2}` : txtFullAddress
//   txtFullAddress = sub_district ? `${txtFullAddress} ${sub_district}` : txtFullAddress
//   txtFullAddress = district ? `${txtFullAddress} ${district}` : txtFullAddress
//   txtFullAddress = province ? `${txtFullAddress} ${province}` : txtFullAddress
//   txtFullAddress = postal_code ? `${txtFullAddress}\n${postal_code}` : txtFullAddress
//   txtFullAddress = telephone ? `${txtFullAddress}\nโทร. ${telephone}` : txtFullAddress
//   txtFullAddress = email ? `${txtFullAddress}\nอีเมล ${email}` : txtFullAddress
//   txtFullAddress =
//     legal_entity_type > 0 && legal_entity_id
//       ? `${txtFullAddress}\n${getLegalEntityLabel(legal_entity_type)} ${legal_entity_id}`
//       : txtFullAddress

//   if (branch_type === 'h') {
//     txtFullAddress = `${txtFullAddress}\nสาขา สำนักงานใหญ่`
//   }
//   if (branch_type === 'b' && _.isString(branch_number) && branch_number.length > 0) {
//     txtFullAddress = `${txtFullAddress}\nสาขา ${branch_number}`
//   }

//   return txtFullAddress
// }

// RETURN Display Name
export function getDisplayNameByUid(uid: number): string {
  if (_.isNil(uid)) {
    return ''
  }
  const profile = getProfile()
  const selectedStore = getStoreSelected(p.op.getAppState())
  // console.log('selectedStore /==> ', selectedStore)
  let helpers = selectedStore.get('helpers') || List([])
  helpers = helpers.toJS() || []
  let displayName = '-'
  // @ts-ignore
  if (uid === profile.id) {
    // @ts-ignore
    displayName = profile.display_name
  }
  if (_.isArray(helpers) && helpers.length > 0) {
    helpers.forEach((helper) => {
      if (helper.uid === uid) {
        displayName = helper.n
      }
    })
  }
  return displayName
}

/**
 * Deep merge two or more objects or arrays.
 * (c) Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param   {*} ...objs  The arrays or objects to merge
 * @returns {*}          The merged arrays or objects
 */
export function deepMerge(...objs) {
  /**
   * Get the object type
   * @param  {*}       obj The object
   * @return {String}      The object type
   */
  function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()
  }

  /**
   * Deep merge two objects
   * @return {Object}
   */
  function mergeObj(clone, obj) {
    for (const [key, value] of Object.entries(obj)) {
      const type = getType(value)
      if (clone[key] !== undefined && getType(clone[key]) === type && ['array', 'object'].includes(type)) {
        clone[key] = deepMerge(clone[key], value)
      } else {
        clone[key] = _.cloneDeep(value)
      }
    }
  }

  // Create a clone of the first item in the objs array
  let clone = _.cloneDeep(objs.shift())

  // Loop through each item
  for (const obj of objs) {
    // Get the object type
    const type = getType(obj)

    // If the current item isn't the same type as the clone, replace it
    if (getType(clone) !== type) {
      clone = _.cloneDeep(obj)
      continue
    }

    // Otherwise, merge
    if (type === 'array') {
      clone = [...clone, ..._.cloneDeep(obj)]
    } else if (type === 'object') {
      mergeObj(clone, obj)
    } else {
      clone = obj
    }
  }

  return clone
}

// export function convertInlineAddressToQuickAddress(text: string): IQuickAddress {
//   const quickAddress: IQuickAddress | any = {
//     id: null,
//     address1: null,
//     address2: null,
//     sub_district: null,
//     district: null,
//     province: null,
//     postal_code: null,
//     telephone: null,
//   }

//   if (!text || text.trim().length === 0) {
//     return quickAddress
//   }
//   let txtAddress = _.clone(text)
//   // let quickAddress:QuickAddress = <QuickAddress>{}

//   quickAddress.address3 = ''

//   const regZipcode = /[1-9][0-9]{3}0/g
//   let splitedAddresses = txtAddress.split('\n')

//   if (!splitedAddresses || splitedAddresses.length === 0) {
//     return quickAddress
//   }
//   let zip_code = ''
//   let regInline
//   let regX
//   let breakZipcode = false
//   let cutAline = false
//   let isStart = false
//   let isEnd = false
//   let betweenLineIndex = 0
//   for (let i = 0; i < splitedAddresses.length; i++) {
//     // บรรทัดที่ i
//     // let aLine = splitedAddresses[i].trim()
//     const aLine = splitedAddresses[i]
//     regInline = aLine.match(regZipcode)
//     // log(regInline)
//     if (!_.isNull(regInline)) {
//       // ถ้าบรรทัดที่ i ไม่มีคำที่ต้องการ ก็ไม่ต้องทำอะไรต่อ
//       for (let ii = 0; ii < regInline.length; ii++) {
//         // คำที่เจอในบรรทัดที่ i ลำดับที่ ii
//         if (aLine.length === 5) {
//           // คำที่เจอตรงตามเงื่อนไขพอดี
//           cutAline = true
//           quickAddress.postal_code = aLine
//           txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
//           // txtAddress = txtAddress.replace(quickAddress.postal_code, '')
//           breakZipcode = true
//           break
//         } else {
//           let rawDataZipCode
//           const start = aLine.indexOf(regInline[ii])
//           let end = false
//           const valLineOfEnd = aLine.length - 5
//           if (valLineOfEnd === start) {
//             end = true
//           }
//           if (start === 0) {
//             // คำที่เจอ เจอเป็นคำแรกของบรรทัดที่ i
//             isStart = true
//             regX = /[1-9][0-9]{3}0[^\d]/g
//             rawDataZipCode = aLine.match(regX)
//             if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
//               // ถ้าข้างหลังคำที่เจอไม่ใช่ตัวเลข ให้ดำเนินการต่อไป
//               zip_code = rawDataZipCode[0].substring(0, 5)
//               quickAddress.postal_code = zip_code
//               txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
//               // txtAddress = txtAddress.replace(zip_code, '')
//               breakZipcode = true
//               break
//             }
//           } else if (end) {
//             // ถ้าคำที่เจอ เจอเป็นคำสุดท้ายของบรรทัดที่ i
//             isEnd = true
//             regX = /[^\d][1-9][0-9]{3}0/g
//             rawDataZipCode = aLine.match(regX)
//             if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
//               zip_code = rawDataZipCode[0].substring(1, 6)
//               quickAddress.postal_code = zip_code
//               txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
//               // txtAddress = txtAddress.replace(zip_code, '')
//               breakZipcode = true
//               break
//             }
//           } else {
//             regX = /[^\d][1-9][0-9]{3}0[^\d]/g
//             rawDataZipCode = aLine.match(regX)
//             if (!_.isNil(rawDataZipCode)) {
//               const matchResult = regX.exec(aLine)
//               betweenLineIndex = matchResult.index + 1
//               if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
//                 zip_code = rawDataZipCode[0].substring(1, 6)
//                 quickAddress.postal_code = zip_code
//                 txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
//                 // txtAddress = txtAddress.replace(zip_code, '')
//                 breakZipcode = true
//                 break
//               }
//             }
//           }
//         }
//       }
//     }
//     if (breakZipcode) {
//       break
//     }
//   }
//   // let postal_code = txtAddress.match(regZipcode) || []
//   // // log('BOV4 ' + postal_code)
//   // if (postal_code.length > 0) {
//   //   let postalCode = postal_code[0].trim()
//   //   if (postalCode.length === 6) {
//   //     postalCode = postalCode.substring(1, 6)
//   //   }
//   //   quickAddress['postal_code'] = postalCode
//   //   // quickAddress['postal_code'] = postal_code[0]
//   //   txtAddress = txtAddress.replace(quickAddress.postal_code, '')
//   // }

//   // Must split each line before doing matching as the regPhones won't work properly if there is new line char (\n)
//   // regPhones แบบเก่า /\(?\+?[0-9]*\)?(\-{0,2}\s{0,1}[0-9]){7,}\)?/g,
//   const regPhones = [
//     /\+?[0-9]{3}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4,7}/g,
//     // The above regex is tested against the following samples:
//     // 096 978 4644
//     // 096-978 4644
//     // 096 9784644
//     // (0851247452)
//     // (085 124-7452)
//     // 66848744155
//     // +66848744155

//     /\(?\+?[0-9]{0,2}\)?[0-9_]{0,3}\s{0,1}?\(?\+?[0-9_]*\)?(\-{0,2}[0-9_]){7,}\)?/g, // (+66) 837031118, +662 837031118, (0851247452), (085-124-7452), 085-124-7452, (085)1234567, 085_8974568
//     // /\(?\+?[0-9]{0,2}\)?[0-9]{0,3}\s{0,1}?\(?\+?[0-9]*\)?(\-{0,2}[0-9]){7,}\)?/g, // (+66) 837031118, +662 837031118, (0851247452), (085-124-7452), 085-124-7452, (085)1234567
//     // /\(?\+?[0-9]*\)?(\-{0,2}[\s\S]{0,2}[0-9](?!.*\n)){7,}\)?/g,
//     // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210
//   ]
//   // สำหรับเช็คเลขเรียง 10 ตัว
//   // 0[0-9]{0,2}[0-9]{7}
//   splitedAddresses = txtAddress.split('\n')
//   let telephone
//   let isTelFound = false
//   for (let idx = 0; idx < regPhones.length; idx++) {
//     // loop for each pattern
//     if (isTelFound) {
//       break
//     }
//     // console.log('BOV2 => ', telephone)
//     for (let i = 0; i < splitedAddresses.length; i++) {
//       let aLine = splitedAddresses[i].trim()
//       aLine = replaceOutUnknowString(aLine)

//       telephone = aLine.match(regPhones[idx])
//       // console.log('BOV3 ' + aLine)
//       if (telephone && telephone.length > 0 && telephone[0].length !== 13) {
//         // console.log('telephone Matched found!! => ', telephone)
//         // log(telephone)

//         let tel = telephone[0].trim()

//         // Remove the telephone from the address
//         txtAddress = txtAddress.replace(tel, '')

//         // Then clean up the whole address
//         txtAddress = txtAddress.replace('โทร.', '')
//         txtAddress = txtAddress.replace('โทร:', '')
//         txtAddress = txtAddress.replace('โทร', '')
//         txtAddress = txtAddress.replace('โทร ', '')
//         txtAddress = txtAddress.replace('โทรศัพท์:', '')
//         txtAddress = txtAddress.replace('โทรศัพท์', '')
//         txtAddress = txtAddress.replace('(+66)', '')
//         txtAddress = txtAddress.replace('tel.', '')
//         txtAddress = txtAddress.replace('tel: ', '')
//         // log('txtAddress1: ' + txtAddress)
//         txtAddress = txtAddress.replace('tel ', '')
//         // log('txtAddress2: ' + txtAddress)
//         // Trim space หน้าหลัง
//         txtAddress = txtAddress.trim()

//         // Now clean up the phone number
//         // Remove ( ) - โทร โทรศัพท์ (+66)
//         // Remove start with #
//         // Remove 66 if starts with 660
//         // Test with
//         /*
//           เก่ง
//           142 ถนนกาญาจนา 10160
//           โทร: (+66)087-897-8977ต่อ5555

//           เก่ง
//           142 ถนนกาญาจนา 10160
//           โทร: 66087-897-8977ต่อ5555

//           093-021 4111
//           080 665 6585
//         */
//         tel = tel.replace(/\s/g, '')
//         tel = tel.replace(/[()-]/g, '') // remove all occurances of ( ) -
//         tel = tel.replace('(+66)', '')
//         tel = tel.trim()
//         // assign the telephone number to the quickAddress object
//         quickAddress.telephone = tel

//         // quickAddress.telephone = '0123456789'
//         isTelFound = true
//         break
//       }
//     }
//   }

//   // ensure that it matches 5 to 6 char that the last 5 are digit and it's not part of long number like phone#
//   // const regZipcode = /[0-9][0-9-]{4,}/g // this one will catch the wrong one i.e. 12/209-210 ซ.13

//   // if (isTelFound) {
//   // reset the array as txtAddress has been changed
//   splitedAddresses = replaceOutUnknowString(txtAddress.trim()).split('\n')

//   // Handle the case where the pasted text is just one line by spliting into two items i.e.
//   // ร.ต.อ.หญิงจิราภรณ์ บัวทอง 270 หมู่2 บ้านโพธิ์ไทร ต.โพธิ์ไทร อ.พิบูลมังสาหาร จ.อุบลราชธานี 34190
//   // or
//   // ภาวิณี ศรีวิเศษ รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582
//   // In short, converting ["ภาวิณี ศรีวิเศษ รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582"]
//   // to ["ภาวิณี ศรีวิเศษ", "รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582"]
//   // console.log('splitedAddresses.len check', splitedAddresses)
//   if (splitedAddresses.length === 1) {
//     // one liner
//     // Split the string into an array based on spaces
//     const splitArray = splitedAddresses[0].split(' ')

//     // Combine the first two elements and the rest
//     splitedAddresses = [splitArray.slice(0, 2).join(' '), splitArray.slice(2).join(' ')]
//     // console.log('splitedAddresses', splitedAddresses)
//   }
//   // สับ empty string ทิ้งไป
//   // แก้ไขปัญหา https://effily.atlassian.net/browse/XSELLY-725 (case 1, 2, 3)
//   for (let i = 0; i < splitedAddresses.length; i++) {
//     splitedAddresses[i] = splitedAddresses[i].trim()
//     if (splitedAddresses[i] === '') {
//       splitedAddresses.splice(i, 1)
//     }
//   }
//   // }

//   // Handle / and - in the address
//   //   ปารนีย์ อนันต์เศรษฐศิริ
//   //   12/209-210 ซ.13 ถ.ลพบุรีราเมศวร์ ต.คลองแห อ.หาดใหญ่ จ.สงขลา 90110
//   //   โทร
//   //   0831309933

//   // log('BOV5 ' + splitedAddresses)
//   // console.log('splitedAddresses', splitedAddresses)
//   if (splitedAddresses) {
//     if (splitedAddresses.length === 1 && splitedAddresses[0].trim().length > 0) {
//       // single line (name + address are on the same line)
//       // Get the name assuming that it comes before any digit
//       const regADigit = /\d/g
//       const theLine = splitedAddresses[0].trim()
//       const singleLineSplitedAddr = theLine.match(regADigit)
//       // console.log('singleLineSplitedAddr ', singleLineSplitedAddr)
//       if (singleLineSplitedAddr && singleLineSplitedAddr.length > 0) {
//         // log('singleLineSplitedAddr')
//         // log(singleLineSplitedAddr)
//         const firstDigit = singleLineSplitedAddr[0]
//         const firstDigitPos = theLine.indexOf(firstDigit)
//         quickAddress.name = theLine.substring(0, firstDigitPos).trim()
//         quickAddress.address3 = theLine.substring(firstDigitPos, theLine.length).trim()
//       }
//     } else if (splitedAddresses.length > 1) {
//       const regADigit = /\d/g
//       const theLine = splitedAddresses[0].trim()
//       const singleLineSplitedAddr = theLine.match(regADigit)
//       // console.log('singleLineSplitedAddr ', singleLineSplitedAddr)

//       // console.log('firstDigitPos', firstDigitPos)

//       /*
//       Case ทดสอบ ที่ 1) มี เลขอยู่ข้างหน้า ลูกค้าใช้ในการรันเลขส่วนตัว
//       6.COD200฿แม่นม4ห่อ ศศิวิมล บุญชัย
//       PRESENT CONDOMINIUM EKACHAI 32  ที่55/257 ชั้น3 ตึกB ถ.เอกชัย แขวงบางขุนเทียน เขตจอมทอง กรุงเทพฯ    (k.บลู
//       10150
//       โทร. 0842750758)

//       Case ทดสอบ ที่ 2) แบบ happy path
//       กนกวรรณ เศรษฐพงศ์วนิช
//       1345 ถนนราชดำเนิน เขตดอนเมือง
//       กทม 10180
//       0971627389
//       */
//       if (!_.isNil(singleLineSplitedAddr)) {
//         // const firstDigit = singleLineSplitedAddr[0]
//         // const firstDigitPos = theLine.indexOf(firstDigit)
//         // console.log('the line', theLine)

//         // Set the whole first line as name
//         quickAddress.name = theLine

//         // quickAddress.name = theLine.substring(0, firstDigitPos).trim()
//         // quickAddress.address3 = theLine.substring(firstDigitPos, theLine.length).trim() + ' '
//       } else {
//         quickAddress.name = splitedAddresses[0].trim()
//       }
//       // multiline
//       // Starting from 2nd line compute the address
//       for (let j = 1; j < splitedAddresses.length; j++) {
//         const tmp = splitedAddresses[j].trim()
//         if (tmp && tmp.length > 0) {
//           if (j > 1) {
//             quickAddress.address3 += '\n'
//           }
//           quickAddress.address3 += tmp
//         }
//       }
//     }
//   }

//   // Trim address3
//   if (_.isString(quickAddress.address3) && quickAddress.address3.length > 0) {
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.trim())
//   }

//   // Remove wired bracket
//   if (
//     quickAddress.telephone &&
//     quickAddress.telephone.length > 2 &&
//     _.isString(quickAddress.address3) &&
//     quickAddress.address3.length > 2
//   ) {
//     const lastTwoOfAddress2 = quickAddress.address3.slice(-2)
//     const isContainWiredฺBracket = lastTwoOfAddress2 === '()'
//     if (isContainWiredฺBracket) {
//       quickAddress.address3 = quickAddress.address3.slice(0, -2)
//     }
//   }

//   // if (splitedAddresses && splitedAddresses.length > 1) {
//   //   quickAddress['name'] = splitedAddresses[0].trim()
//   //   for (var j = 1; j < splitedAddresses.length; j++) {
//   //     let tmp = splitedAddresses[j].trim()
//   //     if (j > 1) {
//   //       quickAddress['address3'] += '\n'
//   //     }
//   //     if (tmp && tmp.length > 0) {
//   //       quickAddress['address3'] += tmp
//   //     }
//   //   }
//   // }

//   /**
//    * regex for legal entity id:
//    * ^\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}$
//    * ^\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}$
//    * ^\d{1,}-\d{5}-\d{9,}$
//    * ^\d{1}-\d{5}-\d{6}-\d{3}$
//    * ^\d{13}$
// คุณประเสริฐ ผลิตภัณฑ์การชั่ง
// 456 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ
// เขตสาทร กรุงเทพ 10120 (089-1234756)
// 0-1212-15435-12-3
//   */
//   // console.log('quickAddress before legal check', quickAddress)

//   const regLegalEntityIdArray = [
//     // 0-1212-15435-12-3
//     /\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}/g,
//     // 0-12316-513-513-55
//     /\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}/g,
//     // 0-12316-513513515
//     /\d{1,}-\d{5}-\d{9,}/g,
//     // 0-12316-513513-515
//     /\d{1}-\d{5}-\d{6}-\d{3}/g,
//     // 0121215435123
//     /\d{13}/g,

//     // sample:
//     // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210 0-1212-15435-12-3
//   ]

//   // sample: Legal Entity
//   // บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่)
//   // 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
//   // เลขประจำตัวผู้เสียภาษี
//   // 0105567199669

//   const regLegalEntityIdTenDigitArray = [
//     // 3-0332-9304-3
//     /\d{1}-\d{4}-\d{4}-\d{1}/g,
//     // 3033293043
//     /\d{10}/g,
//   ]

//   const addressToCheckText = quickAddress.address3
//   let legelEntityId: string = null
//   let legelEntityIdFound = false
//   let legalEntityIdMatchTenDigit = false

//   for (let i = 0; i < regLegalEntityIdArray.length; i++) {
//     const regUse = regLegalEntityIdArray[i]
//     const reg = new RegExp(regUse)
//     if (reg.test(addressToCheckText)) {
//       legelEntityIdFound = true
//       const checkedArray = addressToCheckText.match(regUse)
//       // console.log('regLegalEntityId regUse', regUse)
//       // console.log('regLegalEntityId checkedArray', checkedArray)
//       if (checkedArray && checkedArray.length > 0) {
//         // eslint-disable-next-line prefer-destructuring
//         legelEntityId = checkedArray[0]
//         break
//       }
//     }
//   }

//   if (!legelEntityIdFound) {
//     for (let i = 0; i < regLegalEntityIdTenDigitArray.length; i++) {
//       const regUse = regLegalEntityIdTenDigitArray[i]
//       const reg = new RegExp(regUse)
//       if (reg.test(addressToCheckText)) {
//         legelEntityIdFound = true
//         const checkedArray = addressToCheckText.match(regUse)
//         if (checkedArray && checkedArray.length > 0) {
//           // eslint-disable-next-line prefer-destructuring
//           legelEntityId = checkedArray[0]
//           legalEntityIdMatchTenDigit = true
//           break
//         }
//       }
//     }
//   }
//   // console.log('legelEntityIdFound', legelEntityIdFound)
//   // console.log('legelEntityId', legelEntityId)
//   if (legelEntityIdFound && legelEntityId) {
//     quickAddress.legal_entity_id = legelEntityId.replace(/-/g, '')
//     const { name: nm, address3: a3 } = quickAddress
//     if (
//       legalEntityIdMatchTenDigit ||
//       nm.includes('บริษัท') ||
//       nm.includes('บจก') ||
//       nm.includes('ห้างหุ้น') ||
//       nm.includes('จำกัด') ||
//       nm.includes('มหาชน') ||
//       a3.includes('บริษัท') ||
//       a3.includes('บจก') ||
//       a3.includes('ห้างหุ้น') ||
//       a3.includes('จำกัด') ||
//       a3.includes('มหาชน')
//     ) {
//       quickAddress.legal_entity_type = 2
//     } else {
//       quickAddress.legal_entity_type = 1
//     }

//     if (quickAddress?.legal_entity_type === 1) {
//       quickAddress.legal_entity_type_more_id = 11
//     }
//     if (quickAddress?.legal_entity_type === 2) {
//       if (nm.includes('บริษัท') || nm.includes('บจก')) {
//         quickAddress.legal_entity_type_more_id = 11
//       } else if (nm.includes('ห้างหุ้นส่วน') || nm.includes('หจก')) {
//         quickAddress.legal_entity_type_more_id = 13
//       } else if (nm.includes('มหาชน')) {
//         quickAddress.legal_entity_type_more_id = 12
//       } else {
//         quickAddress.legal_entity_type_more_id = 19
//       }
//     }

//     quickAddress.address3 = quickAddress.address3.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]}:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]}:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(`เลขบัตรประชาชน:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(`บัตรประชาชน:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(`เลขผู้เสียภาษี:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(`เลขบัตร:`, '')
//     quickAddress.address3 = quickAddress.address3.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[1], '')
//     quickAddress.address3 = quickAddress.address3.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[2], '')
//     quickAddress.address3 = quickAddress.address3.replace('เลขบัตรประชาชน', '')
//     quickAddress.address3 = quickAddress.address3.replace('บัตรประชาชน', '')
//     quickAddress.address3 = quickAddress.address3.replace('เลขผู้เสียภาษี', '')
//     quickAddress.address3 = quickAddress.address3.replace('เลขบัตร', '')
//     quickAddress.address3 = quickAddress.address3.replace(/\n/g, '')
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(legelEntityId, '').trim())
//   }
//   // console.log('quickAddress after legal check', quickAddress)

//   // console.log('quickAddress before email check', quickAddress)
//   const regEmail = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
//   let email: string = null
//   let emailFound = false

//   if (regEmail.test(addressToCheckText)) {
//     emailFound = true
//     const checkedArray = addressToCheckText.match(regEmail)
//     // console.log('email regEmail', regEmail)
//     // console.log('email checkedArray', checkedArray)
//     if (checkedArray && checkedArray.length > 0) {
//       // eslint-disable-next-line prefer-destructuring
//       email = checkedArray[0]
//     }
//   }

//   if (emailFound && email) {
//     quickAddress.email = email
//     quickAddress.address3 = quickAddress.address3.replace('อีเมลล์:', '')
//     quickAddress.address3 = quickAddress.address3.replace('อีเมล์:', '')
//     quickAddress.address3 = quickAddress.address3.replace('อีเมล:', '')
//     quickAddress.address3 = quickAddress.address3.replace('email:', '')
//     quickAddress.address3 = quickAddress.address3.replace('Email:', '')
//     quickAddress.address3 = quickAddress.address3.replace('EMail:', '')
//     quickAddress.address3 = quickAddress.address3.replace('E-Mail:', '')
//     quickAddress.address3 = quickAddress.address3.replace('E-mail:', '')
//     quickAddress.address3 = quickAddress.address3.replace('e-mail:', '')
//     quickAddress.address3 = quickAddress.address3.replace('อีเมลล์', '')
//     quickAddress.address3 = quickAddress.address3.replace('อีเมล์', '')
//     quickAddress.address3 = quickAddress.address3.replace('อีเมล', '')
//     quickAddress.address3 = quickAddress.address3.replace('email', '')
//     quickAddress.address3 = quickAddress.address3.replace('Email', '')
//     quickAddress.address3 = quickAddress.address3.replace('EMail', '')
//     quickAddress.address3 = quickAddress.address3.replace('E-Mail', '')
//     quickAddress.address3 = quickAddress.address3.replace('E-mail', '')
//     quickAddress.address3 = quickAddress.address3.replace('e-mail', '')
//     quickAddress.address3 = quickAddress.address3.replace(/\n/g, '')
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(email, '').trim())
//   }
//   // console.log('quickAddress after email check', quickAddress)

//   const matchedProvince = CONS.PROVINCES_FOR_ADDRESS_CHECK.find((province) => quickAddress.address3.includes(province))
//   // console.log('matchedProvince1', matchedProvince)
//   if (!_.isNil(matchedProvince) && matchedProvince.length > 0) {
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(matchedProvince, '').trim())
//     quickAddress.address3 = quickAddress.address3.replace('จ.', '').trim()
//     quickAddress.address3 = quickAddress.address3.replace('จังหวัด', '').trim()
//     quickAddress.province = matchedProvince
//   }

//   // const regProvice = /จ\./
//   // console.log('quickAddress.address3', quickAddress.address3)
//   const regProvice = /(?:จ\.|จังหวัด)\S+/
//   const matchProvice = quickAddress.address3.match(regProvice)
//   // console.log('matchProvice', matchProvice)
//   if (matchProvice) {
//     const extractedWord = matchProvice[0]
//     quickAddress.province = extractedWord
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(extractedWord, '').trim())
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace('จ.', '').trim())
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace('จังหวัด', '').trim())
//   }

//   const regDistrict3 = /(?:อ\.|อำเภอ|เขต)\S+/
//   const matchDistrict3 = quickAddress.address3.match(regDistrict3)
//   // console.log('matchDistrict3', matchDistrict3)
//   if (matchDistrict3) {
//     const extractedWord = matchDistrict3[0]
//     quickAddress.district = extractedWord
//     // quickAddress.district = replaceOutUnknowString(quickAddress.district.replace('อ.', '').trim())
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(extractedWord, '').trim())
//   }

//   // const regSubDistrict = /ตำบล\S+/
//   // const matchSubDistrict = quickAddress.address3.match(regSubDistrict)
//   // if (matchSubDistrict) {
//   //   const extractedWord = matchSubDistrict[0]
//   //   quickAddress.sub_district = extractedWord
//   //   quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(extractedWord, '').trim())
//   // }

//   // const regSubDistrict2 = /แขวง\S+/
//   // const matchSubDistrict2 = quickAddress.address3.match(regSubDistrict2)
//   // if (matchSubDistrict2) {
//   //   const extractedWord = matchSubDistrict2[0]
//   //   quickAddress.sub_district = extractedWord
//   //   quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(extractedWord, '').trim())
//   // }

//   // sample:
//   // ปราชญ์
//   // บ้านเลขที่ 95 ซอยเฉลิมพระเกียรติ4 แขวงหนองบอน เขตประเวศ กทม 10250 0895599697
//   // const regSubDistrict3 = /ต.\S+/
//   // const regSubDistrict3 = /ต\.[ก-ฮ]+/
//   // const regSubDistrict3 = /(?:ต\.|ตำบล)[ก-ฮ0-9]+/
//   // const regSubDistrict3 = /(?:ต\.|ตำบล|แขวง)[\u0E01-\u0E4E]+(?: ?[0-9]+)?/
//   const regSubDistrict3 = /(?:ต\.|ตำบล|แขวง)\S+(?: ?[0-9]+)?/

//   const matchSubDistrict3 = quickAddress.address3.match(regSubDistrict3)
//   if (matchSubDistrict3) {
//     const extractedWord = matchSubDistrict3[0]
//     quickAddress.sub_district = extractedWord
//     // quickAddress.sub_district = replaceOutUnknowString(quickAddress.sub_district.replace('ต.', '').trim())
//     quickAddress.address3 = replaceOutUnknowString(quickAddress.address3.replace(extractedWord, '').trim())
//   }

//   // Sample:
//   // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ ตำบลหมากแข้ง อำเภอเมือง จังหวัดอุดรธานี 41000 0-1212-15435-12-3

//   // log('quickAddress')
//   // log(quickAddress)
//   return quickAddress
// }

// export function replaceZipcode(splitedAddresses, lineNumber, cutAline, isStart, isEnd, betweenLineIndex) {
//   const splitedAddressesLength = splitedAddresses.length
//   let newAddress = ''
//   for (let i = 0; i < splitedAddressesLength; i++) {
//     if (lineNumber === i) {
//       if (isStart) {
//         splitedAddresses[i] = splitedAddresses[i].substring(5, splitedAddresses[i].length)
//         newAddress = `${newAddress + splitedAddresses[i]}\n`
//       } else if (isEnd) {
//         splitedAddresses[i] = splitedAddresses[i].substring(0, splitedAddresses[i].length - 5)
//         newAddress = `${newAddress + splitedAddresses[i]}\n`
//       } else if (cutAline) {
//       } else {
//         const lineStart = splitedAddresses[i].substring(0, betweenLineIndex)
//         const lineEnd = splitedAddresses[i].substring(betweenLineIndex + 5, splitedAddresses[i].length)
//         splitedAddresses[i] = `${lineStart} ${lineEnd}`
//         newAddress = `${newAddress + splitedAddresses[i]}\n`
//       }
//     } else if (!_.isEmpty(splitedAddresses[i])) {
//       newAddress = `${newAddress + splitedAddresses[i]}\n`
//     }
//   }
//   return newAddress
// }

/**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 * https://github.com/Rombecchi/version-compare/blob/master/version-compare.js
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * lexicographical: (true/[false]) compares each part of the version strings lexicographically instead of naturally;
 *                  this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than "1.2".
 * zeroExtend: ([true]/false) changes the result if one version string has less parts than the other. In
 *             this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *
 * @returns {number|NaN}
 * - 0 if the versions are equal
 * - a negative integer iff v1 < v2
 * - a positive integer iff v1 > v2
 * - NaN if either version string is in the wrong format
 */
export function versionCompare(v1: string, v2: string, options?: { lexicographical?: boolean; zeroExtend?: boolean }) {
  const lexicographical = (options && options.lexicographical) || false
  const zeroExtend = (options && options.zeroExtend) || true
  let v1parts = (v1 || '0').split('.')
  let v2parts = (v2 || '0').split('.')

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-zαß]*$/ : /^\d+[A-Za-zαß]?$/).test(x)
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0')
    while (v2parts.length < v1parts.length) v2parts.push('0')
  }

  if (!lexicographical) {
    // @ts-ignore
    v1parts = v1parts.map((x) => {
      const match = /[A-Za-zαß]/.exec(x)
      return Number(match ? x.replace(match[0], `.${x.charCodeAt(match.index)}`) : x)
    })
    // @ts-ignore
    v2parts = v2parts.map((x) => {
      const match = /[A-Za-zαß]/.exec(x)
      return Number(match ? x.replace(match[0], `.${x.charCodeAt(match.index)}`) : x)
    })
  }

  for (let i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1
    }

    if (v1parts[i] === v2parts[i]) {
      continue
    } else if (v1parts[i] > v2parts[i]) {
      return 1
    } else {
      return -1
    }
  }

  if (v1parts.length !== v2parts.length) {
    return -1
  }

  return 0
}

export function getStoreWebstieTagName(tagType: string) {
  switch (tagType) {
    case 'sale_page':
      return 'Sale Page'
    case 'catalog_page':
      return 'Catalog Page'
    case 'storefront':
      return 'Store Front'
    default:
      return '-'
  }
}

// export function isIosNoobCheckByPass(): boolean {
//   const sub = getSubscriptionFromRedux()
//   return isXsellier(sub)
//   // const selectedStore = getSelectedStore(p.op.getAppState())
//   // const subscription = getSubscriptionFromRedux()
//   // const productCount = selectedStore.get('product_count')
//   // const count = _.isNil(productCount) ? 0 : productCount
//   // const type = subscription.get('type')
//   // // console.log('type // => ', type)
//   // // console.log('count // => ', count)
//   // return p.op.isIOS() && count <= 5 && type === CONS.SUBSCRIPTION_PACKAGE.FREE
// }

/**
 * Compute String Similarity Score (Jaro Winkler Distance)
 * https://chatgpt.com/share/08359fdc-074a-439e-b0c1-74856f20f653
 * Original version
 */
// export function getJaroWinklerDistance(s1: string, s2: string): number {
//   const m = getMatchingCharacters(s1, s2)
//   if (m.length === 0) return 0.0

//   const t = getTranspositions(s1, s2, m) / 2
//   const jaro = (m.length / s1.length + m.length / s2.length + (m.length - t) / m.length) / 3
//   const l = getPrefixLength(s1, s2, 4)

//   return jaro + l * 0.1 * (1 - jaro)
// }

// function getMatchingCharacters(s1: string, s2: string): string[] {
//   const matchingCharacters = []
//   const matchWindow = Math.max(s1.length, s2.length) / 2 - 1
//   const s2Matches = new Array(s2.length).fill(false)

//   for (let i = 0; i < s1.length; i++) {
//     const start = Math.max(0, i - matchWindow)
//     const end = Math.min(s2.length, i + matchWindow + 1)

//     for (let j = start; j < end; j++) {
//       if (!s2Matches[j] && s1[i] === s2[j]) {
//         matchingCharacters.push(s1[i])
//         s2Matches[j] = true
//         break
//       }
//     }
//   }
//   return matchingCharacters
// }

// function getTranspositions(s1: string, s2: string, m: string[]): number {
//   let transpositions = 0
//   const s2Matches = new Array(s2.length).fill(false)

//   for (let i = 0, k = 0; i < s1.length; i++) {
//     if (s1[i] === m[k]) {
//       while (s2[s2Matches.indexOf(false)] !== m[k]) {
//         s2Matches[s2Matches.indexOf(false)] = true
//       }
//       if (s1[i] !== s2[s2Matches.indexOf(false)]) transpositions++
//       s2Matches[s2Matches.indexOf(false)] = true
//       k++
//     }
//   }
//   return transpositions
// }

// function getPrefixLength(s1: string, s2: string, maxPrefixLength: number): number {
//   let prefixLength = 0
//   for (let i = 0; i < Math.min(maxPrefixLength, s1.length, s2.length); i++) {
//     if (s1[i] === s2[i]) {
//       prefixLength++
//     } else {
//       break
//     }
//   }
//   return prefixLength
// }

/**
 * Compute String Similarity Score (Jaro Winkler Distance)
 * https://chatgpt.com/share/171b766c-f203-4e2f-942c-6880c6ced344
 * Refined version
 */
export function getJaroWinklerDistance(s1: string, s2: string): number {
  const m = getMatchingCharacters(s1, s2)
  if (m.length === 0) return 0.0

  const t = getTranspositions(s1, s2, m) / 2
  const jaro = (m.length / s1.length + m.length / s2.length + (m.length - t) / m.length) / 3
  const l = getPrefixLength(s1, s2, 4)

  return jaro + l * 0.1 * (1 - jaro)
}

function getMatchingCharacters(s1: string, s2: string): string[] {
  const matchingCharacters = []
  const matchWindow = Math.floor(Math.max(s1.length, s2.length) / 2) - 1
  const s2Matches = new Array(s2.length).fill(false)

  for (let i = 0; i < s1.length; i++) {
    const start = Math.max(0, i - matchWindow)
    const end = Math.min(s2.length, i + matchWindow + 1)

    for (let j = start; j < end; j++) {
      if (!s2Matches[j] && s1[i] === s2[j]) {
        matchingCharacters.push(s1[i])
        s2Matches[j] = true
        break
      }
    }
  }
  return matchingCharacters
}

// function getTranspositions(s1: string, s2: string, m: string[]): number {
//   let transpositions = 0
//   const s2Matches = new Array(s2.length).fill(false)

//   for (let i = 0, k = 0; i < s1.length; i++) {
//     if (s1[i] === m[k]) {
//       while (s2[s2Matches.indexOf(false)] !== m[k]) {
//         s2Matches[s2Matches.indexOf(false)] = true
//       }
//       if (s1[i] !== s2[s2Matches.indexOf(false)]) transpositions++
//       s2Matches[s2Matches.indexOf(false)] = true
//       k++
//     }
//   }
//   return transpositions
// }

// function getPrefixLength(s1: string, s2: string, maxPrefixLength: number): number {
//   let prefixLength = 0
//   for (let i = 0; i < Math.min(maxPrefixLength, s1.length, s2.length); i++) {
//     if (s1[i] === s2[i]) {
//       prefixLength++
//     } else {
//       break
//     }
//   }
//   return prefixLength
// }

function getTranspositions(s1: string, s2: string, m: string[]): number {
  let transpositions = 0
  const s1MatchedIndexes: number[] = []
  const s2MatchedIndexes: number[] = []

  const matchWindow = Math.floor(Math.max(s1.length, s2.length) / 2) - 1

  for (let i = 0; i < s1.length; i++) {
    const start = Math.max(0, i - matchWindow)
    const end = Math.min(s2.length, i + matchWindow + 1)

    for (let j = start; j < end; j++) {
      if (s1[i] === s2[j] && !s2MatchedIndexes.includes(j)) {
        s1MatchedIndexes.push(i)
        s2MatchedIndexes.push(j)
        break
      }
    }
  }

  for (let k = 0; k < s1MatchedIndexes.length; k++) {
    if (s1[s1MatchedIndexes[k]] !== s2[s2MatchedIndexes[k]]) {
      transpositions++
    }
  }

  return transpositions
}

function getPrefixLength(s1: string, s2: string, maxPrefixLength: number): number {
  let prefixLength = 0
  for (let i = 0; i < Math.min(maxPrefixLength, s1.length, s2.length); i++) {
    if (s1[i] === s2[i]) {
      prefixLength++
    } else {
      break
    }
  }
  return prefixLength
}

/**
 *
  https://chatgpt.com/share/171b766c-f203-4e2f-942c-6880c6ced344

  The Jaro-Winkler distance and Levenshtein distance both measure the similarity between two strings, but they do so in different ways and are suitable for different types of applications.

  Levenshtein Distance
  Definition: The Levenshtein distance measures the minimum number of single-character edits (insertions, deletions, or substitutions) required to change one string into the other.
  Use Cases: It's useful in applications where any edit is considered equally significant. Examples include spell checking, DNA sequencing, and general text comparison.

  Jaro-Winkler Distance
  Definition: The Jaro-Winkler distance is a metric for measuring the edit distance between two strings. It is particularly effective for short strings and incorporates the notion of common prefixes.
  Use Cases: It is often used in record linkage (also known as data matching) where data entries are typically short and where common typographical errors occur. Examples include name matching and de-duplication in databases.

  Key Differences
  Edit Operations: Levenshtein distance considers insertions, deletions, and substitutions. Jaro-Winkler distance primarily considers transpositions and matching characters.
  Prefix Handling: Jaro-Winkler distance gives more weight to strings that match from the beginning for a set prefix length.
  Sensitivity to Typing Errors: Jaro-Winkler is better suited for detecting small typos in short strings (like names), whereas Levenshtein distance is more general-purpose.

  Example
  For two strings kitten and sitting:

  Levenshtein Distance: It measures the minimum number of operations to transform one string into another. For these strings, the Levenshtein distance is 3.
  Jaro-Winkler Distance: It measures similarity based on matched characters and transpositions, considering common prefixes. The score will be a value between 0 and 1, where higher values indicate greater similarity.

*/

function levenshtein(a: string, b: string): number {
  const an = a.length
  const bn = b.length

  if (an === 0) return bn
  if (bn === 0) return an

  const matrix: number[][] = Array.from({ length: an + 1 }, () => Array(bn + 1).fill(0))

  for (let i = 0; i <= an; i++) matrix[i][0] = i
  for (let j = 0; j <= bn; j++) matrix[0][j] = j

  for (let i = 1; i <= an; i++) {
    for (let j = 1; j <= bn; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1, // deletion
        matrix[i][j - 1] + 1, // insertion
        matrix[i - 1][j - 1] + cost // substitution
      )
    }
  }

  return matrix[an][bn]
}

export function getLevenshteinSimilarity(a: string, b: string): number {
  const distance = levenshtein(a, b)
  const maxLen = Math.max(a.length, b.length)
  return (maxLen - distance) / maxLen
}

export function indexOfMax(arr: number[]): number {
  if (arr.length === 0) {
    return -1
  }

  let max = arr[0]
  let maxIndex = 0

  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      maxIndex = i
      max = arr[i]
    }
  }

  return maxIndex
}

// For Pre-order feature
export function isSkipCheckEmptyProductStock() {
  // return false // requested by พี่เอ๋ on 12 Sep 2024 to turn this off

  const selectedStore = getSelectedStore(p.op.getAppState())
  // const isSkipCheckEmptyProductStock = selectedStore.get('is_skip_check_empty_product_stock')
  const selectedStoreId = selectedStore.get('id')

  // if (_.isBoolean(isSkipCheckEmptyProductStock)) {
  //   return isSkipCheckEmptyProductStock
  // }

  // FIXME: เป็น logic ที่ทำให้ลูกค้าชั่วคราว และวางแผนไว้ว่าจะมี flag ไว้ใน store setting ภายหลัง
  // if (selectedStoreId === 3 || selectedStoreId === 56634) {
  //   return true
  // }
  if (selectedStoreId === 73800 || selectedStoreId === 75931) {
    return true
  }

  return false
}

export function isProfileAddressInUsed() {
  const selectedStore = getSelectedStore(p.op.getAppState())
  // const selectedStoreId = selectedStore.get('id')
  // if (selectedStoreId === 3) {
  //   return true
  // }

  const is_profile_address_in_used = selectedStore.get('is_profile_address_in_used') || false
  return is_profile_address_in_used
}

export function checkMaxQuotaCreateMkpChannelAndErp() {
  const selectedStore = getSelectedStore(p.op.getAppState())
  const subscription = getSubscriptionFromRedux()
  // console.log('subscription => ', subscription.toJS())
  // console.log('selectedStore => ', selectedStore.toJS())
  const mkp_quota = subscription.has('mkp_quota') ? subscription.get('mkp_quota') : 0
  const erp_channels = selectedStore.has('erp_channels') ? selectedStore.get('erp_channels').toJS() : []
  const channels = selectedStore.has('channels') ? selectedStore.get('channels').toJS() : []
  // console.log('erp_channels => ', erp_channels)
  const channelsInUes = erp_channels.length + channels.length
  return channelsInUes >= mkp_quota
}

export function getSubscriptionTypeName(type: number) {
  let name = 'trial'
  if (type === 1) {
    name = 'free'
  }
  if (type === 2) {
    name = 'bronze'
  }
  if (type === 3) {
    name = 'silver'
  }
  if (type === 4) {
    name = 'gold'
  }
  if (type === 5) {
    name = 'platinum'
  }
  return name
}

export function getSubscriptionTypeFullName(type: number) {
  let name = 'Trial'
  if (type === 1) {
    name = 'Free'
  }
  if (type === 2) {
    name = 'Bronze'
  }
  if (type === 3) {
    name = 'Silver'
  }
  if (type === 4) {
    name = 'Gold'
  }
  if (type === 5) {
    name = 'Platinum'
  }
  return name
}

export function getSubscriptionTypeFullNameBySubType(subtype: string) {
  switch (subtype) {
    case 'free':
      return 'free'
    case 'bronze':
      return 'Bronze'
    case 'silver':
      return 'Silver'
    case 'gold':
      return 'Gold'
    case 'platinum':
      return 'Platinum'
    default:
      return ''
  }
}

export function getSubscriptionTypeFullNameBySubTypeForUpgradeMode(subtype: string) {
  if (subtype.match('platinum')) {
    return 'Platinum'
  }
  if (subtype.match('gold')) {
    return 'Gold'
  }
  if (subtype.match('silver')) {
    return 'Silver'
  }
  if (subtype.match('bronze')) {
    return 'Bronze'
  }
  return ''
}

export function getSubscriptionTypeBySku(sku: string) {
  if (sku.match('PLATINUM')) {
    return 5
  }
  if (sku.match('GOLD')) {
    return 4
  }
  if (sku.match('SILVER')) {
    return 3
  }
  if (sku.match('BRONZE')) {
    return 2
  }
  return 1
}

// this function return 'ok' if succeed
// eslint-disable-next-line consistent-return
export async function purchaseIosPackage(packageData: SubscriptionPackageListItems, transactionId: number) {
  const apiOptions = {
    showSpinner: true,
  }
  const body = {
    sku: packageData.sku,
    // @ts-ignore
    transaction_id: transactionId,
  }
  try {
    const res = await api.postV2(api.POST_SUBSCRIPTION_ORDER_CREATE_APPSTORE, body, apiOptions)
    // console.log('_purchase res => ', res)
    if (res.start_billing_date) {
      return 'ok'
    }

    // if (!res || _.isEmpty(res)) {
    // }
  } catch (err) {
    return null
  }
}

export function getSubcriptionEndDate(subscription) {
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  if (!_.has(subscriptionJS, 'next_package_billing_cycle')) {
    // @ts-ignore
    return subscriptionJS.m_e_date
  }

  const { next_package_billing_cycle } = subscriptionJS
  // Step 1: Filter the objects with item_type 'package_main'
  const packageMainItems = next_package_billing_cycle.filter((item) => item.item_type === 'package_main')

  // Step 2: Find the object with the latest end_date
  let latestEndDateItem = subscriptionJS.m_e_date
  if (_.isArray(packageMainItems)) {
    packageMainItems.forEach((item) => {
      if (new Date(latestEndDateItem) < new Date(item.end_date)) {
        latestEndDateItem = item.end_date
      }
    })
  }

  return latestEndDateItem
}

// this function return 'ok' if succeed
// eslint-disable-next-line consistent-return
export async function orderSubcriptionOrderValidate(packageData: SubscriptionPackageListItems) {
  if (_.isNil(packageData)) {
    return null
  }
  const apiOptions = {
    showSpinner: true,
  }
  // purchase_channel_id = Apple IAP
  const body = {
    purchase_channel_id: 2,
    items: [{ sku: packageData.sku }],
  }
  try {
    const res = await api.postV2(api.POST_SUBSCRIPTION_ORDER_VAILIDATE, body, apiOptions)
    // console.log('_purchase res => ', res)
    if (res.is_valid) {
      return 'ok'
    }
  } catch (err) {
    return null
  }
}

export function showBtnBuyPackage() {
  const subscription = getSubscriptionFromRedux()
  const AVAILABLE_TYPES = [1, 999]
  if (!_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
    return false
  }

  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  if (_.has(subscriptionJS, 'next_package_billing_cycle')) {
    return false
  }
  return true
}

export function showBtnPerPackage() {
  const subscription = getSubscriptionFromRedux()
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  const AVAILABLE_TYPES = [2, 3, 4, 5]
  if (_.isNil(subscriptionJS) || !_.includes(AVAILABLE_TYPES, subscriptionJS.type)) {
    return false
  }

  // const end = dayjs(getSubcriptionEndDate(subscription)) // อายุการใช้งานงานวันสุดท้ายของแพ็กเกจ
  // const toDay = dayjs(new Date())
  // const timeLeft = end.clone().diff(toDay.clone(), 'd') // ช่วงเวลาที่เหลือของอายุการใช้งาน ( 0 วันเท่ากับ วันนี้ )
  // // console.log('timeLeft | => ', timeLeft)
  // if (timeLeft > 20) {
  //   return false
  // }

  // if (isDevMode()) {
  //   return true
  // }
  // if (!p.op.isIOS()) {
  //   return false
  // }

  // console.log('subscription => ', _.has(subscriptionJS, 'next_package_billing_cycle'))

  return !_.has(subscriptionJS, 'next_package_billing_cycle')
}

// PerPackageCheck จะตรวจสอบว่าโควตาปัจจุบันมีเท่ากับแพ็กที่เลือกหรือไม่  ถ้าไม่เท่าจะ return false
export function PerPackageCheck(subscriptionPackageList) {
  const subscription = getSubscriptionFromRedux()
  const subscriptionJS = subscription.toJS()
  // console.log('subscriptionPackageList => ', subscriptionPackageList)
  const { type } = subscriptionJS
  if (type === 999) {
    p.op.showConfirmationOkOnly('แพ็กทดลองใช้', 'กรุณาติดต่อทีมงาน')
    return false
  }
  if (_.isNil(subscriptionPackageList)) {
    return false
  }
  const warningPackage = () =>
    p.op.showConfirmationOkOnly(
      '',
      'ไม่สามารถต่อแพ็กเกจผ่านแอปได้เนื่องจากมีแพ็กเสริมอยู่ กรุณาติดต่อทีมงานที่ LINE: @XSelly เพื่อต่อแพ็กเกจ (have_package_upgrade)'
    )
  const itams = _.cloneDeep(subscriptionPackageList.items)
  const PACKAGE_SKU = ['PACKAGE-BRONZE-CYCLE-12', 'PACKAGE-SILVER-CYCLE-12', 'PACKAGE-GOLD-CYCLE-12', 'PACKAGE-PLATINUM-CYCLE-12']
  const sku = PACKAGE_SKU[type - 2]
  // console.log('sku => ', sku)
  // console.log('itams => ', itams)
  let jsonData = null
  itams.forEach((itam) => {
    if (itam.sku === sku) {
      jsonData = itam.data_json
    }
  })
  if (_.isNil(jsonData)) {
    p.op.showConfirmationOkOnly('เกิดข้อผิดพลาด', 'กรุณาติดต่อทีมงาน (subscription package is null)')
    return false
  }

  const isXsellier = _.has(subscriptionJS, 'is_xsellier') ? subscriptionJS.is_xsellier : false
  // console.log('jsonData => ', jsonData)
  // console.log('subscriptionJS => ', subscriptionJS)
  if (p.op.isIOS() && isXsellier === false) {
    const quotas = ['helper_count', 'order_count_quota', 'mkp_quota', 'pg_quota', 'store_count', 'ug_quota', 'vd_quota', 'wh_quota']
    for (const quota of quotas) {
      if (jsonData[quota] !== subscriptionJS[quota]) {
        warningPackage()
        return false
      }
    }
  }

  return true
}

export function checkSubscriptionOrderQuota(subscription: { [key: string]: any }) {
  const { order_count_curr, order_count_quota, is_new_subscription } = subscription
  if (_.isNil(is_new_subscription)) {
    return
  }
  const availableOrder = order_count_quota - order_count_curr
  const availableOrderPercent = Math.round((availableOrder / order_count_quota) * 100)

  let warningMessage = {
    bgColor: COLORS.BRAND_Info,
    message: 'แพ็กเกจของคุณ',
  }

  // ถ้ามีออเดอร์อยู่ ตัดขั้นตอน validation ออกมา แล้ว reset orderTracker
  if (availableOrderPercent > 20) {
    // ถ้า available %order > 20
    warningMessage = null
  } else {
    // ถ้า available %order < 20
    if (availableOrderPercent <= 0) {
      warningMessage = {
        bgColor: COLORS.BRAND_Danger,
        message: 'คุณใช้ออเดอร์เกินจำนวนโควตา สามารถทำการอัพเกรดแพ็กเกจหรือซื้อแพ็กเกจเสริม',
      }
    } else if (availableOrderPercent <= 20) {
      // เหลือ 20 %
      warningMessage = {
        bgColor: COLORS.BRAND_Warning,
        message: 'คุณใช้ออเดอร์เกินจำนวนโควตา สามารถทำการอัพเกรดแพ็กเกจหรือซื้อแพ็กเกจเสริม',
      }
    } else {
      warningMessage = null
    }

    // eslint-disable-next-line consistent-return
    return warningMessage
  }
}

// checkSubscriptionAllQuota จะไม่เช็ก Quota สำหรับ Order (order_count_quota_exceeded_at)
// checkSubscriptionAllQuota จะ return quota ที่ใกล้หมดเวลาที่สุดกลับไปให้
export function checkSubscriptionAllQuota(subscription: { [key: string]: any }, isPackageView = false) {
  const subscriptionJs = isImmutable(subscription) ? subscription.toJS() : subscription
  // @ts-ignore
  const { is_new_subscription } = subscriptionJs
  if (_.isNil(is_new_subscription)) {
    return
  }
  let warningMessage = {
    message: '',
    type: '',
  }

  const QUOTA_LIST = [
    'mkp_quota_exceeded_at',
    'vd_quota_exceeded_at',
    'ug_quota_exceeded_at',
    'pg_quota_exceeded_at',
    'wh_quota_exceeded_at',
    'store_quota_exceeded_at',
    'helper_quota_exceeded_at',
  ]

  // const timeNow = dayjs()
  warningMessage = null
  let warningQuotaListName = ''
  let exceeded_at_moment_coming = null
  QUOTA_LIST.forEach((key, idx) => {
    // if (_.isNil(warningMessage)) {
    if (_.has(subscription, key)) {
      // console.log('KEY => ', subscription[key])
      // const timeLeft = dayjs(subscription[key]).clone().diff(timeNow.clone(), 'h')
      const exceeded_at_moment = dayjs(subscription[key])
      // console.log('exceeded_at_moment => ', exceeded_at_moment)
      const addOneDay = exceeded_at_moment.clone().add(1, 'd').format('YYYY-MM-DD 23:59:59')
      // console.log('KEY => ', key)
      // console.log('addOneDay => ', addOneDay)
      // console.log('exceeded_at_moment_coming => ', dayjs(addOneDay).isBefore(dayjs(exceeded_at_moment_coming)))
      if (_.isNil(exceeded_at_moment_coming) || dayjs(addOneDay).isBefore(dayjs(exceeded_at_moment_coming))) {
        exceeded_at_moment_coming = _.cloneDeep(addOneDay)
      }

      // console.log('addOneDay ! ', addOneDay)

      // @ts-ignore
      const warningName = getWraningNameByKey(key)
      // console.log('warningName => ', warningName)
      if (idx === 0) {
        warningQuotaListName += `**${warningName}**`
      } else if (idx === QUOTA_LIST.length - 1) {
        warningQuotaListName += ` และ **${warningName}**`
      } else {
        warningQuotaListName += `, **${warningName}**`
      }
    }
    // }
  })
  if (!_.isNil(exceeded_at_moment_coming)) {
    const textLabelMode = isPackageView ? 'กรุณา' : 'กดปุ่มดูรายละเอียดเพื่อ'
    const diffTime = dayjs().diff(dayjs(exceeded_at_moment_coming), 'm')
    warningMessage = {
      message: `คุณจะไม่สามารถเปิดออเดอร์ได้อีก หลังจาก ${dayjs(exceeded_at_moment_coming)
        .clone()
        .format(
          'D MMM YYYY 23:59'
        )} เนื่องจากคุณใช้งาน ${warningQuotaListName} เกินโควตา ${textLabelMode} อัพเกรดแพ็กเกจ หรือ ซื้อแพ็กเสริม`,
      type: diffTime >= 0 ? 'danger' : 'warning',
    }
  }

  // console.log('warningMessageQuota => ', warningMessage)

  // eslint-disable-next-line consistent-return
  return warningMessage
}

export function getWraningNameByKey(
  key:
    | 'mkp_quota_exceeded_at'
    | 'vd_quota_exceeded_at'
    | 'ug_quota_exceeded_at'
    | 'pg_quota_exceeded_at'
    | 'wh_quota_exceeded_at'
    | 'store_quota_exceeded_at'
    | 'helper_quota_exceeded_at'
) {
  switch (key) {
    case 'mkp_quota_exceeded_at': {
      return 'การเชื่อมต่อ'
    }
    case 'pg_quota_exceeded_at': {
      return 'รายการราคา'
    }
    case 'ug_quota_exceeded_at': {
      return 'กลุ่มสมาชิก'
    }
    case 'vd_quota_exceeded_at': {
      return 'ส่วนลดขายส่ง'
    }
    case 'wh_quota_exceeded_at': {
      return 'คลัง'
    }
    case 'store_quota_exceeded_at': {
      return 'ร้านค้า'
    }
    case 'helper_quota_exceeded_at': {
      return 'ผู้ช่วย'
    }
    default:
      return {}
  }
}

export function getWraningBgColor(type: 'warning' | 'danger' | 'success') {
  switch (type) {
    case 'warning': {
      return COLORS.BRAND_Warning
    }
    case 'danger': {
      return COLORS.BRAND_Danger
    }
    case 'success': {
      return COLORS.BRAND_Success
    }
    default:
      return COLORS.BRAND_Info
  }
}

export async function checkingMKPChannelExpireTime() {
  const selectedStore = getSelectedStore(p.op.getAppState())
  const selectedStoreJS = isImmutable(selectedStore) ? selectedStore.toJS() : selectedStore
  // console.log('selectedStoreJS => ', selectedStoreJS)
  const { channels } = selectedStoreJS
  if (!_.isArray(channels) || channels.length < 1) {
    return
  }
  // console.log('channels => ', channels)
  // return
  // @ts-ignore
  // const warningReAuthMKP: {
  //   nextWarningTime: string | null
  //   warningText: string
  //   warningBackgroundColor: string
  //   channel: IMKPChannelDetail
  // } | null = await p.op.storageGet(CONS.STORAGE_KEYS.MKP_CHANNEL_RE_AUTH_TRACKER, true)
  // console.log('_checkingMKPChannelExpireTime ** => ', warningReAuthMKP)
  // if (!_.isNil(warningReAuthMKP)) {
  //   if (_.isNil(warningReAuthMKP.nextWarningTime)) {
  //     return
  //   }
  //   // const channel = warningReAuthMKP.channel
  //   // const NEXT_WARNING = moment(warningReAuthMKP.nextWarningTime)
  //   // console.log('TIME_LEFT RETRUE => ', isRemainingTime(NEXT_WARNING))
  //   // const TIME_LEFT = NEXT_WARNING.diff(moment(), 's')
  //   if (isRemainingTime(warningReAuthMKP.nextWarningTime)) {
  //     return
  //   }
  // }
  // return
  let channelExpireTime = null
  for (let i = 0; i < channels.length; i++) {
    if (channels[i].expire_time === '') {
      return
    }
    const EXPIRE_TIME = moment(channels[i].expire_time)
    const TIME_LEFT = EXPIRE_TIME.diff(moment(), 'd')
    if (TIME_LEFT < 16) {
      channelExpireTime = channels[i]
      break
    }
  }
  // console.log('channelExpireTime => ', channelExpireTime)
  if (!_.isNil(channelExpireTime)) {
    // this._setMKPChannelExpireTime(channelExpireTime)
    // util.setMKPChannelExpireTime(channelExpireTime)
    const EXPIRE_TIME = moment(channelExpireTime.expire_time)
    const TIME_LEFT = EXPIRE_TIME.diff(moment(), 'd')
    // console.log('TIME_LEFT => ', TIME_LEFT)
    const mkpName = getMKPName(channelExpireTime.mkp_id)
    const mkpChannelName = getMKPChannelName(channelExpireTime.id)
    let warningBackgroundColor = COLORS.BRAND_Warning
    // let nextWarningTime = moment().format(xCONS.SERVER_DATETIME_FORMAT)
    // let warningText = `อีก ${TIME_LEFT} วัน ช่องทางขาย ${mkpName} ร้าน ${mkpChannelName} การเชื่อมต่อจะหมดอายุแล้ว\nกรุณากด "เชื่อมต่ออีกครั้ง" เพื่อเชื่อมต่อกับช่องทางขาย`
    let warningText = `กรุณากด "ต่ออายุการเชื่อมต่อ ${mkpName}" เนื่องจากการเชื่อมต่อช่องทางขายจะหมดอายุในอีก ${TIME_LEFT} วัน สำหรับร้าน ${mkpChannelName}`
    if (TIME_LEFT < 0) {
      warningBackgroundColor = COLORS.BRAND_Danger
      warningText = `กรุณากด "ต่ออายุการเชื่อมต่อ ${mkpName}" เนื่องจากการเชื่อมต่อช่องทางขายหมดอายุแล้ว สำหรับร้าน ${mkpChannelName}`
      // nextWarningTime = moment().format(xCONS.SERVER_DATETIME_FORMAT)
    } else if (TIME_LEFT === 0) {
      const HR = EXPIRE_TIME.diff(moment(), 'h')
      if (HR > 0) {
        warningText = `กรุณากด "ต่ออายุการเชื่อมต่อ ${mkpName}" เนื่องจากการเชื่อมต่อช่องทางขายจะหมดอายุในอีก ${HR} ชั่วโมง สำหรับร้าน ${mkpChannelName}`
      } else {
        warningBackgroundColor = COLORS.BRAND_Danger
        warningText = `กรุณากด "ต่ออายุการเชื่อมต่อ ${mkpName}" เนื่องจากการเชื่อมต่อช่องทางขายหมดอายุแล้ว สำหรับร้าน ${mkpChannelName}`
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const warningReAuthMKP = {
      channel: channelExpireTime,
      warningBackgroundColor,
      warningText,
      nextWarningTime: null,
    }
    // console.log('warningReAuthMKP END ~~~ ', warningReAuthMKP)
    p.op.storageSet(CONS.STORAGE_KEYS.MKP_CHANNEL_RE_AUTH_TRACKER, warningReAuthMKP, true)
    // this.props.setWarningReAuthMKP(warningReAuthMKP)
    // p.op.getDispatch()

    const reduxDispatch = p.op.getDispatch()
    // Get Product Count
    reduxDispatch(MarketplaceChannelActions.setWarningReAuthMKPState(warningReAuthMKP))

    // setWarningReAuthMKP(warningReAuthMKP)
    // @ts-ignore
    // return warningReAuthMKP
    // yield put(MarketplaceChannelActions.setWarningReAuthMKPState(warningReAuthMKP))
    // if (warningMessage.type) {
    //   // @ts-ignore
    //   yield put(MarketplaceChannelActions.setWarningReAuthMKPState(warningMessage))
    // }
  }
  p.op.storageClear(CONS.STORAGE_KEYS.MKP_CHANNEL_RE_AUTH_TRACKER)
}

export function getPackageWraning(subscription) {
  if (_.isNil(subscription)) {
    return null
  }
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  const { type } = subscriptionJS
  let canPerPackage = showBtnPerPackage()
  if (type === 999) {
    canPerPackage = true
  }
  // console.log('canPerPackage => ', canPerPackage)
  if (!canPerPackage) {
    return null
  }
  const end = dayjs(getSubcriptionEndDate(subscription)) // อายุการใช้งานวันสุดท้ายของแพ็กเกจ
  // console.log('end => ', end)
  const toDay = dayjs(new Date())
  const timeLeft = end.clone().diff(toDay.clone(), 'd') // ช่วงเวลาที่เหลือของอายุการใช้งาน ( 0 วันเท่ากับ วันนี้ )
  // console.log('timeLeft | => ', timeLeft)
  const txtMainPackageName = getSubscriptionTypeFullName(type)
  let message = ''
  let BG_COLOR = COLORS.BRAND_Warning
  if (timeLeft < 0) {
    message = `แพ็กเกจ ${txtMainPackageName} ของคุณหมดอายุแล้ว กรุณาชำระค่าบริการเพื่อต่อแพ็กเกจของคุณ`
    BG_COLOR = COLORS.BRAND_Danger
  }
  if (timeLeft <= 20 && timeLeft > 0) {
    message = `แพ็กเกจ ${txtMainPackageName} ของคุณหมดอีก ${timeLeft} วัน คุณสามารถชำระค่าบริการเพื่อต่อแพ็กเกจของคุณได้เลย`
    BG_COLOR = COLORS.BRAND_Warning
  }

  if (timeLeft === 0) {
    const lastDay = getPackageWraningIfDayIsZero(subscription)
    message = lastDay.ms
    BG_COLOR = lastDay.bg
  }

  if (timeLeft < 0 && timeLeft > -3) {
    const extendedTime = getPackageWraningIfNotMoreThanTwoDays(subscription)
    message = extendedTime.ms
    BG_COLOR = extendedTime.bg
  }

  const subscriptionPackangWaring = {
    bg: BG_COLOR,
    ms: message,
  }
  // eslint-disable-next-line consistent-return
  return subscriptionPackangWaring
}

export function getPackageWraningIfDayIsZero(subscription) {
  if (_.isNil(subscription)) {
    return null
  }
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  const { type } = subscriptionJS
  const end = dayjs(getSubcriptionEndDate(subscription)) // อายุการใช้งานวันสุดท้ายของแพ็กเกจ
  const toDay = dayjs(new Date())
  const timeLeftHour = end.clone().diff(toDay.clone(), 'h') // ช่วงเวลาที่เหลือของอายุการใช้งาน (ชั่วโมง)
  const txtMainPackageName = getSubscriptionTypeFullName(type)
  let message = ''
  let BG_COLOR = COLORS.BRAND_Warning
  if (timeLeftHour <= 24 && timeLeftHour > 0) {
    message = `แพ็กเกจ ${txtMainPackageName} ของคุณหมดภายใน ${timeLeftHour} ชั่วโมง คุณสามารถชำระค่าบริการเพื่อต่อแพ็กเกจของคุณได้เลย`
    BG_COLOR = COLORS.BRAND_Warning
  } else if (timeLeftHour === 0) {
    message = `แพ็กเกจ ${txtMainPackageName} ของคุณจะหมดอายุภายในหนึ่งชั่วโมง คุณสามารถชำระค่าบริการเพื่อต่อแพ็กเกจของคุณได้เลย`
    BG_COLOR = COLORS.BRAND_Warning
  } else {
    message = `แพ็กเกจ ${txtMainPackageName} ของคุณหมดอายุ ${end.fromNow()} คุณสามารถชำระค่าบริการเพื่อต่อแพ็กเกจของคุณได้เลย`
    BG_COLOR = COLORS.BRAND_Danger
  }

  const subscriptionPackangWaring = {
    bg: BG_COLOR,
    ms: message,
  }
  // eslint-disable-next-line consistent-return
  return subscriptionPackangWaring
}

export function getPackageWraningIfNotMoreThanTwoDays(subscription) {
  if (_.isNil(subscription)) {
    return null
  }
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  const { type } = subscriptionJS
  // const toDay = dayjs()
  const txtMainPackageName = getSubscriptionTypeFullName(type)
  let message = ''
  let BG_COLOR = COLORS.BRAND_Warning
  // const addTwoDay = dayjs(getSubcriptionEndDate(subscription)).add(3, 'd') // เพิ่มอายุการใช้งาน 2 วัน ให้ใส่เลข 3 จะได้ช่วงวันที่ถูกต้อง
  // const hours = addTwoDay.clone().diff(toDay.clone(), 'h')
  // const minutes = addTwoDay.clone().diff(toDay.clone(), 'm')
  // const second = addTwoDay.clone().diff(toDay.clone(), 's')
  // let countdown = `${hours} ชั่วโมง`
  // if (hours === 0) {
  //   if (minutes === 0) {
  //     countdown = `${second} วินาที`
  //   } else {
  //     countdown = `${minutes} นาที`
  //   }
  // }
  // if (checkWarning === lastWarning) {
  BG_COLOR = COLORS.BRAND_Danger
  message = `แพ็กเกจ ${txtMainPackageName} ของคุณหมดอายุแล้ว\nคุณจะไม่สามารถเปิดและรับออเดอร์จากตัวแทนได้อีก`

  const subscriptionPackangWaring = {
    bg: BG_COLOR,
    ms: message,
  }
  // eslint-disable-next-line consistent-return
  return subscriptionPackangWaring
}

export function getSubscriptionNextLastBillingCycle(subscription) {
  const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
  if (!_.has(subscriptionJS, 'next_package_billing_cycle')) {
    // @ts-ignore
    return null
  }

  const { next_package_billing_cycle } = subscriptionJS
  // Step 1: Filter the objects with item_type 'package_main'
  const packageMainItems = next_package_billing_cycle.filter((item) => item.item_type === 'package_main')

  // Step 2: Find the object with the latest end_date
  let latestEndDateItem = new Date()
  let lastPackae = null
  if (_.isArray(packageMainItems)) {
    packageMainItems.forEach((item) => {
      if (new Date(latestEndDateItem) < new Date(item.end_date)) {
        latestEndDateItem = item.end_date
        lastPackae = item
      }
    })
  }

  return lastPackae
}

export function getSubscriptionPackageJsonBySku(sku: string, subscriptionPackageList: ISubscriptionPackageList) {
  if (_.isNil(sku) || _.isNil(subscriptionPackageList)) {
    // @ts-ignore
    return null
  }

  const { items } = subscriptionPackageList
  let packageItem = null
  if (_.isArray(items)) {
    items.forEach((item) => {
      if (sku === item.sku) {
        packageItem = item
      }
    })
  }

  return packageItem
}

export function getSubscriptionPackageTypeByPackageName(name: 'free' | 'bronze' | 'silver' | 'gold' | 'platinum') {
  switch (name) {
    case 'free': {
      return 1
    }
    case 'bronze': {
      return 2
    }
    case 'silver': {
      return 3
    }
    case 'gold': {
      return 4
    }
    case 'platinum': {
      return 5
    }
    default:
      return 999
  }
}

export function getSubscriptionPackageTypeByPackageSku(sku: string) {
  let type = 999
  if (sku.includes('FREE')) {
    type = 1
  }
  if (sku.includes('BRONZE')) {
    type = 2
  }
  if (sku.includes('SILVER')) {
    type = 3
  }
  if (sku.includes('GOLD')) {
    type = 4
  }
  if (sku.includes('PLATINUM')) {
    type = 5
  }
  return type
}

export function changePackageUpgradeSkuToNormalSku(sku: string) {
  let normalSku = 'PACKAGE-BRONZE-CYCLE-12'
  if (sku.includes('TO-SILVER')) {
    normalSku = 'PACKAGE-SILVER-CYCLE-12'
  }
  if (sku.includes('TO-GOLD')) {
    normalSku = 'PACKAGE-GOLD-CYCLE-12'
  }
  if (sku.includes('TO-PLATINUM')) {
    normalSku = 'PACKAGE-PLATINUM-CYCLE-12'
  }
  return normalSku
}

export function getPackageAddOnNameBySku(sku: string) {
  let name = '-'
  if (sku.includes('ADDON-QUOTA-UG')) {
    name = 'กลุ่มสมาชิก'
  }
  if (sku.includes('ADDON-QUOTA-PG')) {
    name = 'รายการราคา'
  }
  if (sku.includes('ADDON-QUOTA-STORE')) {
    name = 'ร้านค้า'
  }
  if (sku.includes('ADDON-QUOTA-HELPER')) {
    name = 'ผู้ช่วย'
  }
  if (sku.includes('ADDON-QUOTA-VD')) {
    name = 'ส่วนลดขายส่ง'
  }
  if (sku.includes('ADDON-QUOTA-ORDER')) {
    name = 'ออเดอร์'
  }
  if (sku.includes('ADDON-QUOTA-MKP')) {
    name = 'ช่องทางขาย'
  }
  return name
}

// eslint-disable-next-line react/no-unused-class-component-methods
export function getAddOnDetail(addOn: SubscriptionPackageListItems) {
  const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
  const LOCAL_DATE_FORMAT = 'D MMM YYYY'
  const { sku } = addOn
  const packageName = getPackageAddOnNameBySku(sku)
  // txtMainPackageEnd = endDate.clone().format(LOCAL_DATE_FORMAT)
  const name = `แพ็กเสริม ${packageName}`
  // @ts-ignore
  const startDate = dayjs(addOn.start_date, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
  const endDate = dayjs(addOn.end_date, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
  const dataTime = `${startDate} - ${endDate}`
  let count = '-'
  if (sku.includes('ADDON-QUOTA-UG')) {
    count = `${addOn.data_json.ug_quota * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-PG')) {
    count = `${addOn.data_json.pg_quota * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-STORE')) {
    count = `${addOn.data_json.store_count * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-HELPER')) {
    count = `${addOn.data_json.helper_count * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-VD')) {
    count = `${addOn.data_json.vd_quota * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-ORDER')) {
    count = `${addOn.data_json.order_count_quota * addOn.qty} ${packageName}`
  }
  if (sku.includes('ADDON-QUOTA-MKP')) {
    count = `${addOn.data_json.mkp_quota * addOn.qty} ${packageName}`
  }
  return { title: name, dataTimeText: dataTime, countText: count, active: dayjs(addOn.end_date).isBefore(dayjs()) }
}

export function getUnitNameByDataJsonKey(key: string) {
  switch (key) {
    case 'order_count_quota': {
      return 'ออเดอร์'
    }
    case 'mkp_quota': {
      return 'การเชื่อมต่อ'
    }
    case 'helper_count': {
      return 'ผู้ช่วย'
    }
    case 'pg_quota': {
      return 'รายการราคา'
    }
    case 'store_count': {
      return 'ร้านค้า'
    }
    case 'ug_quota': {
      return 'กลุ่มสมาชิก'
    }
    case 'vd_quota': {
      return 'ส่วนลดขายส่ง'
    }
    case 'wh_quota': {
      return 'คลัง'
    }
    default:
      return '-'
  }
}
export function getStartAndEndBillingCycle(
  subscriptionPackageList: ISubscriptionPackageList,
  billingCycle: number,
  mode: 'upgrade' | 'buy_package' | 'add_on' | 'continue_package' | 'pending'
) {
  const { future_billing_dates, current_billing_dates } = subscriptionPackageList
  let { start } = future_billing_dates[0]
  // console.log('mode // => ', mode)
  if (mode === 'upgrade') {
    start =
      _.isNil(current_billing_dates) || current_billing_dates.length === 0 ? dayjs().format('D MMM YYYY') : current_billing_dates[0].start
  }
  let { end } = future_billing_dates[billingCycle - 1]
  if (mode === 'upgrade') {
    // const currentBillingDatesLenght = current_billing_dates.length
    end = current_billing_dates[billingCycle - 1].end
  }
  return `${dayjs(start, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end, 'YYYY-MM-DD').format('D MMM YYYY')}`
}

export function getAddOnModeStartAndEndBillingCycle(subscriptionPackageList: ISubscriptionPackageList, billingCycle: number) {
  const { future_billing_dates, current_billing_dates } = subscriptionPackageList
  let { start } = future_billing_dates[0]
  // console.log('mode // => ', mode)
  start =
    _.isNil(current_billing_dates) || current_billing_dates.length === 0 ? dayjs().format('D MMM YYYY') : current_billing_dates[0].start

  const subscription = getSubscriptionFromRedux()
  const subscriptionJs = isImmutable(subscription) ? subscription.toJS() : subscription
  const end =
    !_.isNil(current_billing_dates) && current_billing_dates.length > 0
      ? current_billing_dates[billingCycle - 1].end
      : dayjs(subscriptionJs.m_e_date).format('D MMM YYYY')
  // console.log('end => ', end)
  // @ts-ignore
  return `${dayjs(start, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end, 'YYYY-MM-DD').format('D MMM YYYY')}`
}

export function getAddOnListCanBuyFromMainPackageSelectedPackage(
  subscriptionPackageList: ISubscriptionPackageList,
  type: number,
  sku: string
) {
  const { addon_tsku_by_subscription_type, items } = subscriptionPackageList
  // Filter items that start with the given SKU
  const listAddOnOrder = items.filter((item: SubscriptionPackageListItems) => item.sku.startsWith(sku))
  // Get the key from the first item
  const key = listAddOnOrder[0]?.item_subtype

  // Sort addOnList by the specified key in ascending order
  const sortedAddOnList = _.orderBy(listAddOnOrder, [`data_json.${key}`], ['asc'])
  // console.log('type * => ', type)
  let subscriptionTsku = null
  addon_tsku_by_subscription_type.forEach((item) => {
    if (item.type === type) {
      subscriptionTsku = item
    }
  })
  const sortedAddOnListByMainPackage = []
  sortedAddOnList.forEach((item) => {
    if (subscriptionTsku && subscriptionTsku.tskus.includes(item.tsku)) {
      sortedAddOnListByMainPackage.push(item)
    }
  })
  return sortedAddOnListByMainPackage
}

export function appendNotSpecifiedProductCategoryIfNotExist(categorys: ICategory[]) {
  if (_.isNil(categorys) || categorys.length === 0) {
    return []
  }

  const newCategorys = [...categorys]
  const foundNotSpecifiedIndex = newCategorys.findIndex((category) => category.id === 0)

  if (foundNotSpecifiedIndex === -1) {
    const notSpecifiedCategory: ICategory = { id: 0, n: 'ไม่ระบุหมวดหมู่', l: COLORS.TEXT_INACTIVE, p: null, c: [], np: [] }
    newCategorys.push(notSpecifiedCategory)
    return newCategorys
  }
  newCategorys[foundNotSpecifiedIndex] = {
    ...newCategorys[foundNotSpecifiedIndex],
    n: 'ไม่ระบุหมวดหมู่',
    l: COLORS.TEXT_INACTIVE,
    p: null,
    c: [],
    np: [],
  }
  return newCategorys
}

export function getOrderListFilterPreferance(): IOrderListFilterPreference {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const pref = selectedStore.get('pref_ui_order_list_filter')

  if (!pref || !pref.get('createdAt')) {
    return {
      templates: [],
      dashboardItems: [],
      createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
    }
  }

  return Map.isMap(pref) ? pref.toJS() : pref
}

export function getProductListFilterPreferance(): IProductListFilterPreference {
  const selectedStore = getStoreSelected(p.op.getAppState())
  const pref = selectedStore.get('pref_ui_pp_list_filter')

  if (!pref || !pref.get('createdAt')) {
    return {
      templates: [
        {
          id: 'default_01',
          name: 'คงเหลือหมดสต๊อก',
          color: '#b79ec7',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          stockQtyEnabled: true,
          stockQtySelectedOptionKey: 'empty',
          stockQtyValueEqual: '0',
        },
        {
          id: 'default_02',
          name: 'คงเหลือน้อยกว่าหรือเท่ากับ 5',
          color: '#b79ec7',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          stockQtyEnabled: true,
          stockQtySelectedOptionKey: 'almost_empty',
          stockQtyValueLessThanOrEqual: '5',
        },
        {
          id: 'default_03',
          name: 'พร้อมขายน้อยกว่าหรือเท่ากับ 3',
          color: '#b79ec7',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          stockAvailableQtyEnabled: true,
          stockAvailableQtySelectedOptionKey: 'almost_empty',
          stockAvailableQtyValueLessThanOrEqual: '3',
        },
      ],
      dashboardItems: [
        {
          id: 'default_01',
          templateId: 'default_01',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
        },
        {
          id: 'default_01',
          templateId: 'default_02',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
        },
        {
          id: 'default_01',
          templateId: 'default_03',
          createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
          updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
        },
      ],
      createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
    }
  }

  return Map.isMap(pref) ? pref.toJS() : pref
}

export async function fetchSubscriptionPackageList(subscription) {
  const isXsellierx = isXsellier(subscription)
  const apiOptions = {
    // showSpinner: true,
    showSpinner: false,
  }
  let PURCHASABLES_ID = CONS.PURCHASABLES_ID.SCB
  if (p.op.isIOS() && isXsellierx === false) {
    PURCHASABLES_ID = CONS.PURCHASABLES_ID.IOS
  }
  const body = {
    lang: 'th',
    purchase_channel_id: PURCHASABLES_ID,
  }
  try {
    const res = await api.postV2(api.POST_SUBSCRIPTION_PACKAGE_LIST, body, apiOptions)
    // console.log('_fetchSubscriptionPackageList res => ', res)
    return res
  } catch (err) {
    return err
  }
}

export function isXsellier(subscription = null) {
  const subscriptionRedux = _.isNil(subscription) ? getSubscriptionFromRedux() : subscription
  const subscriptionJS = isImmutable(subscriptionRedux) ? subscriptionRedux.toJS() : subscriptionRedux
  if (p.op.isIOS()) {
    return _.has(subscriptionJS, 'is_xsellier') ? subscriptionJS.is_xsellier : false
  }
  return true
}

export function isShippingTypeCod(shippingTypeId: number) {
  if (_.includes(CONS.COD_SHIPPING_TYPE_IDS, shippingTypeId)) {
    return true
  }
  return false
}

export function computeProductBundlesInOrder(order: { [key: string]: any }): { [key: string]: any } {
  console.log('Before computeProductBundlesInOrder => ', order)
  const newOrder = _.cloneDeep(order)

  if (
    newOrder &&
    _.isArray(newOrder.products) &&
    newOrder.products.length > 0 &&
    _.isArray(newOrder.product_bundles) &&
    newOrder.product_bundles.length > 0
  ) {
    for (let i = 0; i < newOrder.products.length; i++) {
      const productBundleId = newOrder.products[i].product_bundle_id
      console.log('find productBundleId => ', productBundleId)
      if (!_.isNil(productBundleId)) {
        for (let j = 0; j < newOrder.product_bundles.length; j++) {
          console.log('Match productBundleId => ', productBundleId)

          if (newOrder.product_bundles[j].product_bundle_id && newOrder.product_bundles[j].product_bundle_id === productBundleId) {
            // Do something with the matching product bundle
            if ('bundle_product_mappings' in newOrder.products[i]) {
              newOrder.products[i].bundle_product_mappings.push(newOrder.product_bundles[j])
            } else {
              newOrder.products[i].bundle_product_mappings = [newOrder.product_bundles[j]]
            }
          }
        }

        if (newOrder.products[i].bundle_product_mappings && newOrder.products[i].bundle_product_mappings.length > 0) {
          newOrder.products[i].bundled_pp_count = newOrder.products[i].bundle_product_mappings.length
          newOrder.products[i].bundled_sum_qty = newOrder.products[i].bundle_product_mappings.reduce(
            (acc, mapping) => acc + (mapping.qty || 0),
            0
          )
        }
      }
    }
  }

  console.log('New computeProductBundlesInOrder => ', newOrder)
  return newOrder
}
